<template>
  <div class="conditionally-approve-wizard clear-to-close-wizard">
    <div v-if="hasMI && wizardStep === 0" class="edit-condition__wrapper">
      <div class="edit-condition__detail-tracking">
        <section class="edit-condition__section-detail" v-if="loanData">
          <h2 class="section--title">File Data</h2>
          <h3 class="section--subtitle first">Loan Information</h3>
          <div class="added__info">
            <label>
              Loan Amount
              <k-input disabled :value="$options.filters.formatCurrency(loanData.loanAmount)" />
            </label>
            <label>
              Interest Rate
              <k-input disabled :value="`${loanData.interestRate} %`" />
            </label>
          </div>

          <div class="added__info">
            <label>
              LTV
              <k-input disabled :value="`${loanData.ltv} %`" />
            </label>
            <label>
              DTI
              <k-input disabled :value="`${loanData.dti} %`" />
            </label>
          </div>

          <h3 class="section--subtitle">Borrower Information</h3>
          <label>
            Credit Score
            <k-input disabled :value="loanData.creditScore" />
          </label>

          <h3 class="section--subtitle">Property Information</h3>
          <div class="added__info">
            <label>
              Loan Purpose
              <k-input disabled :value="loanData.loanPurpose" />
            </label>
            <label>
              Property Type
              <k-input disabled :value="loanData.propertyType" />
            </label>
          </div>
        </section>
      </div>
      <div class="edit-condition__attachments mi">
        <div class="attachments-grid__panel-container mi">
          <k-panelbar :expand-mode="'single'" :items="panelItems" class="attachments-grid__panel">
            <template v-slot:attachmentsgrid>
              <k-grid :data-items="quoteAttachments"
                      :columns="attachmentColumns"
                      :sortable="sortable"
                      :sort="attachmentSort"
                      @sortchange="attachmentSortChangeHandler"
                      @rowclick="getAttachment"></k-grid>
            </template>
          </k-panelbar>
        </div>
        <div class="viewer__container">
          <WebViewer @removeAttchment="RemoveAttachments" :showEditorButton="false" :selectedAttchement="selectedAttachment" :pdfFile="selectedAttachment.url" v-if="!isAttachmentLoading && selectedAttachment.url" />
          <div class="document-attachment__loader-container" v-if="isAttachmentLoading">
            <loader :size="'large'" :type="'pulsing'"></loader>
          </div>
          <div v-if="showPMIQuoteWarning">
            <p class="asset--info"><span class="k-icon k-i-information k-i-info"></span> This file currently has no PMI Quote</p>
          </div>
        </div>
      </div>
    </div>
    <div v-if="hasMI && wizardStep === 1" class="mi-instructions">
      <h2 class="instructions"><span class="k-icon k-i-information k-i-info"></span>Follow the instructions below to order MI from Encompass LO Connect</h2>
      <div class="step-one-two">
        <div class="step one">
          <h4 class="mi-step"><span class="step-number">1</span><span class="step-text">Under the services tab click on MI Center</span></h4>
          <div class="step__img-container">
            <img src="../assets/orderMI_one.jpg" />
          </div>
        </div>
        <div class="step two">
          <h4 class="mi-step"><span class="step-number">2</span><span class="step-text">Select new order and select MI provider</span></h4>
          <div class="step__img-container">
            <img src="../assets/orderMI_two.jpg" />
          </div>
        </div>
      </div>
      <div class="step three">
        <h4 class="mi-step"><span class="step-number">3</span><span class="step-text">Select delegated MI, confirm parameters are accurate (Premium type, Coverage, DTI, etc), click order</span></h4>
        <div class="step__img-container">
          <img src="../assets/orderMI_three.jpg" />
          <img src="../assets/orderMI_four.jpg" />
        </div>
      </div>
      <div class="step four">
        <h4 class="mi-step"><span class="step-number">4</span><span class="step-text">MI is auto-imported</span></h4>
        <div class="step__img-container">
          <img src="../assets/orderMI_five.jpg" />
        </div>
      </div>
    </div>
    <div v-if="(hasMI && wizardStep === 2) || (!hasMI && wizardStep === 0)" class="aus-findings__container edit-condition__wrapper">
      <div v-if="!isLoadingAUS" class="edit-condition__detail-tracking">
        <div>
          <section class="edit-condition__section-detail" v-if="loanData">
            <h2 class="section--title">File Data</h2>
            <h3 class="section--subtitle first">Loan Information</h3>
            <div class="added__info">
              <label>
                Loan Amount
                <k-input disabled :value="$options.filters.formatCurrency(loanData.loanAmount)" />
              </label>
              <label>
                Interest Rate
                <k-input disabled :value="`${loanData.interestRate} %`" />
              </label>
            </div>

            <div class="added__info">
              <label>
                LTV
                <k-input disabled :value="`${loanData.ltv} %`" />
              </label>
              <label>
                DTI
                <k-input disabled :value="`${loanData.dti} %`" />
              </label>
            </div>

            <h3 class="section--subtitle">Borrower Information</h3>
            <label>
              Credit Score
              <k-input disabled :value="loanData.creditScore" />
            </label>

            <h3 class="section--subtitle">Property Information</h3>
            <div class="added__info">
              <label>
                Loan Purpose
                <k-input disabled :value="loanData.loanPurpose" />
              </label>
              <label>
                Property Type
                <k-input disabled :value="loanData.propertyType" />
              </label>
            </div>
          </section>
        </div>
      </div>
      <div class="edit-condition__attachments">
        <h2 class="section--title" v-if="!isLoadingAUS">Supporting Document</h2>
        <div class="viewer__container">
          <WebViewer @removeAttchment="RemoveAttachments"  :showEditorButton="false" :selectedAttchement="selectedAttachment" :pdfFile="selectedAttachment.url" v-if="!isAttachmentLoading && selectedAttachment.url" />
          <div class="document-attachment__loader-container" v-if="isAttachmentLoading">
            <loader :size="'large'" :type="'pulsing'"></loader>
          </div>
          <div v-if="ausFindingsWarning">
            <p class="asset--info"><span class="k-icon k-i-information k-i-info"></span> AUS Findings Unavailable</p>
          </div>
        </div>
      </div>
      <div class="conditions__loader-container" v-if="isLoadingAUS">
        <p class="progress-notification">{{ progressNotification }}</p>
        <k-progressbar class="aus__progressbar" v-if="progressValue < 50" :value="progressValue" :label-visible="false" :min="0" :max="50" :animation="progressAnimation" />
        <loader :size="'large'" :type="'infinite-spinner'" v-if="progressValue === 50"></loader>
      </div>
    </div>

    <div v-if="(hasMI && wizardStep === 3) || (!hasMI && wizardStep === 1)" class="edit-condition__attachments assets">
      <div class="assets-summary">
        <div class="asset-rows__container">
          <h3 class="section--subtitle first">Borrower Funds to Close</h3>
          <div class="assets-summary__row">
            <p class="summary-category">Deposits:</p>
            <p>{{ $options.filters.formatCurrencyDec(applicationVODTotal) }}</p>
          </div>
          <div class="assets-summary__row">
            <p class="summary-category">Gifts/Grants:</p>
            <p>{{ $options.filters.formatCurrencyDec(applicationGiftGrantsTotal) }}</p>
          </div>
          <div class="assets-summary__row">
            <p class="summary-category">Other Assets:</p>
            <p>{{ $options.filters.formatCurrencyDec(applicationOtherAssetsTotal) }}</p>
          </div>
          <hr />
          <div class="assets-summary__row">
            <p class="summary-category">Total:</p>
            <k-numeric-input v-model="borrowerFunds" :format="'c2'" :min="0"/>
          </div>
          <div class="assets-summary__row">
            <div class="summary-category"></div>
            <p class="asset--info"><span class='k-icon k-i-information k-i-info'></span> Total transfers to *CL1007</p>
          </div>
          <div v-if="isFHA" class="emd__container">
            <h3 class="section--subtitle first">Borrower Source of Funds</h3>
            <k-dropdown class="borrower-funds__dropdown" :data-items="borrowerSourceOfFundsSelects" v-model="fhaSummaryFields.find(f => f.id === '34').value"></k-dropdown>
          </div>
          <div class="emd__container">
            <h3 class="section--subtitle first">Monthly Payment</h3>
            <div class="assets-summary__row">
              <p class="summary-category">Total:</p>
              <k-numeric-input v-model="monthlyPaymentTotal" :format="'c2'" :min="0"/>
            </div>
            <div class="assets-summary__row">
              <div class="summary-category"></div>
              <p class="asset--info"><span class='k-icon k-i-information k-i-info'></span> Total transfers to *CL1029</p>
            </div>
          </div>
          <div class="emd__container" v-if="!isRefi">
            <h3 class="section--subtitle first">Earnest Money Deposit</h3>
            <div class="assets-summary__row">
              <p class="summary-category">Total:</p>
              <k-numeric-input v-model="emd" :format="'c2'" :min="0"/>
            </div>
            <div class="assets-summary__row">
              <div class="summary-category"></div>
              <p class="asset--info"><span class='k-icon k-i-information k-i-info'></span> Total transfers to *CL1010</p>
            </div>
          </div>
          <div class="emd__container" v-if="!isRefi">
            <h3 class="section--subtitle first">Seller Contribution</h3>
            <div class="assets-summary__row" v-if="sellerContributionFields.find(field => field.fieldId === '4795')">
              <p class="summary-category">Non-Specific Credit:</p>
              <p>{{ $options.filters.formatCurrencyDec(sellerContributionFields.find(field => field.fieldId === '4795').value) }}</p>
            </div>
            <div class="assets-summary__row" v-if="sellerContributionFields.find(field => field.fieldId === '202')">
              <p class="summary-category">Seller Credit:</p>
              <p>{{ $options.filters.formatCurrencyDec(sellerContributionFields.find(field => field.fieldId === '141').value) }}</p>
            </div>
            <div class="assets-summary__row" v-if="sellerContributionFields.find(field => field.fieldId === '1091')">
              <p class="summary-category">Seller Credit:</p>
              <p>{{ $options.filters.formatCurrencyDec(sellerContributionFields.find(field => field.fieldId === '1095').value) }}</p>
            </div>
            <div class="assets-summary__row" v-if="sellerContributionFields.find(field => field.fieldId === '1106')">
              <p class="summary-category">Seller Credit:</p>
              <p>{{ $options.filters.formatCurrencyDec(sellerContributionFields.find(field => field.fieldId === '1115').value) }}</p>
            </div>
            <div class="assets-summary__row" v-if="sellerContributionFields.find(field => field.fieldId === '1646')">
              <p class="summary-category">Seller Credit:</p>
              <p>{{ $options.filters.formatCurrencyDec(sellerContributionFields.find(field => field.fieldId === '1647').value) }}</p>
            </div>
            <hr />
            <div class="assets-summary__row">
              <p class="summary-category">Total:</p>
              <k-numeric-input v-model="sellerContTotal" :format="'c2'" :min="0"/>
            </div>
            <div class="assets-summary__row">
              <div class="summary-category"></div>
              <p class="asset--info"><span class='k-icon k-i-information k-i-info'></span> Total transfers to *CL1014</p>
            </div>
          </div>
          <div class="emd__container">
            <div class="liabilities-title-btn__container">
              <h3 class="section--subtitle first">Liabilities To Be Paid</h3>
              <k-button><i class="fa-duotone fa-layer-group" title="View Liabilities" @click="toggleLiabilitiesDialog"></i></k-button>
            </div>
            <div class="assets-summary__row" v-for="vol in applicationVOLsToBePaid" v-bind:key="vol.id">
              <p class="summary-category">{{ vol.holderName }}</p>
              <p>{{ $options.filters.formatCurrencyDec(vol.toBePaidOffAmount) }}</p>
            </div>
            <hr />
            <div class="assets-summary__row">
              <p class="summary-category">Total:</p>
              <k-numeric-input v-model="applicationVOLsToBePaidTotal" :format="'c2'" :min="0"/>
            </div>
            <div class="assets-summary__row">
              <div class="summary-category"></div>
              <p class="asset--info"><span class='k-icon k-i-information k-i-info'></span> Total transfers to *CL1032</p>
            </div>
          </div>
          <div v-if="isFHA" class="emd__container">
            <h3 class="section--subtitle first">Assets Miniumum Contribution</h3>
            <div class="assets-summary__row">
              <p class="summary-category">Total:</p>
              <k-numeric-input v-model="assetsMinimumTotal" :format="'c2'" :min="0"/>
            </div>
            <div class="assets-summary__row">
              <div class="summary-category"></div>
              <p class="asset--info"><span class='k-icon k-i-information k-i-info'></span> Total transfers to *CL1001</p>
            </div>
          </div>
        </div>
      </div>
      <div class="assets-detail">
        <div class="assets__container">
          <h2 class="section--title">Verification of Deposits</h2>
          <k-grid :data-items="applicationVODItems"
                  :data-item-key="'itemNumber'"
                  :columns="VODColumns">
          </k-grid>
          <div class="assets-total__container">
            <p><span>Total:</span> {{ $options.filters.formatCurrencyDec(applicationVODTotal) }}</p>
          </div>
        </div>

        <div class="assets__container">
          <h2 class="section--title">Verification of Gifts and Grants</h2>
          <k-grid :data-items="applicationGiftGrants"
                  :data-item-key="'itemNumber'"
                  :columns="giftGrantsColumns">
          </k-grid>
          <div class="assets-total__container">
            <p><span>Total <i>(Less Deposited)</i>:</span> {{ $options.filters.formatCurrencyDec(applicationGiftGrantsTotal) }}</p>
          </div>
        </div>

        <div class="assets__container">
          <h2 class="section--title">Verification of Other Assets</h2>
          <k-grid :data-items="applicationOtherAssets"
                  :data-item-key="'id'"
                  :columns="otherAssetsColumns">
          </k-grid>
          <div class="assets-total__container">
            <p><span>Total <i>(Less Earnest Money)</i>:</span> {{ $options.filters.formatCurrencyDec(applicationOtherAssetsTotal) }}</p>
          </div>
        </div>
      </div>
      <div class="conditions__loader-container" v-if="isLoadingBorrowerFunds">
        <loader :size="'large'" :type="'infinite-spinner'"></loader>
      </div>
    </div>

    <div v-show="(hasMI && wizardStep === 4) || (!hasMI && wizardStep === 2)" class="edit-condition__attachments assets">
      <div class="assets-summary doc-dates">
        <div class="asset-rows__container doc-dates">
          <div class="dates__header">
            <h3 class="section--subtitle first">Document Dates</h3>
            <div class="doc-field__row title-row">
              <p class="doc-field--title"></p>
              <div class="doc-field--date">
                <p>Doc Date</p>
              </div>
              <div class="doc-field--exp">
                <p>Exp Date</p>
              </div>
              <div class="doc-field--na">
                <p>N/A</p>
              </div>
            </div>
          </div>

          <div class="doc-field__row" v-for="field in docDateFields" v-bind:key="field.title">
            <p class="doc-field--title">{{field.title}}</p>
            <div class="doc-field--date">
              <k-datepicker v-if="field.hasDoc" :name="field.fields.find(f => f.type === 'doc').fieldId" @change="onUpdateLoanField($event, 'docDateFields')" v-model="field.fields.find(f => f.type === 'doc').value"></k-datepicker>
            </div>
            <div class="doc-field--exp">
              <k-datepicker disabled v-if="field.hasExp" v-model="field.fields.find(f => f.type === 'exp').value"></k-datepicker>
            </div>
            <div class="doc-field--na">
              <k-checkbox :size="'large'" v-if="field.hasNA" :name="field.fields.find(f => f.type === 'na').fieldId" @change="onUpdateLoanField($event.e, 'docDateFields')" v-model="field.fields.find(f => f.type === 'na').value"></k-checkbox>
            </div>
          </div>
          <br />
          <div class="doc-exp__fields">
            <div class="doc-field__row doc--exp" v-for="field in docExpFields" v-bind:key="field.title">
              <p class="doc-field--title">{{field.title}}</p>
              <div class="doc-field--date">
                <k-datepicker :name="field.fields[0].fieldId" @change="onUpdateLoanField($event, 'docExpFields')" v-model="field.fields[0].value"></k-datepicker>
              </div>
              <div class="doc-field--na">
                <k-checkbox :size="'large'" v-if="field.hasNA" v-model="field.fields.find(f => f.type === 'na').value"></k-checkbox>
              </div>
            </div>
          </div>
          <br />
          <div class="doc-purchase__container">
            <p>{{ docPurchaseFields[0].title }}</p>
            <div class="doc-purchase__row">
              <div class="doc-field--date">
                <k-datepicker :name="docPurchaseFields[0].fields[0].fieldId" @change="onUpdateLoanField($event, 'docPurchaseFields')" v-model="docPurchaseFields[0].fields[0].value"></k-datepicker>
              </div>
              <div class="doc-field--date">
                <k-datepicker :name="docPurchaseFields[0].fields[1].fieldId" @change="onUpdateLoanField($event, 'docPurchaseFields')" v-model="docPurchaseFields[0].fields[1].value"></k-datepicker>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="assets-detail doc-dates" v-show="!showAttachment">
        <h2 class="section--title">Supporting Documents(s)</h2>
        <k-grid ref="docgrid"
                :data-items="attachments"
                :columns="allAttachmentColumns"
                :sortable="sortable"
                :sort="allAttachmentSort"
                :filterable="true"
                :filter="allAttachmentFilter"
                :column-menu="true"
                :selected-field="selectedField"
                @rowclick="getDocAttachment"
                @filterchange="allAttachmentFilterChange"
                @sortchange="allAttachmentSortChangeHandler">
          <toolbar>
            <span class="k-textbox k-grid-search k-display-flex">
              <k-input :style="{ width: '230px' }"
                       placeholder="Search in all columns..."
                       :value="allAttachmentSearchWord"
                       :icon-name="'search'"
                       @input="onFilterAttachments"></k-input>
              <div class="grid__toggle-switch">
                <p :class="['grid__toggle-label', { 'grid__toggle-label--selected': showAllAttachments }]">Show All</p>
                <k-switch v-model="showAllAttachments" :on-label="''" :off-label="''"></k-switch>
              </div>
              <p class="attachments-count">Files: {{ attachments.length }}</p>
            </span>
          </toolbar>
          <template v-slot:versionCell="{props}">
            <td class="attachment__version-cell">
              <span v-if="props.dataItem.isActive" class="k-icon k-i-check-circle active"></span>
              <span v-else class="k-icon k-i-minus not-active"></span>
            </td>
          </template>
        </k-grid>
      </div>
      <div class="assets-detail doc-dates" v-show="showAttachment">
        <div class="viewer__container">
          <k-button class="back-to-att__btn" @click="showAttachment = false"><span class="k-icon k-i-undo"></span> Back to Attachments</k-button>
          <WebViewer @removeAttchment="RemoveAttachments"  :showEditorButton="false" :pdfContainerClass="'attachments-viewer'" :selectedAttchement="selectedAttachment" :pdfFile="selectedAttachment.url" v-if="!isAttachmentLoading && selectedAttachment.url" />
          <div class="document-attachment__loader-container" v-if="isAttachmentLoading">
            <loader :size="'large'" :type="'pulsing'"></loader>
          </div>
        </div>
      </div>
    </div>

    <div v-show="(hasMI && wizardStep === 5) || (!hasMI && wizardStep === 3)" class="edit-condition__attachments assets">
      <div class="assets-summary secondary-execution">
        <div class="asset-rows__container">
          <h3 class="section--subtitle first">Secondary Execution Questions <span class="required">* Required</span></h3>
          <div class="question-columns">
            <div class="question-column">
              <div class="input__row" v-for="field in secondaryExecutionFields" :key="field.id">
                <label class="input-label">
                  <span v-if="field.type === 'yesnodropdown'">*</span> {{ field.label }}
                </label>
                <div class="input" v-if="field.type === 'yesnodropdown'">
                  <k-dropdown :data-items="yesNoDropdownSelects"
                              v-model="field.value"></k-dropdown>
                </div>
                <div class="input" v-if="field.type === 'homereadydropdown'">
                  <k-dropdown :data-items="homeReadyDropdownSelects"
                              v-model="field.value"></k-dropdown>
                </div>
                <div class="input" v-if="field.type === 'numeric'">
                  <k-numeric-input v-model="field.value"></k-numeric-input>
                </div>
                <div class="input" v-if="field.type === 'input'">
                  <k-input v-model="field.value" />
                </div>
                <div class="input" v-if="field.type === 'checkbox'">
                  <k-checkbox :checked="field.value === 'Y'" @change="setCheckboxValue($event, field.id, 'secondaryExecutionFields')"></k-checkbox>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="assets-summary property-appraisal">
        <div class="asset-rows__container">
           <h3 class="section--subtitle first">Property and Appraisal 
            <span class="mgr-review">
              <k-checkbox :checked="propertyAndAppraisalFields.find(f => f.id === 'CX.UW.MGRAPPREVIEW').value === 'Y'" @change="setCheckboxValue($event, 'CX.UW.MGRAPPREVIEW', 'propertyAndAppraisalFields')"></k-checkbox>
              MGR review
              <k-datepicker v-model="propertyAndAppraisalFields.find(f => f.id === 'CX.AUDIT.APPRAISALREVIEW').value"></k-datepicker>
            </span>
            <span class="escrow-holdback">
              <k-button @click="toggleEscrowHoldback">Escrow Holdback</k-button>
            </span>
          </h3>
          <span class="required">* Required</span>
          <div class="property-appraisal__container">
            <div class="input__row">
              <label v-for="field in propertyAndAppraisalFields.filter(field => field.iterate)" :key="field.id">
                {{ field.label }}
                <k-dropdown v-if="field.type === 'dropdown'"
                            :data-items="field.selects"
                            v-model="field.value"></k-dropdown>
                <k-dropdown v-if="field.type === 'yesnodropdown'"
                            :data-items="yesNoDropdownSelects"
                            v-model="field.value"></k-dropdown>
                <k-input v-if="field.type === 'input'" v-model="field.value" />
                <k-numeric-input v-if="field.type === 'numeric'" v-model="field.value"></k-numeric-input>
                <k-datepicker v-if="field.type === 'date'" v-model="field.value"></k-datepicker>
              </label>
              <p class="project-type">Project Type</p>
              <label class="row" v-for="field in propertyAndAppraisalFields.filter(field => field.type === 'nestedcheckbox')" :key="field.id">
                <k-checkbox :checked="field.value === 'Y'" @change="setCheckboxValue($event, field.id, 'propertyAndAppraisalFields')"></k-checkbox>
                {{ field.label }}
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--WIP - VA CTC Wizard -->
    <!--<div v-show="(!hasMI && wizardStep && isVA && wizardStep === 4)"
     class="va-summary__container edit-condition__wrapper">
  <div class="edit-condition__detail-tracking">-->
    <!-- VA Tabstrip -->
    <!--<k-tabstrip :selected="selectedVaTab"
            @select="onVaTabSelected"
            :tabs="vaTabs"
            class="va-tabstrip">-->
    <!-- Loan Summary Tab Content -->
    <!--<template v-slot:vaLoanSummary>
    <section class="edit-condition__section-detail va-loan-summary">
      <h2 class="section--title va">VA Loan Summary</h2>

      <div class="row" v-for="field in vaLoanSummaryFields.filter(f => f.section === 'header')" :key="field.id">
        <label class="full">
          {{ field.label }}
          <k-input v-if="field.type === 'input'" v-model="field.value" :placeholder="field.label" :disabled="field.isDisabled" />
        </label>
      </div>

      <h3 class="section--subtitle">Veteran Information</h3>

      <h3 class="section--subtitle">Borrower</h3>

      <div class="row" v-for="field in vaLoanSummaryFields.filter(f => f.section === 'borrower')" :key="field.id">
        <label class="full">
          {{ field.label }}
          <k-input v-if="field.type === 'input'" v-model="field.value" :placeholder="field.label" :disabled="field.isDisabled" />
          <k-datepicker v-if="field.type === 'date'" v-model="field.value" :placeholder="field.label" :disabled="field.isDisabled" />
        </label>
      </div>

      <h3 class="section--subtitle">Co-Borrower</h3>
      <div class="row" v-for="field in vaLoanSummaryFields.filter(f => f.section === 'coborrower')" :key="field.id">
        <label class="full">
          {{ field.label }}
          <k-input v-if="field.type === 'input'" v-model="field.value" :placeholder="field.label" :disabled="field.isDisabled" />
          <k-datepicker v-if="field.type === 'date'" v-model="field.value" :placeholder="field.label" :disabled="field.isDisabled" />
        </label>
      </div>

      <h3 class="section--subtitle">Entitlement</h3>
      <div class="row" v-for="field in vaLoanSummaryFields.filter(f => f.section === 'entitlement')" :key="field.id">
        <label class="full">
          {{ field.label }}
          <k-input v-if="field.type === 'input'" v-model="field.value" :placeholder="field.label" :disabled="field.isDisabled" />
          <k-numeric-input v-if="field.type === 'numeric'" :format="'c2'" :min="0" v-model="field.value" :disabled="field.isDisabled" />
          <k-dropdown v-if="field.type === 'dropdown'" :data-items="field.options" v-model="field.value" :placeholder="field.label" :disabled="field.isDisabled" />
          <k-datepicker v-if="field.type === 'date'" v-model="field.value" :placeholder="field.label" :disabled="field.isDisabled" />

        </label>
      </div>

      <h3 class="section--subtitle">Loan and Property Information</h3>
      <div class="row" v-for="field in vaLoanSummaryFields.filter(f => f.section === 'loanprop')" :key="field.id">
        <label class="full">
          {{ field.label }}
          <k-input v-if="field.type === 'input'" v-model="field.value" :placeholder="field.label" :disabled="field.isDisabled" />
          <k-numeric-input v-if="field.type === 'numeric'" :format="'c2'" :min="0" v-model="field.value" :disabled="field.isDisabled" />
          <k-dropdown v-if="field.type === 'dropdown'" :data-items="field.options" v-model="field.value" :placeholder="field.label" :disabled="field.isDisabled" />
          <k-datepicker v-if="field.type === 'date'" v-model="field.value" :placeholder="field.label" :disabled="field.isDisabled" />
        </label>
      </div>

      <h3 class="section--subtitle">Energy Improvements</h3>
      <div class="row" v-for="field in vaLoanSummaryFields.filter(f => f.section === 'loanpropcheck')" :key="field.id">
        <label class="full">
          {{ field.label }}
          <k-input v-if="field.type === 'input'" v-model="field.value" :placeholder="field.label" :disabled="field.isDisabled" />
          <k-numeric-input v-if="field.type === 'numeric'" :format="'c2'" :min="0" v-model="field.value" :disabled="field.isDisabled" />
          <k-dropdown v-if="field.type === 'dropdown'" :data-items="field.options" v-model="field.value" :placeholder="field.label" :disabled="field.isDisabled" />
          <k-datepicker v-if="field.type === 'date'" v-model="field.value" :placeholder="field.label" :disabled="field.isDisabled" />
          <k-checkbox v-if="field.type === 'checkbox' && ['376', '379', '377', '380', '378', '381'].includes(field.id)"
                      v-model="field.value"
                      :disabled="field.isDisabled"
                      @change="handleVaEnergyCheckboxChange($event, field)" />
          <k-checkbox v-if="field.type === 'checkbox' && !['376', '379', '377', '380', '378', '381'].includes(field.id)"
                      v-model="field.value"
                      :disabled="field.isDisabled" />
        </label>
      </div>

      <h3 class="section--subtitle">Loan and Property Information (Cont.)</h3>
      <div class="row" v-for="field in vaLoanSummaryFields.filter(f => f.section === 'loanpropcont')" :key="field.id">
        <label class="full">
          {{ field.label }}
          <k-input v-if="field.type === 'input'" v-model="field.value" :placeholder="field.label" :disabled="field.isDisabled" />
          <k-numeric-input v-if="field.type === 'numeric'" :format="'n0'" :min="0" v-model="field.value" :disabled="field.isDisabled" />
          <k-dropdown v-if="field.type === 'dropdown'" :data-items="field.options" v-model="field.value" :placeholder="field.label" :disabled="field.isDisabled" />
          <k-datepicker v-if="field.type === 'date'" v-model="field.value" :placeholder="field.label" :disabled="field.isDisabled" />
        </label>
      </div>

      <h3 class="section--subtitle">For LAPP Cases Only</h3>
      <div class="row" v-for="field in vaLoanSummaryFields.filter(f => f.section === 'lapp')" :key="field.id">
        <label class="full">
          {{ field.label }}
          <k-input v-if="field.type === 'input'" v-model="field.value" :placeholder="field.label" :disabled="field.isDisabled" />
          <k-numeric-input v-if="field.type === 'numeric'" :format="'n0'" :min="0" v-model="field.value" :disabled="field.isDisabled" />
          <k-dropdown v-if="field.type === 'dropdown'" :data-items="field.options" v-model="field.value" :placeholder="field.label" :disabled="field.isDisabled" />
          <k-datepicker v-if="field.type === 'date'" v-model="field.value" :placeholder="field.label" :disabled="field.isDisabled" />
        </label>
      </div>

      <h3 class="section--subtitle">Income Information</h3>
      <div class="row" v-for="field in vaLoanSummaryFields.filter(f => f.section === 'income')" :key="field.id">
        <label class="full">
          {{ field.label }}
          <k-input v-if="field.type === 'input'" v-model="field.value" :placeholder="field.label" :disabled="field.isDisabled" />
          <k-numeric-input v-if="field.type === 'numeric'" :format="'c2'" :min="0" v-model="field.value" :disabled="field.isDisabled" />
          <k-dropdown v-if="field.type === 'dropdown'" :data-items="field.options" v-model="field.value" :placeholder="field.label" :disabled="field.isDisabled" />
          <k-datepicker v-if="field.type === 'date'" v-model="field.value" :placeholder="field.label" :disabled="field.isDisabled" />
        </label>
      </div>

      <h3 class="section--subtitle">Discount Information</h3>
      <div class="row" v-for="field in vaLoanSummaryFields.filter(f => f.section === 'discount')" :key="field.id">
        <label class="full">
          {{ field.label }}
          <k-input v-if="field.type === 'input'" v-model="field.value" :placeholder="field.label" :disabled="field.isDisabled" />
          <k-numeric-input v-if="field.type === 'numeric'" :format="'n3'" :min="0" v-model="field.value" :disabled="field.isDisabled" />
          <k-dropdown v-if="field.type === 'dropdown'" :data-items="field.options" v-model="field.value" :placeholder="field.label" :disabled="field.isDisabled" />
          <k-datepicker v-if="field.type === 'date'" v-model="field.value" :placeholder="field.label" :disabled="field.isDisabled" />
        </label>
      </div>

      <h3 class="section--subtitle">For IRRRLs Only</h3>
      <div class="row" v-for="field in vaLoanSummaryFields.filter(f => f.section === 'IRRRL')" :key="field.id">
        <label class="full">
          {{ field.label }}
          <k-input v-if="field.type === 'input'" v-model="field.value" :placeholder="field.label" :disabled="field.isDisabled" />
          <k-numeric-input v-if="field.type === 'numeric'" :format="'c2'" :min="0" v-model="field.value" :disabled="field.isDisabled" />
          <k-dropdown v-if="field.type === 'dropdown'" :data-items="field.options" v-model="field.value" :placeholder="field.label" :disabled="field.isDisabled" />
          <k-datepicker v-if="field.type === 'date'" v-model="field.value" :placeholder="field.label" :disabled="field.isDisabled" />
        </label>
      </div>

      <h3 class="section--subtitle">Remarks</h3>
      <div class="row" v-for="field in vaLoanSummaryFields.filter(f => f.section === 'remarks')" :key="field.id">
        <label class="full">
          {{ field.label }}
          <k-input v-if="field.type === 'input'" v-model="field.value" :placeholder="field.label" :disabled="field.isDisabled" />
          <k-numeric-input v-if="field.type === 'numeric'" :format="'c2'" :min="0" v-model="field.value" :disabled="field.isDisabled" />
          <k-dropdown v-if="field.type === 'dropdown'" :data-items="field.options" v-model="field.value" :placeholder="field.label" :disabled="field.isDisabled" />
          <k-datepicker v-if="field.type === 'date'" v-model="field.value" :placeholder="field.label" :disabled="field.isDisabled" />
        </label>
      </div>

    </section>
  </template>-->
    <!-- Reasonable Value Tab Content -->
    <!--<template v-slot:vaReasonableValue>
    <section class="edit-condition__section-detail va-reasonable-value">
      <h2 class="section--title va">VA Reasonable Value</h2>

      <h3 class="section--subtitle">Section 1: Property Address and Description</h3>
      <div class="row" v-for="field in vaRasonableValueFields.filter(f => f.section === 'reasonablevaluesection1')" :key="field.id">
        <label class="full">
          {{ field.label }}
          <k-input v-if="field.type === 'input'" v-model="field.value" :placeholder="field.label" :disabled="field.isDisabled" />
          <k-numeric-input v-if="field.type === 'numeric'" :format="'c2'" :min="0" v-model="field.value" :disabled="field.isDisabled" />
          <k-dropdown v-if="field.type === 'dropdown'" :data-items="field.options" v-model="field.value" :placeholder="field.label" :disabled="field.isDisabled" />
          <k-datepicker v-if="field.type === 'date'" v-model="field.value" :placeholder="field.label" :disabled="field.isDisabled" />
        </label>
      </div>

      <h3 class="section--subtitle">Section 2: Loan Type And Information</h3>
      <div class="row" v-for="field in vaRasonableValueFields.filter(f => f.section === 'reasonablevaluesection2')" :key="field.id">
        <label class="full">
          {{ field.label }}
          <k-input v-if="field.type === 'input'" v-model="field.value" :placeholder="field.label" :disabled="field.isDisabled" />
          <k-numeric-input v-if="field.type === 'numeric'" :format="'c2'" :min="0" v-model="field.value" :disabled="field.isDisabled" />
          <k-dropdown v-if="field.type === 'dropdown'" :data-items="field.options" v-model="field.value" :placeholder="field.label" :disabled="field.isDisabled" />
          <k-datepicker v-if="field.type === 'date'" v-model="field.value" :placeholder="field.label" :disabled="field.isDisabled" />
        </label>
      </div>

      <h3 class="section--subtitle">New Or Proposed Construction</h3>
      <div class="row" v-for="field in vaRasonableValueFields.filter(f => f.section === 'reasonablevaluesection2newprop')" :key="field.id">
        <label class="full">
          {{ field.label }}
          <k-input v-if="field.type === 'input'" v-model="field.value" :placeholder="field.label" :disabled="field.isDisabled" />
          <k-numeric-input v-if="field.type === 'numeric'" :format="'n0'" :min="0" v-model="field.value" :disabled="field.isDisabled" />
          <k-dropdown v-if="field.type === 'dropdown'" :data-items="field.options" v-model="field.value" :placeholder="field.label" :disabled="field.isDisabled" />
          <k-datepicker v-if="field.type === 'date'" v-model="field.value" :placeholder="field.label" :disabled="field.isDisabled" />
          <k-maskedtextbox v-if="field.type === 'phone'" v-model="field.value" :mask="'000-000-0000'" :rules="{ '0': /\d/ }" :placeholder="field.label" :disabled="field.isDisabled" />
        </label>
      </div>

      <h3 class="section--subtitle">Section 3: Special Instructions</h3>
      <div class="row" v-for="field in vaRasonableValueFields.filter(f => f.section === 'reasonablevaluesection3specialinstructions')" :key="field.id">
        <label class="full">
          {{ field.label }}
          <k-input v-if="field.type === 'input'" v-model="field.value" :placeholder="field.label" :disabled="field.isDisabled" />
          <k-numeric-input v-if="field.type === 'numeric'" :format="'n0'" :min="0" v-model="field.value" :disabled="field.isDisabled" />
          <k-dropdown v-if="field.type === 'dropdown'" :data-items="field.options" v-model="field.value" :placeholder="field.label" :disabled="field.isDisabled" />
          <k-datepicker v-if="field.type === 'date'" v-model="field.value" :placeholder="field.label" :disabled="field.isDisabled" />
          <k-maskedtextbox v-if="field.type === 'phone'" v-model="field.value" :mask="'000-000-0000'" :rules="{ '0': /\d/ }" :placeholder="field.label" :disabled="field.isDisabled" />
          <k-checkbox v-if="field.type === 'checkbox'" v-model="field.value" :disabled="field.isDisabled" />
        </label>
      </div>

      <h3 class="section--subtitle">Section 3: Other Instructions</h3>
      <div class="row" v-for="field in vaRasonableValueFields.filter(f => f.section === 'reasonablevaluesection3')" :key="field.id">
        <label class="full">
          {{ field.label }}
          <k-input v-if="field.type === 'input'" v-model="field.value" :placeholder="field.label" :disabled="field.isDisabled" />
          <k-numeric-input v-if="field.type === 'numeric'" :format="'n0'" :min="0" v-model="field.value" :disabled="field.isDisabled" />
          <k-dropdown v-if="field.type === 'dropdown'" :data-items="field.options" v-model="field.value" :placeholder="field.label" :disabled="field.isDisabled" />
          <k-datepicker v-if="field.type === 'date'" v-model="field.value" :placeholder="field.label" :disabled="field.isDisabled" />
          <k-maskedtextbox v-if="field.type === 'phone'" v-model="field.value" :mask="'000-000-0000'" :rules="{ '0': /\d/ }" :placeholder="field.label" :disabled="field.isDisabled" />
          <k-checkbox v-if="field.type === 'checkbox'" v-model="field.value" :disabled="field.isDisabled" />
          <k-textarea v-if="field.type === 'textarea'" v-model="field.value" :rows="4" :placeholder="field.label" :disabled="field.isDisabled" />
        </label>
      </div>

      <h3 class="section--subtitle">Section 4: Point of Contact Information</h3>
      <div class="row" v-for="field in vaRasonableValueFields.filter(f => f.section === 'reasonablevaluesection4')" :key="field.id">
        <label class="full">
          {{ field.label }}
          <k-input v-if="field.type === 'input'" v-model="field.value" :placeholder="field.label" :disabled="field.isDisabled" />
          <k-numeric-input v-if="field.type === 'numeric'" :format="'n0'" :min="0" v-model="field.value" :disabled="field.isDisabled" />
          <k-dropdown v-if="field.type === 'dropdown'" :data-items="field.options" v-model="field.value" :placeholder="field.label" :disabled="field.isDisabled" />
          <k-datepicker v-if="field.type === 'date'" v-model="field.value" :placeholder="field.label" :disabled="field.isDisabled" />
          <k-maskedtextbox v-if="field.type === 'phone'" v-model="field.value" :mask="'000-000-0000'" :rules="{ '0': /\d/ }" :placeholder="field.label" :disabled="field.isDisabled" />
          <k-checkbox v-if="field.type === 'checkbox'" v-model="field.value" :disabled="field.isDisabled" />
          <k-textarea v-if="field.type === 'textarea'" v-model="field.value" :rows="4" :placeholder="field.label" :disabled="field.isDisabled" />
          <k-input v-if="field.type === 'email'" type="email" v-model="field.value" :placeholder="field.label" :disabled="field.isDisabled" />
        </label>
      </div>

      <h3 class="section--subtitle">Section 5: Requester Information</h3>
      <div class="row" v-for="field in vaRasonableValueFields.filter(f => f.section === 'reasonablevaluesection5')" :key="field.id">
        <label class="full">
          {{ field.label }}
          <k-input v-if="field.type === 'input'" v-model="field.value" :placeholder="field.label" :disabled="field.isDisabled" />
          <k-numeric-input v-if="field.type === 'numeric'" :format="'n0'" :min="0" v-model="field.value" :disabled="field.isDisabled" />
          <k-dropdown v-if="field.type === 'dropdown'" :data-items="field.options" v-model="field.value" :placeholder="field.label" :disabled="field.isDisabled" />
          <k-datepicker v-if="field.type === 'date'" v-model="field.value" :placeholder="field.label" :disabled="field.isDisabled" />
          <k-maskedtextbox v-if="field.type === 'phone'" v-model="field.value" :mask="'000-000-0000'" :rules="{ '0': /\d/ }" :placeholder="field.label" :disabled="field.isDisabled" />
          <k-checkbox v-if="field.type === 'checkbox'" v-model="field.value" :disabled="field.isDisabled" />
          <k-textarea v-if="field.type === 'textarea'" v-model="field.value" :rows="4" :placeholder="field.label" :disabled="field.isDisabled" />
          <k-input v-if="field.type === 'email'" type="email" v-model="field.value" :placeholder="field.label" :disabled="field.isDisabled" />
        </label>
      </div>

      <h3 class="section--subtitle">Section 6: Veteran/Borrower Information</h3>
      <div class="row" v-for="field in vaRasonableValueFields.filter(f => f.section === 'reasonablevaluesection6')" :key="field.id">
        <label class="full">
          {{ field.label }}
          <k-input v-if="field.type === 'input'" v-model="field.value" :placeholder="field.label" :disabled="field.isDisabled" />
          <k-numeric-input v-if="field.type === 'numeric'" :format="'n0'" :min="0" v-model="field.value" :disabled="field.isDisabled" />
          <k-dropdown v-if="field.type === 'dropdown'" :data-items="field.options" v-model="field.value" :placeholder="field.label" :disabled="field.isDisabled" />
          <k-datepicker v-if="field.type === 'date'" v-model="field.value" :placeholder="field.label" :disabled="field.isDisabled" />
          <k-maskedtextbox v-if="field.type === 'phone'" v-model="field.value" :mask="'000-000-0000'" :rules="{ '0': /\d/ }" :placeholder="field.label" :disabled="field.isDisabled" />
          <k-checkbox v-if="field.type === 'checkbox'" v-model="field.value" :disabled="field.isDisabled" />
          <k-textarea v-if="field.type === 'textarea'" v-model="field.value" :rows="4" :placeholder="field.label" :disabled="field.isDisabled" />
          <k-input v-if="field.type === 'email'" type="email" v-model="field.value" :placeholder="field.label" :disabled="field.isDisabled" />
        </label>
      </div>

      <h3 class="section--subtitle">Section 7: Certification For Submission To VA</h3>
      <div class="row" v-for="field in vaRasonableValueFields.filter(f => f.section === 'reasonablevaluesection7')" :key="field.id">
        <label class="full">
          {{ field.label }}
          <k-input v-if="field.type === 'input'" v-model="field.value" :placeholder="field.label" :disabled="field.isDisabled" />
          <k-numeric-input v-if="field.type === 'numeric'" :format="'n0'" :min="0" v-model="field.value" :disabled="field.isDisabled" />
          <k-dropdown v-if="field.type === 'dropdown'" :data-items="field.options" v-model="field.value" :placeholder="field.label" :disabled="field.isDisabled" />
          <k-datepicker v-if="field.type === 'date'" v-model="field.value" :placeholder="field.label" :disabled="field.isDisabled" />
          <k-maskedtextbox v-if="field.type === 'phone'" v-model="field.value" :mask="'000-000-0000'" :rules="{ '0': /\d/ }" :placeholder="field.label" :disabled="field.isDisabled" />
          <k-checkbox v-if="field.type === 'checkbox'" v-model="field.value" :disabled="field.isDisabled" />
          <k-textarea v-if="field.type === 'textarea'" v-model="field.value" :rows="4" :placeholder="field.label" :disabled="field.isDisabled" />
          <k-input v-if="field.type === 'email'" type="email" v-model="field.value" :placeholder="field.label" :disabled="field.isDisabled" />
        </label>
      </div>

    </section>
  </template>-->
    <!-- Disbursement Tab Content -->
    <!--<template v-slot:vaDisbursement>
    <section class="edit-condition__section-detail va-disbursement">
      <h2 class="section--title va">Loan Report and Certification of Disbursement</h2>

      <div class="row" v-for="field in vaDisbursementFields.filter(f => f.section === 'disbursement')" :key="field.id">
        <label class="full">
          {{ field.label }}
          <k-input v-if="field.type === 'input'" v-model="field.value" :placeholder="field.label" :disabled="field.isDisabled" />
          <k-numeric-input v-if="field.type === 'numeric'" :format="'n0'" :min="0" v-model="field.value" :disabled="field.isDisabled" />
          <k-dropdown v-if="field.type === 'dropdown'" :data-items="field.options" v-model="field.value" :placeholder="field.label" :disabled="field.isDisabled" />
          <k-datepicker v-if="field.type === 'date'" v-model="field.value" :placeholder="field.label" :disabled="field.isDisabled" />
          <k-maskedtextbox v-if="field.type === 'phone'" v-model="field.value" :mask="'000-000-0000'" :rules="{ '0': /\d/ }" :placeholder="field.label" :disabled="field.isDisabled" />
          <k-checkbox v-if="field.type === 'checkbox'" v-model="field.value" :disabled="field.isDisabled" />
          <k-textarea v-if="field.type === 'textarea'" v-model="field.value" :rows="4" :placeholder="field.label" :disabled="field.isDisabled" />
          <k-input v-if="field.type === 'email'" type="email" v-model="field.value" :placeholder="field.label" :disabled="field.isDisabled" />
        </label>
      </div>

      <h3 class="section--subtitle">Section 1 - Purpose/Amount/Terms/Security</h3>
      <div class="row" v-for="field in vaDisbursementFields.filter(f => f.section === 'disbursementsection1')" :key="field.id">
        <label class="full">
          {{ field.label }}
          <k-input v-if="field.type === 'input'" v-model="field.value" :placeholder="field.label" :disabled="field.isDisabled" />
          <k-numeric-input v-if="field.type === 'numeric'" :format="'n0'" :min="0" v-model="field.value" :disabled="field.isDisabled" />
          <k-dropdown v-if="field.type === 'dropdown'" :data-items="field.options" v-model="field.value" :placeholder="field.label" :disabled="field.isDisabled" />
          <k-datepicker v-if="field.type === 'date'" v-model="field.value" :placeholder="field.label" :disabled="field.isDisabled" />
          <k-maskedtextbox v-if="field.type === 'phone'" v-model="field.value" :mask="'000-000-0000'" :rules="{ '0': /\d/ }" :placeholder="field.label" :disabled="field.isDisabled" />
          <k-checkbox v-if="field.type === 'checkbox'" v-model="field.value" :disabled="field.isDisabled" />
          <k-textarea v-if="field.type === 'textarea'" v-model="field.value" :rows="4" :placeholder="field.label" :disabled="field.isDisabled" />
          <k-input v-if="field.type === 'email'" type="email" v-model="field.value" :placeholder="field.label" :disabled="field.isDisabled" />
        </label>
      </div>

      <h3 class="section--subtitle">Terms of Loan</h3>
      <div class="row" v-for="field in vaDisbursementFields.filter(f => f.section === 'disbursementsection1terms')" :key="field.id">
        <label class="full">
          {{ field.label }}
          <k-input v-if="field.type === 'input'" v-model="field.value" :placeholder="field.label" :disabled="field.isDisabled" />
          <k-numeric-input v-if="field.type === 'numeric'" :format="'n0'" :min="0" v-model="field.value" :disabled="field.isDisabled" />
          <k-numeric-input v-if="field.type === 'numeric-currency'" :format="'c2'" :min="0" v-model="field.value" :disabled="field.isDisabled" />
          <k-dropdown v-if="field.type === 'dropdown'" :data-items="field.options" v-model="field.value" :placeholder="field.label" :disabled="field.isDisabled" />
          <k-datepicker v-if="field.type === 'date'" v-model="field.value" :placeholder="field.label" :disabled="field.isDisabled" />
          <k-maskedtextbox v-if="field.type === 'phone'" v-model="field.value" :mask="'000-000-0000'" :rules="{ '0': /\d/ }" :placeholder="field.label" :disabled="field.isDisabled" />
          <k-checkbox v-if="field.type === 'checkbox'" v-model="field.value" :disabled="field.isDisabled" />
          <k-textarea v-if="field.type === 'textarea'" v-model="field.value" :rows="4" :placeholder="field.label" :disabled="field.isDisabled" />
          <k-input v-if="field.type === 'email'" type="email" v-model="field.value" :placeholder="field.label" :disabled="field.isDisabled" />
        </label>
      </div>

      <h3 class="section--subtitle">Type of Lien</h3>
      <div class="row" v-for="field in vaDisbursementFields.filter(f => f.section === 'disbursementsection1lien')" :key="field.id">
        <label class="full">
          {{ field.label }}
          <k-input v-if="field.type === 'input'" v-model="field.value" :placeholder="field.label" :disabled="field.isDisabled" />
          <k-numeric-input v-if="field.type === 'numeric'" :format="'n0'" :min="0" v-model="field.value" :disabled="field.isDisabled" />
          <k-numeric-input v-if="field.type === 'numeric-currency'" :format="'c2'" :min="0" v-model="field.value" :disabled="field.isDisabled" />
          <k-dropdown v-if="field.type === 'dropdown'" :data-items="field.options" v-model="field.value" :placeholder="field.label" :disabled="field.isDisabled" />
          <k-datepicker v-if="field.type === 'date'" v-model="field.value" :placeholder="field.label" :disabled="field.isDisabled" />
          <k-maskedtextbox v-if="field.type === 'phone'" v-model="field.value" :mask="'000-000-0000'" :rules="{ '0': /\d/ }" :placeholder="field.label" :disabled="field.isDisabled" />
          <k-checkbox v-if="field.type === 'checkbox'" v-model="field.value" :disabled="field.isDisabled" />
          <k-textarea v-if="field.type === 'textarea'" v-model="field.value" :rows="4" :placeholder="field.label" :disabled="field.isDisabled" />
          <k-input v-if="field.type === 'email'" type="email" v-model="field.value" :placeholder="field.label" :disabled="field.isDisabled" />
        </label>
      </div>

      <h3 class="section--subtitle">Estate/Title</h3>
      <div class="row" v-for="field in vaDisbursementFields.filter(f => f.section === 'disbursementsection1estate')" :key="field.id">
        <label class="full">
          {{ field.label }}
          <k-input v-if="field.type === 'input'" v-model="field.value" :placeholder="field.label" :disabled="field.isDisabled" />
          <k-numeric-input v-if="field.type === 'numeric'" :format="'n0'" :min="0" v-model="field.value" :disabled="field.isDisabled" />
          <k-numeric-input v-if="field.type === 'numeric-currency'" :format="'c2'" :min="0" v-model="field.value" :disabled="field.isDisabled" />
          <k-dropdown v-if="field.type === 'dropdown'" :data-items="field.options" v-model="field.value" :placeholder="field.label" :disabled="field.isDisabled" />
          <k-datepicker v-if="field.type === 'date'" v-model="field.value" :placeholder="field.label" :disabled="field.isDisabled" />
          <k-maskedtextbox v-if="field.type === 'phone'" v-model="field.value" :mask="'000-000-0000'" :rules="{ '0': /\d/ }" :placeholder="field.label" :disabled="field.isDisabled" />
          <k-checkbox v-if="field.type === 'checkbox'" v-model="field.value" :disabled="field.isDisabled" />
          <k-textarea v-if="field.type === 'textarea'" v-model="field.value" :rows="4" :placeholder="field.label" :disabled="field.isDisabled" />
          <k-input v-if="field.type === 'email'" type="email" v-model="field.value" :placeholder="field.label" :disabled="field.isDisabled" />
        </label>
      </div>

      <h3 class="section--subtitle">For Refinances Only</h3>
      <div class="row" v-for="field in vaDisbursementFields.filter(f => f.section === 'disbursementsection1refi')" :key="field.id">
        <label class="full">
          {{ field.label }}
          <k-input v-if="field.type === 'input'" v-model="field.value" :placeholder="field.label" :disabled="field.isDisabled" />
          <k-numeric-input v-if="field.type === 'numeric'" :format="'n3'" :min="0" v-model="field.value" :disabled="field.isDisabled" />
          <k-numeric-input v-if="field.type === 'numeric-whole'" :format="'n0'" :min="0" v-model="field.value" :disabled="field.isDisabled" />
          <k-numeric-input v-if="field.type === 'numeric-currency'" :format="'c2'" :min="0" v-model="field.value" :disabled="field.isDisabled" />
          <k-dropdown v-if="field.type === 'dropdown'" :data-items="field.options" v-model="field.value" :placeholder="field.label" :disabled="field.isDisabled" />
          <k-datepicker v-if="field.type === 'date'" v-model="field.value" :placeholder="field.label" :disabled="field.isDisabled" />
          <k-maskedtextbox v-if="field.type === 'phone'" v-model="field.value" :mask="'000-000-0000'" :rules="{ '0': /\d/ }" :placeholder="field.label" :disabled="field.isDisabled" />
          <k-checkbox v-if="field.type === 'checkbox'" v-model="field.value" :disabled="field.isDisabled" />
          <k-textarea v-if="field.type === 'textarea'" v-model="field.value" :rows="4" :placeholder="field.label" :disabled="field.isDisabled" />
          <k-input v-if="field.type === 'email'" type="email" v-model="field.value" :placeholder="field.label" :disabled="field.isDisabled" />
        </label>
      </div>

      <h3 class="section--subtitle">Section 1 - Continued</h3>
      <div class="row" v-for="field in vaDisbursementFields.filter(f => f.section === 'disbursementsection1cont')" :key="field.id">
        <label class="full">
          {{ field.label }}
          <k-input v-if="field.type === 'input'" v-model="field.value" :placeholder="field.label" :disabled="field.isDisabled" />
          <k-numeric-input v-if="field.type === 'numeric'" :format="'n3'" :min="0" v-model="field.value" :disabled="field.isDisabled" />
          <k-numeric-input v-if="field.type === 'numeric-whole'" :format="'n0'" :min="0" v-model="field.value" :disabled="field.isDisabled" />
          <k-numeric-input v-if="field.type === 'numeric-currency'" :format="'c2'" :min="0" v-model="field.value" :disabled="field.isDisabled" />
          <k-dropdown v-if="field.type === 'dropdown'" :data-items="field.options" v-model="field.value" :placeholder="field.label" :disabled="field.isDisabled" />
          <k-datepicker v-if="field.type === 'date'" v-model="field.value" :placeholder="field.label" :disabled="field.isDisabled" />
          <k-maskedtextbox v-if="field.type === 'phone'" v-model="field.value" :mask="'000-000-0000'" :rules="{ '0': /\d/ }" :placeholder="field.label" :disabled="field.isDisabled" />
          <k-checkbox v-if="field.type === 'checkbox' && !['376', '379', '377', '380', '378', '381'].includes(field.id)" v-model="field.value" :disabled="field.isDisabled" />
          <k-textarea v-if="field.type === 'textarea'" v-model="field.value" :rows="4" :placeholder="field.label" :disabled="field.isDisabled" />
          <k-input v-if="field.type === 'email'" type="email" v-model="field.value" :placeholder="field.label" :disabled="field.isDisabled" />
          <k-checkbox v-if="field.type === 'checkbox' && ['376', '379', '377', '380', '378', '381'].includes(field.id)"
                      v-model="field.value"
                      :disabled="field.isDisabled"
                      @change="handleVaEnergyCheckboxChange($event, field)" />
          <k-checkbox v-if="field.type === 'checkbox' && !['376', '379', '377', '380', '378', '381'].includes(field.id)"
                      v-model="field.value"
                      :disabled="field.isDisabled" />
        </label>
      </div>

      <h3 class="section--subtitle">Section 2 - Lenders Certification</h3>
      <div class="row" v-for="field in vaDisbursementFields.filter(f => f.section === 'disbursementsection2')" :key="field.id">
        <label class="full">
          {{ field.label }}
          <k-input v-if="field.type === 'input'" v-model="field.value" :placeholder="field.label" :disabled="field.isDisabled" />
          <k-numeric-input v-if="field.type === 'numeric'" :format="'n3'" :min="0" v-model="field.value" :disabled="field.isDisabled" />
          <k-numeric-input v-if="field.type === 'numeric-whole'" :format="'n0'" :min="0" v-model="field.value" :disabled="field.isDisabled" />
          <k-numeric-input v-if="field.type === 'numeric-currency'" :format="'c2'" :min="0" v-model="field.value" :disabled="field.isDisabled" />
          <k-dropdown v-if="field.type === 'dropdown'" :data-items="field.options" v-model="field.value" :placeholder="field.label" :disabled="field.isDisabled" />
          <k-datepicker v-if="field.type === 'date'" v-model="field.value" :placeholder="field.label" :disabled="field.isDisabled" />
          <k-maskedtextbox v-if="field.type === 'phone'" v-model="field.value" :mask="'000-000-0000'" :rules="{ '0': /\d/ }" :placeholder="field.label" :disabled="field.isDisabled" />
          <k-checkbox v-if="field.type === 'checkbox' && !['376', '379', '377', '380', '378', '381'].includes(field.id)" v-model="field.value" :disabled="field.isDisabled" />
          <k-textarea v-if="field.type === 'textarea'" v-model="field.value" :rows="4" :placeholder="field.label" :disabled="field.isDisabled" />
          <k-input v-if="field.type === 'email'" type="email" v-model="field.value" :placeholder="field.label" :disabled="field.isDisabled" />
        </label>
      </div>

      <h3 class="section--subtitle">Complete Where Authorized By Certificate Of Reasonable Value</h3>
      <div class="row" v-for="field in vaDisbursementFields.filter(f => f.section === 'disbursementsection2cert')" :key="field.id">
        <label class="full">
          {{ field.label }}
          <k-input v-if="field.type === 'input'" v-model="field.value" :placeholder="field.label" :disabled="field.isDisabled" />
          <k-numeric-input v-if="field.type === 'numeric'" :format="'n3'" :min="0" v-model="field.value" :disabled="field.isDisabled" />
          <k-numeric-input v-if="field.type === 'numeric-whole'" :format="'n0'" :min="0" v-model="field.value" :disabled="field.isDisabled" />
          <k-numeric-input v-if="field.type === 'numeric-currency'" :format="'c2'" :min="0" v-model="field.value" :disabled="field.isDisabled" />
          <k-dropdown v-if="field.type === 'dropdown'" :data-items="field.options" v-model="field.value" :placeholder="field.label" :disabled="field.isDisabled" />
          <k-datepicker v-if="field.type === 'date'" v-model="field.value" :placeholder="field.label" :disabled="field.isDisabled" />
          <k-maskedtextbox v-if="field.type === 'phone'" v-model="field.value" :mask="'000-000-0000'" :rules="{ '0': /\d/ }" :placeholder="field.label" :disabled="field.isDisabled" />
          <k-checkbox v-if="field.type === 'checkbox' && !['376', '379', '377', '380', '378', '381'].includes(field.id)" v-model="field.value" :disabled="field.isDisabled" />
          <k-textarea v-if="field.type === 'textarea'" v-model="field.value" :rows="4" :placeholder="field.label" :disabled="field.isDisabled" />
          <k-input v-if="field.type === 'email'" type="email" v-model="field.value" :placeholder="field.label" :disabled="field.isDisabled" />
        </label>
      </div>

      <h3 class="section--subtitle">If this loan is required to be personally reviewed and approved by a VA-approved underwriter:</h3>
      <div class="row" v-for="field in vaDisbursementFields.filter(f => f.section === 'disbursementsection2uwapproved')" :key="field.id">
        <label class="full">
          {{ field.label }}
          <k-input v-if="field.type === 'input'" v-model="field.value" :placeholder="field.label" :disabled="field.isDisabled" />
          <k-numeric-input v-if="field.type === 'numeric'" :format="'n3'" :min="0" v-model="field.value" :disabled="field.isDisabled" />
          <k-numeric-input v-if="field.type === 'numeric-whole'" :format="'n0'" :min="0" v-model="field.value" :disabled="field.isDisabled" />
          <k-numeric-input v-if="field.type === 'numeric-currency'" :format="'c2'" :min="0" v-model="field.value" :disabled="field.isDisabled" />
          <k-dropdown v-if="field.type === 'dropdown'" :data-items="field.options" v-model="field.value" :placeholder="field.label" :disabled="field.isDisabled" />
          <k-datepicker v-if="field.type === 'date'" v-model="field.value" :placeholder="field.label" :disabled="field.isDisabled" />
          <k-maskedtextbox v-if="field.type === 'phone'" v-model="field.value" :mask="'000-000-0000'" :rules="{ '0': /\d/ }" :placeholder="field.label" :disabled="field.isDisabled" />
          <k-checkbox v-if="field.type === 'checkbox' && !['376', '379', '377', '380', '378', '381'].includes(field.id)" v-model="field.value" :disabled="field.isDisabled" />
          <k-textarea v-if="field.type === 'textarea'" v-model="field.value" :rows="4" :placeholder="field.label" :disabled="field.isDisabled" />
          <k-input v-if="field.type === 'email'" type="email" v-model="field.value" :placeholder="field.label" :disabled="field.isDisabled" />
        </label>
      </div>

      <h3 class="section--subtitle">Name and Address of Lender</h3>
      <div class="row" v-for="field in vaDisbursementFields.filter(f => f.section === 'disbursementsection2lender')" :key="field.id">
        <label class="full">
          {{ field.label }}
          <k-input v-if="field.type === 'input'" v-model="field.value" :placeholder="field.label" :disabled="field.isDisabled" />
          <k-numeric-input v-if="field.type === 'numeric'" :format="'n3'" :min="0" v-model="field.value" :disabled="field.isDisabled" />
          <k-numeric-input v-if="field.type === 'numeric-whole'" :format="'n0'" :min="0" v-model="field.value" :disabled="field.isDisabled" />
          <k-numeric-input v-if="field.type === 'numeric-currency'" :format="'c2'" :min="0" v-model="field.value" :disabled="field.isDisabled" />
          <k-dropdown v-if="field.type === 'dropdown'" :data-items="field.options" v-model="field.value" :placeholder="field.label" :disabled="field.isDisabled" />
          <k-datepicker v-if="field.type === 'date'" v-model="field.value" :placeholder="field.label" :disabled="field.isDisabled" />
          <k-maskedtextbox v-if="field.type === 'phone'" v-model="field.value" :mask="'000-000-0000'" :rules="{ '0': /\d/ }" :placeholder="field.label" :disabled="field.isDisabled" />
          <k-checkbox v-if="field.type === 'checkbox' && !['376', '379', '377', '380', '378', '381'].includes(field.id)" v-model="field.value" :disabled="field.isDisabled" />
          <k-textarea v-if="field.type === 'textarea'" v-model="field.value" :rows="4" :placeholder="field.label" :disabled="field.isDisabled" />
          <k-input v-if="field.type === 'email'" type="email" v-model="field.value" :placeholder="field.label" :disabled="field.isDisabled" />
        </label>
      </div>

      <h3 class="section--subtitle">Section 3 - Veterans Certification</h3>
      <div class="row" v-for="field in vaDisbursementFields.filter(f => f.section === 'disbursementsection3')" :key="field.id">
        <label class="full">
          {{ field.label }}
          <k-input v-if="field.type === 'input'" v-model="field.value" :placeholder="field.label" :disabled="field.isDisabled" />
          <k-numeric-input v-if="field.type === 'numeric'" :format="'n3'" :min="0" v-model="field.value" :disabled="field.isDisabled" />
          <k-numeric-input v-if="field.type === 'numeric-whole'" :format="'n0'" :min="0" v-model="field.value" :disabled="field.isDisabled" />
          <k-numeric-input v-if="field.type === 'numeric-currency'" :format="'c2'" :min="0" v-model="field.value" :disabled="field.isDisabled" />
          <k-dropdown v-if="field.type === 'dropdown'" :data-items="field.options" v-model="field.value" :placeholder="field.label" :disabled="field.isDisabled" />
          <k-datepicker v-if="field.type === 'date'" v-model="field.value" :placeholder="field.label" :disabled="field.isDisabled" />
          <k-maskedtextbox v-if="field.type === 'phone'" v-model="field.value" :mask="'000-000-0000'" :rules="{ '0': /\d/ }" :placeholder="field.label" :disabled="field.isDisabled" />
          <k-checkbox v-if="field.type === 'checkbox' && !['376', '379', '377', '380', '378', '381'].includes(field.id)" v-model="field.value" :disabled="field.isDisabled" />
          <k-textarea v-if="field.type === 'textarea'" v-model="field.value" :rows="4" :placeholder="field.label" :disabled="field.isDisabled" />
          <k-input v-if="field.type === 'email'" type="email" v-model="field.value" :placeholder="field.label" :disabled="field.isDisabled" />
        </label>
      </div>

      <h3 class="section--subtitle">If the Contract Price or Cost Exceeds the VA Reasonable Value, Complete The Following Item:</h3>
      <div class="row" v-for="field in vaDisbursementFields.filter(f => f.section === 'disbursementsection3exceeds')" :key="field.id">
        <label class="full">
          {{ field.label }}
          <k-input v-if="field.type === 'input'" v-model="field.value" :placeholder="field.label" :disabled="field.isDisabled" />
          <k-numeric-input v-if="field.type === 'numeric'" :format="'n3'" :min="0" v-model="field.value" :disabled="field.isDisabled" />
          <k-numeric-input v-if="field.type === 'numeric-whole'" :format="'n0'" :min="0" v-model="field.value" :disabled="field.isDisabled" />
          <k-numeric-input v-if="field.type === 'numeric-currency'" :format="'c2'" :min="0" v-model="field.value" :disabled="field.isDisabled" />
          <k-dropdown v-if="field.type === 'dropdown'" :data-items="field.options" v-model="field.value" :placeholder="field.label" :disabled="field.isDisabled" />
          <k-datepicker v-if="field.type === 'date'" v-model="field.value" :placeholder="field.label" :disabled="field.isDisabled" />
          <k-maskedtextbox v-if="field.type === 'phone'" v-model="field.value" :mask="'000-000-0000'" :rules="{ '0': /\d/ }" :placeholder="field.label" :disabled="field.isDisabled" />
          <k-checkbox v-if="field.type === 'checkbox' && !['376', '379', '377', '380', '378', '381'].includes(field.id)" v-model="field.value" :disabled="field.isDisabled" />
          <k-textarea v-if="field.type === 'textarea'" v-model="field.value" :rows="4" :placeholder="field.label" :disabled="field.isDisabled" />
          <k-input v-if="field.type === 'email'" type="email" v-model="field.value" :placeholder="field.label" :disabled="field.isDisabled" />
        </label>
      </div>

      <h3 class="section--subtitle">If Certificate of Eligibility Requires Certification of Active Duty Status, Following Cerification Must Be Checked:</h3>
      <div class="row" v-for="field in vaDisbursementFields.filter(f => f.section === 'disbursementsection3certrequired')" :key="field.id">
        <label class="full">
          {{ field.label }}
          <k-input v-if="field.type === 'input'" v-model="field.value" :placeholder="field.label" :disabled="field.isDisabled" />
          <k-numeric-input v-if="field.type === 'numeric'" :format="'n3'" :min="0" v-model="field.value" :disabled="field.isDisabled" />
          <k-numeric-input v-if="field.type === 'numeric-whole'" :format="'n0'" :min="0" v-model="field.value" :disabled="field.isDisabled" />
          <k-numeric-input v-if="field.type === 'numeric-currency'" :format="'c2'" :min="0" v-model="field.value" :disabled="field.isDisabled" />
          <k-dropdown v-if="field.type === 'dropdown'" :data-items="field.options" v-model="field.value" :placeholder="field.label" :disabled="field.isDisabled" />
          <k-datepicker v-if="field.type === 'date'" v-model="field.value" :placeholder="field.label" :disabled="field.isDisabled" />
          <k-maskedtextbox v-if="field.type === 'phone'" v-model="field.value" :mask="'000-000-0000'" :rules="{ '0': /\d/ }" :placeholder="field.label" :disabled="field.isDisabled" />
          <k-checkbox v-if="field.type === 'checkbox' && !['376', '379', '377', '380', '378', '381'].includes(field.id)" v-model="field.value" :disabled="field.isDisabled" />
          <k-textarea v-if="field.type === 'textarea'" v-model="field.value" :rows="4" :placeholder="field.label" :disabled="field.isDisabled" />
          <k-input v-if="field.type === 'email'" type="email" v-model="field.value" :placeholder="field.label" :disabled="field.isDisabled" />
        </label>
      </div>

    </section>
  </template>-->
    <!-- Loan Analysis Tab Content -->
    <!--<template v-slot:vaLoanAnalysis>
        <section class="edit-condition__section-detail va-loan-analysis">
          <h2 class="section--title va">VA Loan Analysis</h2>

          <h3 class="section--subtitle">Section A - Borrower/Coborrower Information</h3>
          <div class="row" v-for="field in vaDisbursementFields.filter(f => f.section === 'loananalysissection1')" :key="field.id">
            <label class="full">
              {{ field.label }}
              <k-input v-if="field.type === 'input'" v-model="field.value" :placeholder="field.label" :disabled="field.isDisabled" />
              <k-numeric-input v-if="field.type === 'numeric'" :format="'n3'" :min="0" v-model="field.value" :disabled="field.isDisabled" />
              <k-numeric-input v-if="field.type === 'numeric-whole'" :format="'n0'" :min="0" v-model="field.value" :disabled="field.isDisabled" />
              <k-numeric-input v-if="field.type === 'numeric-currency'" :format="'c2'" :min="0" v-model="field.value" :disabled="field.isDisabled" />
              <k-dropdown v-if="field.type === 'dropdown'" :data-items="field.options" v-model="field.value" :placeholder="field.label" :disabled="field.isDisabled" />
              <k-datepicker v-if="field.type === 'date'" v-model="field.value" :placeholder="field.label" :disabled="field.isDisabled" />
              <k-maskedtextbox v-if="field.type === 'phone'" v-model="field.value" :mask="'000-000-0000'" :rules="{ '0': /\d/ }" :placeholder="field.label" :disabled="field.isDisabled" />
              <k-checkbox v-if="field.type === 'checkbox' && !['376', '379', '377', '380', '378', '381'].includes(field.id)" v-model="field.value" :disabled="field.isDisabled" />
              <k-textarea v-if="field.type === 'textarea'" v-model="field.value" :rows="4" :placeholder="field.label" :disabled="field.isDisabled" />
              <k-input v-if="field.type === 'email'" type="email" v-model="field.value" :placeholder="field.label" :disabled="field.isDisabled" />
            </label>
          </div>

          <div class="row name-group">
            <label>Borrower:</label>
            <k-input class="name-field" disabled placeholder="Last Name" />
            <k-input class="name-field" disabled placeholder="First Name" />
            <k-input class="name-field middle" disabled placeholder="MI" />
            <k-input class="name-field suffix" disabled placeholder="Suffix" />
          </div>
          <div class="row name-group">
            <label>Co-Borrower:</label>
            <k-input class="name-field" disabled placeholder="Last Name" />
            <k-input class="name-field" disabled placeholder="First Name" />
            <k-input class="name-field middle" disabled placeholder="MI" />
            <k-input class="name-field suffix" disabled placeholder="Suffix" />
          </div>

          <div class="row loan-amount-breakdown">
            <label>Base Loan Amount <k-numeric-input :format="'c2'" placeholder="Amount" /></label>
            <label>MIP / FF <k-numeric-input :format="'c2'" placeholder="Amount" /></label>
            <label>FF Paid in Cash <k-numeric-input :format="'c2'" placeholder="Amount" /></label>
            <label>% = <k-numeric-input :format="'p3'" :step="0.001" placeholder="%" /></label> <label>Total Loan Amount <k-numeric-input :format="'c2'" placeholder="Amount" disabled /></label>
          </div>
          <div class="row">
            <label class="full">Cash Down Payment <k-numeric-input :format="'c2'" placeholder="Amount" /></label>
          </div>

          <h3 class="section--subtitle">Borrower's Personal and Financial Status</h3>
          <h3 class="section--subtitle">Estimated Monthly Shelter Expenses</h3>
          <div class="shelter-expenses-grid">
            <label>Term of Loan (Yrs) <k-numeric-input :format="'n0'" :decimals="0" placeholder="Years" /></label>
            <label>Mortgage Payment (P&I) <k-numeric-input :format="'c2'" placeholder="Amount" /></label>
            <label>Realty Taxes <k-numeric-input :format="'c2'" placeholder="Amount" /></label>
            <label>Hazard Ins <k-numeric-input :format="'c2'" placeholder="Amount" /></label>
            <label>Special Asmts <k-numeric-input :format="'c2'" placeholder="Amount" /></label>
            <label>Maintenance & Utilities <k-numeric-input :format="'c2'" placeholder="Amount" /></label> <label>Other <k-numeric-input :format="'c2'" placeholder="Amount" /></label>
            <label>Total <k-numeric-input :format="'c2'" placeholder="Amount" disabled /></label>
          </div>

          <h3 class="section--subtitle">Debts and Obligations</h3>
          <table class="k-grid-table va-debt-table">
            <colgroup>
              <col style="width: 35%;" />
              <col style="width: 15%;" />
              <col style="width: 25%;" />
              <col style="width: 25%;" />
            </colgroup>
            <thead>
              <tr>
                <th>Creditor</th>
                <th class="center-text">Include on Line 40?</th>
                <th>Monthly Payment</th>
                <th>Unpaid Balance</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td><k-input placeholder="Creditor Name" /></td>
                <td class="center-text"><k-checkbox /></td>
                <td><k-numeric-input :format="'c2'" /></td>
                <td><k-numeric-input :format="'c2'" /></td>
              </tr>
              <tr>
                <td><k-input /></td>
                <td class="center-text"><k-checkbox /></td>
                <td><k-numeric-input :format="'c2'" /></td>
                <td><k-numeric-input :format="'c2'" /></td>
              </tr>
              <tr>
                <td><k-input /></td>
                <td class="center-text"><k-checkbox /></td>
                <td><k-numeric-input :format="'c2'" /></td>
                <td><k-numeric-input :format="'c2'" /></td>
              </tr>
              <tr><td>Job Related Expense</td><td class="center-text"><k-checkbox /></td><td><k-numeric-input :format="'c2'" /></td><td class="na-cell">N/A</td></tr>
              <tr><td>Alimony / Child Support</td><td class="center-text"><k-checkbox /></td><td><k-numeric-input :format="'c2'" /></td><td class="na-cell">N/A</td></tr>
              <tr><td>Other Liabilities</td><td class="center-text"><k-checkbox /></td><td><k-numeric-input :format="'c2'" /></td><td><k-numeric-input :format="'c2'" /></td></tr>
              <tr class="total-row">
                <td colspan="2"><strong>Total Debt Payments</strong></td>
                <td><k-numeric-input :format="'c2'" disabled /></td>
                <td></td>
              </tr>
            </tbody>
          </table>

          <h3 class="section--subtitle">Monthly Income and Deductions</h3>
          <table class="k-grid-table va-income-table">
            <colgroup>
              <col style="width: 40%;" />
              <col style="width: 20%;" />
              <col style="width: 20%;" />
              <col style="width: 20%;" />
            </colgroup>
            <thead>
              <tr>
                <th>Items</th>
                <th>Borrower</th>
                <th>Spouse</th>
                <th>Total</th>
              </tr>
            </thead>
            <tbody>
              <tr class="income-row"><td colspan="4"><strong>INCOME</strong></td></tr>
              <tr><td>Earnings from Employment</td><td><k-numeric-input :format="'c2'" /></td><td><k-numeric-input :format="'c2'" /></td><td><k-numeric-input :format="'c2'" disabled /></td></tr>
              <tr><td>Other Net Income (Pension, etc.)</td><td><k-numeric-input :format="'c2'" /></td><td><k-numeric-input :format="'c2'" /></td><td><k-numeric-input :format="'c2'" disabled /></td></tr>
              <tr class="total-row"><td><strong>Total Gross Income</strong></td><td></td><td></td><td><k-numeric-input :format="'c2'" disabled /></td></tr>
              <tr class="deduction-row"><td colspan="4"><strong>DEDUCTIONS</strong></td></tr>
              <tr><td>Federal Inc Tax</td><td><k-numeric-input :format="'c2'" /></td><td><k-numeric-input :format="'c2'" /></td><td><k-numeric-input :format="'c2'" disabled /></td></tr>
              <tr><td>State Inc Tax</td><td><k-numeric-input :format="'c2'" /></td><td><k-numeric-input :format="'c2'" /></td><td><k-numeric-input :format="'c2'" disabled /></td></tr>
              <tr><td>Social Security</td><td><k-numeric-input :format="'c2'" /></td><td><k-numeric-input :format="'c2'" /></td><td><k-numeric-input :format="'c2'" disabled /></td></tr>
              <tr><td>Other (Specify) <k-input class="inline-input" placeholder="Specify" /></td><td><k-numeric-input :format="'c2'" /></td><td><k-numeric-input :format="'c2'" /></td><td><k-numeric-input :format="'c2'" disabled /></td></tr>
              <tr class="total-row"><td><strong>Total Deductions</strong></td><td><k-numeric-input :format="'c2'" disabled /></td><td><k-numeric-input :format="'c2'" disabled /></td><td><k-numeric-input :format="'c2'" disabled /></td></tr>
              <tr class="total-row"><td><strong>Net Take-Home Pay (Income - Deductions)</strong></td><td><k-numeric-input :format="'c2'" disabled /></td><td><k-numeric-input :format="'c2'" disabled /></td><td><k-numeric-input :format="'c2'" disabled /></td></tr>
            </tbody>
          </table>
          <div class="income-calculations">
            <div class="row pair-group">
              <label class="pair">Other Items Deducted from Section D <k-numeric-input :format="'c2'" placeholder="Sum of checked items" disabled /></label>
              <label class="pair">Total Net Effective Income <k-numeric-input :format="'c2'" placeholder="Net Pay - Other Deductions" disabled /></label>
            </div>
            <div class="row pair-group">
              <label class="pair">Less Estimated Monthly Shelter Expense <k-numeric-input :format="'c2'" placeholder="From Section C" disabled /></label>
              <label class="pair">Balance Available for Family Support <k-numeric-input :format="'c2'" placeholder="Net Effective - Shelter" disabled /></label>
            </div>
            <div class="row pair-group">
              <label class="pair">Guideline <k-numeric-input :format="'c2'" placeholder="Guideline Amount" /></label> <label class="pair">Ratio (Shelter + Debt) / Gross Income % <k-numeric-input :format="'p2'" :step="0.001" placeholder="%" disabled /></label>
            </div>
          </div>

          <h3 class="section--subtitle">Disposition of Application and Underwriter Certification</h3>
          <div class="row pair-group">
            <label class="pair">
              Was an Automated Underwriting System Used?
              <k-dropdown :data-items="['No', 'Yes']" default-value="No" />
            </label>
            <label class="pair">
              Select System Used
              <k-dropdown :data-items="['N/A', 'LP', 'DU', 'PMI AURA', 'CLUES', 'ZIPPY']" default-value="N/A" />
            </label>
          </div>
          <div class="row pair-group">
            <label class="pair">
              Risk Classification
              <k-dropdown :data-items="['N/A','APPROVE', 'REFER']" default-value="N/A" />
            </label>
            <label class="pair">Borrower Median Credit Score <k-numeric-input :format="'n0'" :decimals="0" /></label>
          </div>
          <div class="row pair-group">
            <label class="pair">Borrower's CAIVRS # <k-input /></label>
            <label class="pair">Co-Borrower Median Credit Score <k-numeric-input :format="'n0'" :decimals="0" /></label>
          </div>
          <div class="row">
            <label class="full">Co-Borrower's CAIVRS # <k-input /></label>
          </div>
          <div class="row disposition-radios">
            <span class="k-form-field">
              <label class="k-label">Past Credit Record</label>
              <ul class="k-radio-list k-list-horizontal">
                <li class="k-radio-item"><input type="radio" name="creditRecord" id="crSat" value="Satisfactory" class="k-radio k-radio-md" checked /><label class="k-radio-label" for="crSat">Satisfactory</label></li>
                <li class="k-radio-item"><input type="radio" name="creditRecord" id="crUnsat" value="Unsatisfactory" class="k-radio k-radio-md" /><label class="k-radio-label" for="crUnsat">Unsatisfactory</label></li>
              </ul>
            </span>
            <span class="k-form-field">
              <label class="k-label">Does Loan Meet VA Credit Standards?</label>
              <ul class="k-radio-list k-list-horizontal">
                <li class="k-radio-item"><input type="radio" name="creditStandards" id="csYes" value="Yes" class="k-radio k-radio-md" checked /><label class="k-radio-label" for="csYes">Yes</label></li>
                <li class="k-radio-item"><input type="radio" name="creditStandards" id="csNo" value="No" class="k-radio k-radio-md" /><label class="k-radio-label" for="csNo">No</label></li>
              </ul>
            </span>
          </div>
          <div class="row">
            <label class="full">Underwriter VA ID Number <k-input placeholder="ID #" /></label>
          </div>
          <div class="row">
            <label class="full">Remarks <k-textarea :rows="4" placeholder="Enter remarks..." /></label>
          </div>

          <div class="row approval-blocks">
            <div class="approval-block">
              <label>Examiner / Underwriter Recommendation</label>
              <ul class="k-radio-list">
                <li class="k-radio-item"><input type="radio" name="uwRec" id="uwRecApp" value="Approved" class="k-radio k-radio-md" /><label class="k-radio-label" for="uwRecApp">Approved</label></li>
                <li class="k-radio-item"><input type="radio" name="uwRec" id="uwRecDis" value="Disapproved" class="k-radio k-radio-md" /><label class="k-radio-label" for="uwRecDis">Disapproved</label></li>
              </ul>
              <label>Date <k-datepicker /></label>
            </div>
            <div class="approval-block">
              <label>Final Action</label>
              <ul class="k-radio-list">
                <li class="k-radio-item"><input type="radio" name="finalAction" id="finalApp" value="Approved" class="k-radio k-radio-md" /><label class="k-radio-label" for="finalApp">Approved</label></li>
                <li class="k-radio-item"><input type="radio" name="finalAction" id="finalRej" value="Rejected" class="k-radio k-radio-md" /><label class="k-radio-label" for="finalRej">Rejected</label></li>
              </ul>
              <label>Date <k-datepicker /></label>
            </div>
          </div>

        </section>
      </template>

    </k-tabstrip>
  </div>
  <div class="edit-condition__attachments va">
    <div class="attachments-grid__panel-container va">
      <k-panelbar :expand-mode="'single'"
                  :items="panelItems"
                  class="attachments-grid__panel">
        <template v-slot:attachmentsgrid>
          <k-grid :data-items="fhaAttachments"
                  :columns="attachmentColumns"
                  :sortable="sortable"
                  :sort="vaAttachmentSort"
                  @sortchange="vaAttachmentSortChangeHandler"
                  @rowclick="getAttachment">
          </k-grid>
        </template>
      </k-panelbar>
    </div>
    <div class="viewer__container">
      <WebViewer @removeAttchment="RemoveAttachments"
                 :pdfContainerClass="'va-attachments-viewer'"
                 :showEditorButton="false"
                 :selectedAttchement="selectedAttachment"
                 :pdfFile="selectedAttachment.url"
                 v-if="!isVaAttachmentLoading && selectedAttachment.url && vaAttachmentId" />
      <div class="document-attachment__loader-container"
           v-if="isVaAttachmentLoading">
        <loader :size="'large'" :type="'pulsing'"></loader>
      </div>
      <div v-if="showVADocsWarning">
        <p class="asset--info">
          <span class="k-icon k-i-information k-i-info"></span> This file currently has no VA Docs
        </p>
      </div>
      </div>
    </div>
  </div>-->
    <!-- VA Signing Docs Placeholder -->
    <!--<div v-if="(!hasMI && wizardStep && isVA && wizardStep === 5)"
     class="va-signing-docs__container edit-condition__wrapper">
  <div class="edit-condition__attachments va-signing-docs__container">
    <h2 class="section--title va">VA Signing Documents</h2>-->
    <!-- Document dropdown/viewer will go here later -->
    <!--</div>
  </div>-->


    <div v-show="(!hasMI && wizardStep && isFHA && wizardStep === 4)" class="fha-summary__container edit-condition__wrapper">
      <div class="edit-condition__detail-tracking">
        <k-tabstrip :selected="selectedFhaTab" @select="onFhaTabSelected" :tabs="fhaTabs" class="fha-tabstrip">
          <template v-slot:loanTransmittal>
            <section class="edit-condition__section-detail">
              <h2 class="section--title fha">HUD - 92900 LT FHA Loan Transmittal Form</h2>
              <div class="added__info">
                <label v-for="field in fhaSummaryFields.filter(f => f.section === 'lt')" v-bind:key="field.id">
                  {{ field.label }}
                  <k-input v-if="field.type === 'input'" v-model="field.value" />
                  <k-dropdown v-if="field.type === 'dropdown'"
                              :data-items="field.selects"
                              v-model="field.value"></k-dropdown>
                </label>
              </div>

              <h3 class="section--subtitle">Property Information</h3>
              <div class="added__info wrap">
                <label v-for="field in fhaSummaryFields.filter(f => f.section === 'Property Information' && f.iterate)" v-bind:key="field.value" class="radio-label">
                  <k-radio v-if="field.type === 'radio'"
                           :name="field.section"
                           :value="field.value"
                           :checked="fhaSummaryFields.find(f => f.id === '2996').value === field.value"
                                        @change="onFhaPropertyTypeChanged"/>
                  {{ field.label }}
                </label>
              </div>

              <h3 class="section--subtitle">Secondary Financing</h3>
              <div class="secondary-financing-gifts__container">
                <div class="row" v-for="field in fhaSummaryFields.filter(f => f.section === 'Secondary Financing' && f.iterate && f.label && f.type === 'input')" v-bind:key="field.id">
                  <label class="full">
                    {{ field.label }}
                    <k-input v-model="field.value" />
                  </label>
                </div>
                <div class="row">
                  <label class="trio" v-for="field in fhaSummaryFields.filter(f => f.section === 'Secondary Financing' && f.iterate && f.label !== 'Other' && f.type === 'checkbox')" v-bind:key="field.id">
                    <k-checkbox :checked="field.value === 'Y'" @change="setCheckboxValue($event, field.id, 'fhaSummaryFields')"></k-checkbox>
                    {{ field.label }}
                  </label>
                </div>
                <div class="row">
                  <label class="mixed-pair" v-for="field in fhaSummaryFields.filter(f => f.section === 'Secondary Financing' && f.iterate && (f.label === 'Other' || f.label === ''))" v-bind:key="field.id">
                    <k-checkbox v-if="field.type === 'checkbox'" :checked="field.value === 'Y'" @change="setCheckboxValue($event, field.id, 'fhaSummaryFields')"></k-checkbox>
                    <k-input v-if="field.type === 'input'" v-model="field.value" />
                    {{ field.label }}
                  </label>
                </div>
                <div class="row" v-for="field in fhaSummaryFields.filter(f => f.section === 'Secondary Financing' && f.iterate && f.type === 'numeric')" v-bind:key="field.id">
                  <label class="full">
                    {{ field.label }}
                                        <k-numeric-input v-model="field.value" :format="'c2'" :min="0"/>
                  </label>
                </div>
              </div>

                            <h3 class="section--subtitle fha-gifts">Gifts
                <span class="dap__span">
                  <k-checkbox :checked="fhaSummaryFields.find(f => f.id === '3008').value === 'Y'" @change="setCheckboxValue($event, '3008', 'fhaSummaryFields')"></k-checkbox>
                  Seller Funded DAP
                </span>
              </h3>
              <div class="secondary-financing-gifts__container" v-for="index in 2" :key="index">
                <div class="row" v-for="field in fhaSummaryFields.filter(f => f.section === 'Gifts' && f.iterate && f.label && f.type === 'input' && f.group === index)" v-bind:key="field.id">
                  <label class="full">
                    {{ index }}. {{ field.label }}
                    <k-input v-model="field.value" />
                  </label>
                </div>
                <div class="row">
                  <label class="trio" v-for="field in fhaSummaryFields.filter(f => f.section === 'Gifts' && f.iterate && f.label !== 'Other' && f.type === 'checkbox' && f.group === index)" v-bind:key="field.id">
                    <k-checkbox :checked="field.value === 'Y'" @change="setCheckboxValue($event, field.id, 'fhaSummaryFields')"></k-checkbox>
                    {{ field.label }}
                  </label>
                </div>
                <div class="row">
                  <label class="mixed-pair" v-for="field in fhaSummaryFields.filter(f => f.section === 'Gifts' && f.iterate && (f.label === 'Other' || f.label === '') && f.group === index)" v-bind:key="field.id">
                    <k-checkbox v-if="field.type === 'checkbox'" :checked="field.value === 'Y'" @change="setCheckboxValue($event, field.id, 'fhaSummaryFields')"></k-checkbox>
                    <k-input v-if="field.type === 'input'" v-model="field.value" />
                    {{ field.label }}
                  </label>
                </div>
                <div class="row" v-for="field in fhaSummaryFields.filter(f => f.section === 'Gifts' && f.iterate && f.type === 'numeric' && f.group === index)" v-bind:key="field.id">
                  <label class="full">
                    {{ field.label }}
                                        <k-numeric-input v-model="field.value" :format="'c2'" :min="0"/>
                  </label>
                </div>
              </div>

              <h3 class="section--subtitle">Qualifying Ratios</h3>
              <div class="row">
                <label class="pair">
                  CAIVRS # (B)
                  <k-input v-model="fhaSummaryFields.find(f => f.id === '1018').value" />
                </label>
                <label class="pair">
                  CAIVRS # (C)
                  <k-input v-model="fhaSummaryFields.find(f => f.id === '1144').value" />
                </label>
              </div>
              <div class="row">
                <label class="full">
                  CHUMS ID #
                  <k-input v-model="fhaSummaryFields.find(f => f.id === '980').value" />
                </label>
              </div>

              <h3 class="section--subtitle">Underwriter Comments</h3>
              <div class="row" v-for="field in fhaSummaryFields.filter(f => f.section === 'Underwriter Comments')" :key="field.id">
                <k-input class="comment__input" :maxLength="80" v-model="field.value" />
              </div>

              <h3 class="section--subtitle">Risk Assessment</h3>
              <label class="full">
                CHUMS ID # For Reviewer of Appraisal
                <k-input v-model="fhaSummaryFields.find(f => f.id === '3030').value" />
              </label>
            </section>
          </template>
          <template v-slot:conditionalCommitment>
            <section class="edit-condition__section-detail">
              <h2 class="section--title fha">HUD - 928005b Conditional Commitment</h2>
              <h3 class="section--subtitle first">Commitment Terms</h3>
              <div class="row">
                <label class="full">
                  Action Date
                  <k-datepicker v-model="fhaSummaryFields.find(f => f.id === '1038').value"></k-datepicker>
                </label>
              </div>
              <div class="row">
                <label class="pair">
                  Commitment Issued
                  <k-datepicker v-model="fhaSummaryFields.find(f => f.id === '1068').value"></k-datepicker>
                </label>
                <label class="pair">
                  Commitment Expires
                  <k-datepicker v-model="fhaSummaryFields.find(f => f.id === '1072').value"></k-datepicker>
                </label>
              </div>
            </section>
          </template>
          <template v-slot:addendum>
            <section class="edit-condition__section-detail">
              <h2 class="section--title fha">HUD 1003 Addendum</h2>
              <div class="row">
                <label class="full">
                  Agency Type
                  <k-dropdown :data-items="fhaAgencyTypeSelects"
                              v-model="fhaSummaryFields.find(f => f.id === '1711').value"></k-dropdown>
                </label>
              </div>


              <h2 class="section--subtitle">Purpose of Loan</h2>
              <div class="row" v-for="field in fhaSummaryFields.filter(f => f.section === 'Purpose of Loan' && f.iterate)" v-bind:key="field.value">
                <label class="full radio-label">
                  <k-radio :name="field.section"
                           :value="field.value"
                           :checked="(fhaSummaryFields.find(f => f.id === '28').value)?.replace(/[^a-zA-Z0-9]/g, '').toLowerCase() === field.value.replace(/[^a-zA-Z0-9]/g, '').toLowerCase()"
                                        @change="onFhaLoanPurposeChanged"/>
                  {{ field.label }}
                </label>
              </div>

              <h2 class="section--subtitle">Approved & Additional Conditions</h2>
              <div class="row" v-for="field in fhaSummaryFields.filter(f => f.section === 'Modified/Approved' && f.iterate)" v-bind:key="field.value">
                <label class="full radio-label">
                  <k-radio :name="field.section"
                           :value="field.value"
                           :checked="fhaSummaryFields.find(f => f.id === '3175').value === field.value"
                           @change="onModifiedApprovedChanged" />
                  {{ field.label }}
                </label>
              </div>
              <div class="property-appraisal__container">
                <div class="input__row">
                  <label v-for="field in fhaSummaryFields.filter(field => field.section === 'Approved & Additional Conditions' && field.iterate)" :key="field.id">
                    {{ field.label }}
                    <k-numeric-input v-if="field.type === 'numeric' && field.dec" v-model="field.value" :format="field.id === '3179' ? '##.00 \\%' : 'c2'" :min="0" :disabled="fhaSummaryFields.find(f => f.id === '3175').value === 'Approved'"></k-numeric-input>
                  </label>
                </div>
                <div class="row">
                  <label class="pair">
                    Proposed Maturity
                    <span class="y-m__inputs">
                      <k-numeric-input v-model="fhaSummaryFields.find(f => f.id === '3180').value" :format="'n0'" :disabled="fhaSummaryFields.find(f => f.id === '3175').value === 'Approved'"></k-numeric-input>Y
                      <k-numeric-input class="last" v-model="fhaSummaryFields.find(f => f.id === '3181').value" :format="'n0'" :disabled="fhaSummaryFields.find(f => f.id === '3175').value === 'Approved'"></k-numeric-input>M
                    </span>
                  </label>
                  <label class="pair">
                    Term of Annual Premium
                    <span class="y-m__inputs">
                      <k-numeric-input class="single" v-model="fhaSummaryFields.find(f => f.id === '3196').value" :format="'n0'" :disabled="fhaSummaryFields.find(f => f.id === '3175').value === 'Approved'"></k-numeric-input>Months
                    </span>
                  </label>
                </div>
                <div class="row">
                  <label class="full">
                    Monthly Payment
                    <k-numeric-input disabled v-model="fhaSummaryFields.find(f => f.id === '3182').value" :format="'c2'" :min="0"></k-numeric-input>
                  </label>
                </div>
                <div class="row">
                  <label class="pair">
                    Date Mortgage Approved
                    <k-datepicker v-model="fhaSummaryFields.find(f => f.id === '3176').value"></k-datepicker>
                  </label>
                  <label class="pair">
                    Date Approval Expires
                    <k-datepicker v-model="fhaSummaryFields.find(f => f.id === '3177').value"></k-datepicker>
                  </label>
                </div>

                <h3 class="subsection--title">Additional Conditions</h3>
                <div class="additional-conditions">
                  <div class="row" v-for="field in fhaSummaryFields.filter(f => f.section === 'Additional Conditions' && f.iterate)" v-bind:key="field.id">
                    <div class="checkbox-container">
                      <k-checkbox v-if="field.type === 'checkbox'" :checked="field.value === 'Y'" @change="setCheckboxValue($event, field.id, 'fhaSummaryFields')"></k-checkbox>
                    </div>
                    <div class="label-container" v-if="field.type !== 'input' && field.type !== 'textarea'">
                      {{ field.label }}
                    </div>
                    <div class="label-container" v-if="field.type === 'input'">
                      <p class="inline-label"><span>{{ field.label }}</span> <k-input v-model="field.value" :disabled="fhaSummaryFields.find(f => f.id === '3193').value != 'Y'" /></p>
                    </div>
                    <div class="label-container" v-if="field.type === 'textarea'">
                      <k-textarea v-model="field.value" :disabled="fhaSummaryFields.find(f => f.id === '3191').value != 'Y'"></k-textarea>
                    </div>
                  </div>
                </div>

                <h2 class="section--subtitle">Borrower Certification</h2>
                <div class="additional-conditions borrower-cert">
                  <div class="row">
                    <div class="checkbox-container">
                      <p>22a</p>
                    </div>
                    <div class="label-container">
                      <label>
                        {{ fhaSummaryFields.find(f => f.id === '900').label }}
                        <k-dropdown :data-items="yesNoDropdownSelects"
                                    v-model="fhaSummaryFields.find(f => f.id === '900').value"></k-dropdown>
                      </label>
                    </div>
                  </div>
                  <div class="row">
                    <div class="checkbox-container">
                      <p></p>
                    </div>
                    <div class="label-container">
                      <label>
                        {{ fhaSummaryFields.find(f => f.id === '933').label }}
                        <k-dropdown :data-items="yesNoDropdownSelects"
                                    v-model="fhaSummaryFields.find(f => f.id === '933').value"></k-dropdown>
                      </label>
                    </div>
                  </div>
                  <div class="row">
                    <div class="checkbox-container">
                      <p>22b</p>
                    </div>
                    <div class="label-container">
                      <label>
                        {{ fhaSummaryFields.find(f => f.id === '687').label }}
                        <k-numeric-input v-model="fhaSummaryFields.find(f => f.id === '687').value" :format="'c2'" :min="0"></k-numeric-input>
                      </label>
                    </div>
                  </div>
                  <div class="row">
                    <div class="checkbox-container">
                      <p>22c</p>
                    </div>
                    <div class="label-container">
                      <label>
                        {{ fhaSummaryFields.find(f => f.id === '744').label }}
                        <k-numeric-input v-model="fhaSummaryFields.find(f => f.id === '744').value" :format="'c2'" :min="0"></k-numeric-input>
                      </label>
                    </div>
                  </div>
                  <div class="row group-label">
                    <div class="checkbox-container">
                      <p>22d</p>
                    </div>
                    <div class="label-container">
                      <label>
                        Address of the Sold Property
                      </label>
                    </div>
                  </div>
                  <div class="row">
                    <div class="checkbox-container">
                      <p></p>
                    </div>
                    <div class="label-container">
                      <label>
                        <p class="inline-label"><span class="address">{{ fhaSummaryFields.find(f => f.id === '461').label }}</span> <k-input v-model="fhaSummaryFields.find(f => f.id === '461').value" /></p>
                      </label>
                    </div>
                  </div>
                  <div class="row">
                    <div class="checkbox-container">
                      <p></p>
                    </div>
                    <div class="label-container">
                      <label>
                        <p class="inline-label"><span class="address">{{ fhaSummaryFields.find(f => f.id === '1738').label }}</span> <k-input v-model="fhaSummaryFields.find(f => f.id === '1738').value" /></p>
                      </label>
                    </div>
                  </div>
                  <div class="row">
                    <div class="checkbox-container">
                      <p></p>
                    </div>
                    <div class="label-container">
                      <label>
                        <p class="inline-label">
                          <span class="address">{{ fhaSummaryFields.find(f => f.id === '1739').label }}</span>
                          <k-input v-model="fhaSummaryFields.find(f => f.id === '1739').value" />
                          <span class="double">{{ fhaSummaryFields.find(f => f.id === '1740').label }}</span>
                          <k-input v-model="fhaSummaryFields.find(f => f.id === '1740').value" />
                        </p>
                      </label>
                    </div>
                  </div>
                  <div class="row">
                    <div class="checkbox-container">
                      <p>22e</p>
                    </div>
                    <div class="label-container">
                      <label>
                        {{ fhaSummaryFields.find(f => f.id === '1016').label }}
                        <k-dropdown :data-items="yesNoDropdownSelects"
                                    v-model="fhaSummaryFields.find(f => f.id === '1016').value"></k-dropdown>
                      </label>
                    </div>
                  </div>
                  <div class="row">
                    <div class="checkbox-container">
                      <p>22f</p>
                    </div>
                    <div class="label-container">
                      <label>
                        {{ fhaSummaryFields.find(f => f.id === '1017').label }}
                        <k-dropdown :data-items="yesNoDropdownSelects"
                                    v-model="fhaSummaryFields.find(f => f.id === '1017').value"></k-dropdown>
                      </label>
                    </div>
                  </div>
                  <div class="row">
                    <div class="checkbox-container">
                      <p>23</p>
                    </div>
                    <div class="label-container">
                      <label>
                        {{ fhaSummaryFields.find(f => f.id === '1398').label }}
                        <k-dropdown :data-items="yesNoDropdownSelects"
                                    v-model="fhaSummaryFields.find(f => f.id === '1398').value"></k-dropdown>
                      </label>
                    </div>
                  </div>
                  <div class="row group-label">
                    <div class="checkbox-container">
                      <p>25</p>
                    </div>
                    <div class="label-container">
                      <label>
                        I, the Undersigned Borrower(s) Certify that:
                      </label>
                    </div>
                  </div>
                  <div class="row">
                    <div class="checkbox-container">
                      <p></p>
                    </div>
                    <div class="label-container">
                      <label>
                        {{ fhaSummaryFields.find(f => f.id === '1065').label }}
                        <k-dropdown :data-items="fhaSummaryFields.find(f => f.id === '1065').selects"
                                    v-model="fhaSummaryFields.find(f => f.id === '1065').value"></k-dropdown>
                      </label>
                    </div>
                  </div>
                  <div class="row">
                    <div class="checkbox-container">
                      <p></p>
                    </div>
                    <div class="label-container">
                      <label>
                        <p class="inline-label">
                          <span>{{ fhaSummaryFields.find(f => f.id === '356').label }}</span>
                          <k-numeric-input v-model="fhaSummaryFields.find(f => f.id === '356').value" :format="'c0'" :min="0"></k-numeric-input>
                        </p>
                      </label>
                    </div>
                  </div>
                  <div class="row">
                    <div class="checkbox-container">
                      <p></p>
                    </div>
                    <div class="label-container">
                      <label>
                        {{ fhaSummaryFields.find(f => f.id === '1639').label }}
                        <k-dropdown :data-items="fhaSummaryFields.find(f => f.id === '1639').selects"
                                    v-model="fhaSummaryFields.find(f => f.id === '1639').value"></k-dropdown>
                      </label>
                    </div>
                  </div>
                  <div class="row">
                    <div class="checkbox-container">
                      <p></p>
                    </div>
                    <div class="label-container">
                      <label>
                        {{ fhaSummaryFields.find(f => f.id === '1399').label }}
                        <k-dropdown :data-items="fhaSummaryFields.find(f => f.id === '1399').selects"
                                    v-model="fhaSummaryFields.find(f => f.id === '1399').value"></k-dropdown>
                      </label>
                    </div>
                  </div>
                  <div class="row">
                    <div class="checkbox-container">
                      <p></p>
                    </div>
                    <div class="label-container">
                      <label>
                        {{ fhaSummaryFields.find(f => f.id === '1400').label }}
                        <k-dropdown :data-items="yesNoDropdownSelects"
                                    v-model="fhaSummaryFields.find(f => f.id === '1400').value"></k-dropdown>
                      </label>
                    </div>
                  </div>
                  <h2 class="subsection--title">Lender's Representative</h2>
                  <div class="input__row">
                    <label>
                      {{ fhaSummaryFields.find(f => f.id === '1754').label }}
                      <k-input v-model="fhaSummaryFields.find(f => f.id === '1754').value" />
                    </label>
                    <label>
                      {{ fhaSummaryFields.find(f => f.id === '1755').label }}
                      <k-input v-model="fhaSummaryFields.find(f => f.id === '1755').value" />
                    </label>
                  </div>
                  <div class="input__row">
                    <label>
                      {{ fhaSummaryFields.find(f => f.id === '1756').label }}
                      <k-input v-model="fhaSummaryFields.find(f => f.id === '1756').value" />
                    </label>
                  </div>
                  <h2 class="subsection--title">Mortgagee Relationship</h2>
                  <div class="input__row full">
                    <div class="label-container">
                      <label>
                        <p class="inline-label">
                          <span>The Mortgagee </span>
                          <k-dropdown :data-items="fhaSummaryFields.find(f => f.id === '153').selects"
                                      v-model="fhaSummaryFields.find(f => f.id === '153').value"></k-dropdown>
                        </p>
                      </label>
                    </div>
                  </div>
                  <div class="input__row full">
                    <p>have a financial interest in or a relationship, by affiliation or ownership, with the builder or seller.</p>
                  </div>
                </div>
              </div>
            </section>
          </template>
          <template v-slot:tracking>
            <div class="assets-summary fha-tracking">
              <div class="asset-rows__container" v-if="isRefi">
                <h3 class="section--subtitle first">UFMIP Refund</h3>
                <div class="assets-summary__row">
                  <p class="summary-category">Description:</p>
                </div>
                <div class="assets-summary__row single" v-if="fhaRefundCondition">
                  <k-input v-model="fhaRefundCondition.externalDescription" />
                </div>
                <div class="assets-summary__row">
                  <p class="asset--info ufmip"><span class='k-icon k-i-information k-i-info'></span> Input transfers to *CL1054</p>
                </div>

                <h3 class="section--subtitle">FHA Case Number</h3>
                <div class="property-appraisal__container">
                  <div class="input__row">
                    <label v-for="field in fhaRefiFields.filter(field => field.iterate && field.section === 'FHA Case Number')" :key="field.id">
                      {{ field.label }}
                      <k-input v-if="field.type === 'input'" v-model="field.value" />
                      <k-numeric-input v-if="field.type === 'numeric'" v-model="field.value"></k-numeric-input>
                      <k-datepicker v-if="field.type === 'date'" v-model="field.value"></k-datepicker>
                    </label>
                  </div>
                </div>

                <h3 class="section--subtitle">Refi Authorization</h3>
                <div class="property-appraisal__container">
                  <div class="input__row">
                    <label v-for="field in fhaRefiFields.filter(field => field.iterate && field.section === 'Refi Authorization')" :key="field.id" :class="[{'last': field.id === '3432'}]">
                      {{ field.label }}
                      <k-input v-if="field.type === 'input'" v-model="field.value" />
                      <k-numeric-input v-if="field.type === 'numeric'" :format="'c2'" :min="0" v-model="field.value"></k-numeric-input>
                      <k-datepicker v-if="field.type === 'date'" v-model="field.value"></k-datepicker>
                    </label>
                  </div>
                </div>

                <h3 class="section--subtitle">Total Scorecard</h3>
                <div class="property-appraisal__container">
                  <div class="input__row">
                    <label v-for="field in fhaRefiFields.filter(field => field.iterate && field.section === 'Total Scorecard')" :key="field.id">
                      {{ field.label ?? field.masterLabel }}
                      <k-input v-if="field.type === 'input'" v-model="field.value" />
                      <k-numeric-input v-if="field.type === 'numeric'" :format="'c2'" :min="0" v-model="field.value"></k-numeric-input>
                      <k-datepicker v-if="field.type === 'date'" v-model="field.value"></k-datepicker>
                      <span v-if="field.type === 'radio' && field.radioGroup === 4" class="radio__container">
                        <k-radio :name="field.masterLabel"
                                 v-for="item in field.items"
                                 :value="item.value"
                                 :label="item.label"
                                 :checked="fhaRefiFields.find(f => f.id === '3029').value === item.value"
                                 @change="onRiskTypeChanged" />
                      </span>
                      <span v-if="field.type === 'radio' && field.radioGroup === 5" class="radio__container">
                        <k-radio :name="field.masterLabel"
                                 v-for="item in field.items"
                                 :value="item.value"
                                 :label="item.label"
                                 :checked="fhaRefiFields.find(f => f.id === '3631').value === item.value"
                                 @change="onRefiEligibilityChanged" />
                      </span>
                    </label>
                  </div>
                </div>

                <h3 class="section--subtitle">Condo PUD Lookup</h3>
                <div class="property-appraisal__container">
                  <div class="input__row">
                    <label v-for="field in fhaRefiFields.filter(field => field.iterate && field.section === 'Condo PUD Lookup')" :key="field.id">
                      {{ field.label }}
                      <k-input v-if="field.type === 'input'" v-model="field.value" />
                      <k-numeric-input v-if="field.type === 'numeric'" v-model="field.value"></k-numeric-input>
                      <k-datepicker v-if="field.type === 'date'" v-model="field.value"></k-datepicker>
                    </label>
                  </div>
                </div>
              </div>
              <div class="asset-rows__container">
                <h3 :class="['section--subtitle', { 'first': !isRefi }]">Appraisal</h3>
                <div class="property-appraisal__container">
                  <div class="input__row">
                    <label>
                      Logged Date
                      <k-datepicker v-model="fhaSummaryFields.find(field => field.id === '3076').value"></k-datepicker>
                    </label>
                    <label>
                      By
                      <k-input v-model="fhaSummaryFields.find(field => field.id === '3077').value"></k-input>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </k-tabstrip>
      </div>
      <div class="edit-condition__attachments mi">
        <div class="attachments-grid__panel-container fha">
          <k-panelbar :expand-mode="'single'" :items="panelItems" class="attachments-grid__panel">
            <template v-slot:attachmentsgrid>
              <k-grid :data-items="fhaAttachments"
                      :columns="attachmentColumns"
                      :sortable="sortable"
                      :sort="attachmentSort"
                      @sortchange="attachmentSortChangeHandler"
                      @rowclick="getAttachment"></k-grid>
            </template>
          </k-panelbar>
        </div>
        <div class="viewer__container">
          <WebViewer @removeAttchment="RemoveAttachments" :pdfContainerClass="'fha-attachments-viewer'" :showEditorButton="false" :selectedAttchement="selectedAttachment" :pdfFile="selectedAttachment.url" v-if="!isFhaAttachmentLoading && selectedAttachment.url && fhaAttachmentId" />
          <div class="document-attachment__loader-container" v-if="isFhaAttachmentLoading">
            <loader :size="'large'" :type="'pulsing'"></loader>
          </div>
          <div v-if="showFHADocsWarning">
            <p class="asset--info"><span class="k-icon k-i-information k-i-info"></span> This file currently has no FHA Docs</p>
          </div>
        </div>
      </div>
    </div>

    <div v-if="(!hasMI && wizardStep && isFHA && wizardStep === 5)" class="fha-summary__container edit-condition__wrapper">
      <div class="edit-condition__attachments fha-signing-docs__container">
        <k-dropdown :data-items="fhaSigningDocsSelects"
                    v-model="selectedFHASigningDoc"
                    :class="'doc-dropdown'"
                    :text-field="'display'"
                    :label="'Document'"
                    :data-item-key="'display'"
                    @change="onFhaSigningDocSelected"></k-dropdown>
        <div class="viewer__container" v-if="fhaSigningDocs.length === (applications.length * 3) && !isFhaDocLoading">
          <WebViewer :pdfContainerClass="'fha-docs-viewer-addendum'"
                     :isShowing="!isFhaDocLoading && selectedFHASigningDoc.url && selectedFHASigningDoc.display === 'HUD 1003 Addendum (App 1)'"
                     :applicationNumber="1"
                     :showEditorButton="false"
                     :selectedAttchement="fhaSigningDocs.find(doc => doc.docName === 'HUD/V.A. Addendum to Uniform Residential Loan Application' && doc.applicationNumber === 1)"
                     :pdfFile="fhaSigningDocs.find(doc => doc.docName === 'HUD/V.A. Addendum to Uniform Residential Loan Application' && doc.applicationNumber === 1)?.url"
                     @fhaaddendum1="saveFHABase64($event, '*UW* HUD/VA 1003 Addendum - 92900A', 1, fhaSigningDocs.find(doc => doc.docName === 'HUD/V.A. Addendum to Uniform Residential Loan Application' && doc.applicationNumber === 1)?.applicationId)"
                     v-if="fhaSigningDocs.find(doc => doc.docName === 'HUD/V.A. Addendum to Uniform Residential Loan Application' && doc.applicationNumber === 1)?.url"
                     v-show="!isFhaDocLoading && selectedFHASigningDoc.url && selectedFHASigningDoc.display === 'HUD 1003 Addendum (App 1)'" />
          <WebViewer :pdfContainerClass="'fha-docs-viewer-commitment'"
                     :isShowing="!isFhaDocLoading && selectedFHASigningDoc.url && selectedFHASigningDoc.display === 'HUD-928005b Conditional Commitment (App 1)'"
                     :applicationNumber="1"
                     :showEditorButton="false"
                     :selectedAttchement="fhaSigningDocs.find(doc => doc.docName === 'HUD-92800.5B Appraised Value' && doc.applicationNumber === 1)"
                     :pdfFile="fhaSigningDocs.find(doc => doc.docName === 'HUD-92800.5B Appraised Value' && doc.applicationNumber === 1)?.url"
                     @fhacommitment1="saveFHABase64($event, '*UW* Conditional Commitment  - 92800.5b', 1, fhaSigningDocs.find(doc => doc.docName === 'HUD-92800.5B Appraised Value' && doc.applicationNumber === 1)?.applicationId)"
                     v-if="fhaSigningDocs.find(doc => doc.docName === 'HUD-92800.5B Appraised Value' && doc.applicationNumber === 1)?.url"
                     v-show="!isFhaDocLoading && selectedFHASigningDoc.url && selectedFHASigningDoc.display === 'HUD-928005b Conditional Commitment (App 1)'" />
          <WebViewer :pdfContainerClass="'fha-docs-viewer-transmittal'"
                     :isShowing="selectedFHASigningDoc.display === 'HUD-92900LT FHA Loan Transmittal (App 1)'"
                     :applicationNumber="1"
                     :showEditorButton="false"
                     :selectedAttchement="fhaSigningDocs.find(doc => doc.docName === 'FHA Loan Transmittal' && doc.applicationNumber === 1)"
                     :pdfFile="fhaSigningDocs.find(doc => doc.docName === 'FHA Loan Transmittal' && doc.applicationNumber === 1)?.url"
                     @fhatransmittal1="saveFHABase64($event, '*UW* Loan Transmittal - 92900LT', 1, fhaSigningDocs.find(doc => doc.docName === 'FHA Loan Transmittal' && doc.applicationNumber === 1)?.applicationId)"
                     v-if="fhaSigningDocs.find(doc => doc.docName === 'FHA Loan Transmittal' && doc.applicationNumber === 1)?.url"
                     v-show="!isFhaDocLoading && selectedFHASigningDoc.url && selectedFHASigningDoc.display === 'HUD-92900LT FHA Loan Transmittal (App 1)'" />
          <WebViewer :pdfContainerClass="'fha-docs-viewer-addendum2'"
                     :isShowing="!isFhaDocLoading && selectedFHASigningDoc.url && selectedFHASigningDoc.display === 'HUD 1003 Addendum (App 2)'"
                     :applicationNumber="2"
                     :showEditorButton="false"
                     :selectedAttchement="fhaSigningDocs.find(doc => doc.docName === 'HUD/V.A. Addendum to Uniform Residential Loan Application' && doc.applicationNumber === 2)"
                     :pdfFile="fhaSigningDocs.find(doc => doc.docName === 'HUD/V.A. Addendum to Uniform Residential Loan Application' && doc.applicationNumber === 2)?.url"
                     @fhaaddendum2="saveFHABase64($event, '*UW* HUD/VA 1003 Addendum - 92900A', 2, fhaSigningDocs.find(doc => doc.docName === 'HUD/V.A. Addendum to Uniform Residential Loan Application' && doc.applicationNumber === 2)?.applicationId)"
                     v-if="fhaSigningDocs.find(doc => doc.docName === 'HUD/V.A. Addendum to Uniform Residential Loan Application' && doc.applicationNumber === 2)?.url"
                     v-show="!isFhaDocLoading && selectedFHASigningDoc.url && selectedFHASigningDoc.display === 'HUD 1003 Addendum (App 2)'" />
          <WebViewer :pdfContainerClass="'fha-docs-viewer-commitment2'"
                     :isShowing="!isFhaDocLoading && selectedFHASigningDoc.url && selectedFHASigningDoc.display === 'HUD-928005b Conditional Commitment (App 2)'"
                     :applicationNumber="2"
                     :showEditorButton="false"
                     :selectedAttchement="fhaSigningDocs.find(doc => doc.docName === 'HUD-92800.5B Appraised Value' && doc.applicationNumber === 2)"
                     :pdfFile="fhaSigningDocs.find(doc => doc.docName === 'HUD-92800.5B Appraised Value' && doc.applicationNumber === 2)?.url"
                     @fhacommitment2="saveFHABase64($event, '*UW* Conditional Commitment  - 92800.5b', 2, fhaSigningDocs.find(doc => doc.docName === 'HUD-92800.5B Appraised Value' && doc.applicationNumber === 2)?.applicationId)"
                     v-if="fhaSigningDocs.find(doc => doc.docName === 'HUD-92800.5B Appraised Value' && doc.applicationNumber === 2)?.url"
                     v-show="!isFhaDocLoading && selectedFHASigningDoc.url && selectedFHASigningDoc.display === 'HUD-928005b Conditional Commitment (App 2)'" />
          <WebViewer :pdfContainerClass="'fha-docs-viewer-transmittal2'"
                     :isShowing="!isFhaDocLoading && selectedFHASigningDoc.url && selectedFHASigningDoc.display === 'HUD-92900LT FHA Loan Transmittal (App 2)'"
                     :applicationNumber="2"
                     :showEditorButton="false"
                     :selectedAttchement="fhaSigningDocs.find(doc => doc.docName === 'FHA Loan Transmittal' && doc.applicationNumber === 2)"
                     :pdfFile="fhaSigningDocs.find(doc => doc.docName === 'FHA Loan Transmittal' && doc.applicationNumber === 2)?.url"
                     @fhatransmittal2="saveFHABase64($event, '*UW* Loan Transmittal - 92900LT', 2, fhaSigningDocs.find(doc => doc.docName === 'FHA Loan Transmittal' && doc.applicationNumber === 2)?.applicationId)"
                     v-if="fhaSigningDocs.find(doc => doc.docName === 'FHA Loan Transmittal' && doc.applicationNumber === 2)?.url"
                     v-show="!isFhaDocLoading && selectedFHASigningDoc.url && selectedFHASigningDoc.display === 'HUD-92900LT FHA Loan Transmittal (App 2)'" />
          <WebViewer :pdfContainerClass="'fha-docs-viewer-addendum3'"
                     :isShowing="isFhaDocLoading && selectedFHASigningDoc.url && selectedFHASigningDoc.display === 'HUD 1003 Addendum (App 3)'"
                     :applicationNumber="3"
                     :showEditorButton="false"
                     :selectedAttchement="fhaSigningDocs.find(doc => doc.docName === 'HUD/V.A. Addendum to Uniform Residential Loan Application' && doc.applicationNumber === 3)"
                     :pdfFile="fhaSigningDocs.find(doc => doc.docName === 'HUD/V.A. Addendum to Uniform Residential Loan Application' && doc.applicationNumber === 3)?.url"
                     @fhaaddendum3="saveFHABase64($event, '*UW* HUD/VA 1003 Addendum - 92900A', 3, fhaSigningDocs.find(doc => doc.docName === 'HUD/V.A. Addendum to Uniform Residential Loan Application' && doc.applicationNumber === 3)?.applicationId)"
                     v-if="fhaSigningDocs.find(doc => doc.docName === 'HUD/V.A. Addendum to Uniform Residential Loan Application' && doc.applicationNumber === 3)?.url"
                     v-show="!isFhaDocLoading && selectedFHASigningDoc.url && selectedFHASigningDoc.display === 'HUD 1003 Addendum (App 3)'" />
          <WebViewer :pdfContainerClass="'fha-docs-viewer-commitment3'"
                     :isShowing="!isFhaDocLoading && selectedFHASigningDoc.url && selectedFHASigningDoc.display === 'HUD-928005b Conditional Commitment (App 3)'"
                     :applicationNumber="3"
                     :showEditorButton="false"
                     :selectedAttchement="fhaSigningDocs.find(doc => doc.docName === 'HUD-92800.5B Appraised Value' && doc.applicationNumber === 3)"
                     :pdfFile="fhaSigningDocs.find(doc => doc.docName === 'HUD-92800.5B Appraised Value' && doc.applicationNumber === 3)?.url"
                     @fhacommitment3="saveFHABase64($event, '*UW* Conditional Commitment  - 92800.5b', 3, fhaSigningDocs.find(doc => doc.docName === 'HUD-92800.5B Appraised Value' && doc.applicationNumber === 3)?.applicationId)"
                     v-if="fhaSigningDocs.find(doc => doc.docName === 'HUD-92800.5B Appraised Value' && doc.applicationNumber === 3)?.url"
                     v-show="!isFhaDocLoading && selectedFHASigningDoc.url && selectedFHASigningDoc.display === 'HUD-928005b Conditional Commitment (App 3)'" />
          <WebViewer :pdfContainerClass="'fha-docs-viewer-transmittal3'"
                     :isShowing="!isFhaDocLoading && selectedFHASigningDoc.url && selectedFHASigningDoc.display === 'HUD-92900LT FHA Loan Transmittal (App 3)'"
                     :applicationNumber="3"
                     :showEditorButton="false"
                     :selectedAttchement="fhaSigningDocs.find(doc => doc.docName === 'FHA Loan Transmittal' && doc.applicationNumber === 3)"
                     :pdfFile="fhaSigningDocs.find(doc => doc.docName === 'FHA Loan Transmittal' && doc.applicationNumber === 3)?.url"
                     @fhatransmittal3="saveFHABase64($event, '*UW* Loan Transmittal - 92900LT', 3, fhaSigningDocs.find(doc => doc.docName === 'FHA Loan Transmittal' && doc.applicationNumber === 3)?.applicationId)"
                     v-if="fhaSigningDocs.find(doc => doc.docName === 'FHA Loan Transmittal' && doc.applicationNumber === 3)?.url"
                     v-show="!isFhaDocLoading && selectedFHASigningDoc.url && selectedFHASigningDoc.display === 'HUD-92900LT FHA Loan Transmittal (App 3)'" />
        </div>
        <div class="document-attachment__loader-container" v-if="isFhaDocLoading">
          <loader :size="'large'" :type="'pulsing'"></loader>
        </div>
      </div>
    </div>
    <!--WIP - VA CTC Wizard-->
    <!--<div v-if="(hasMI && wizardStep === 6) || (!hasMI && !isFHA && !isVA && wizardStep === 4) || (!hasMI && (isFHA || isVA) && wizardStep === 6)" class="processor-notes__container">-->
    <div v-if="(hasMI && wizardStep === 6) || (!hasMI && !isFHA && wizardStep === 4) || (!hasMI && isFHA && wizardStep === 6)" class="processor-notes__container">
      <div class="processor-select__container">
        <p class="processor--info">
          <span class="k-icon k-i-information k-i-info"></span>
          Listed below is the current processor on the file. You have the ability to reassign to a different processor using the dropdown below as necessary
        </p>
        <h3 class="step--label">Current Assigned Processor</h3>
        <k-dropdown :data-items="filteredProcessors"
                    :text-field="'displayName'"
                    :data-item-key="'id'"
                    :value="selectedProcessor"
                    :filterable="true"
                    @filterchange="onProcessorFilterChange"
                    @change="onProcessorSelected"></k-dropdown>
                <k-fade :appear="selectedProcessor !== null" v-bind:class="['processor-info__container', {'container--hide': !selectedProcessor }]" >
          <div v-if="selectedProcessor">
            <h3 class="step--label"><span class="k-icon k-i-user"></span>  {{ selectedProcessor.fullName }}</h3>
            <p class="processor__link">Email: <a :href="'mailto: ' + selectedProcessor.email">{{ selectedProcessor.email }}</a></p>
            <p v-bind:class="['processor__link', { 'processor__link--disabled': !selectedProcessor.cellPhone }]">Mobile: <a :href="selectedProcessor.cellPhone ? 'tel: ' + selectedProcessor.cellPhone : ''">{{ selectedProcessor.cellPhone ? $options.filters.phoneFilter(selectedProcessor.cellPhone) : 'N/A' }}</a></p>
            <p v-bind:class="['processor__link', { 'processor__link--disabled': !selectedProcessor.phone }]">Phone: <a :href="selectedProcessor.phone ? 'tel: ' + selectedProcessor.phone : ''">{{ selectedProcessor.phone ? $options.filters.phoneFilter(selectedProcessor.phone) : 'N/A' }}</a></p>
          </div>
        </k-fade>
      </div>
            <loan-notes-component
                :loan-id="loanId" 
                            :wizard-view="true"
                            :default-note="'Loan is CTC'"
                            v-on:wizardnoteadded="addWizardNote"></loan-notes-component>
    </div>

    <escrow-holdback-dialog :show-dialog="showEscrowHoldback"
                            :holdback-fields="escrowHoldbackFields"
                            @dialogclosed="toggleEscrowHoldback"
                            @fieldsupdated="updateEscrowHoldbackFields"></escrow-holdback-dialog>

    <div class="conditions__loader-container" v-if="isLoading">
      <loader :size="'large'" :type="'infinite-spinner'"></loader>
    </div>

    <k-notification-group class="conditions__notification-container">
      <k-fade :appear="successNotification">
        <k-notification v-if="successNotification"
                        :type="{ style: 'success', icon: true }"
                        :closable="true"
                        @close="onCloseNotification('successNotification')">
          <span>{{ notificationMsg }}</span>
        </k-notification>
      </k-fade>
      <k-fade :appear="progressNotificationTab">
        <k-notification v-if="progressNotification"
                        :type="{ style: 'warning', icon: true }"
                        :closable="true"
                        @close="onCloseNotification('progressNotification')">
          <span>{{ progressNotificationTabMsg }}</span>
        </k-notification>
      </k-fade>
    </k-notification-group>

    <transition name="dialogfade">
      <k-dialog v-if="showErrorDialog" :title="errorTitle" class="error__dialog" @close="toggleErrorDialog">
        <p class="error-dialog__msg">{{ errorMsg }}</p>
      </k-dialog>
    </transition>

    <wizard-liabilities-dialog :show-dialog="showLiabilitiesDialog"
                               :vols="applicationVOLs"
                               :loan-id="loanId"
                               @dialogclosed="toggleLiabilitiesDialog"></wizard-liabilities-dialog>
  </div>
</template>

<script>
    import auth from '../authConfig.js';
    import apiService from '../api/api.service.js';
    import WebViewer from "../components/WebViewer.vue";
    import cloneDeep from 'lodash.clonedeep';

    import { Dialog, DialogActionsBar } from '@progress/kendo-vue-dialogs';
    import { DropDownList } from '@progress/kendo-vue-dropdowns';
    import { Loader } from "@progress/kendo-vue-indicators";
    import { Button } from '@progress/kendo-vue-buttons';
    import { Notification, NotificationGroup } from "@progress/kendo-vue-notification";
    import { Input, NumericTextBox, TextArea, Checkbox, Switch, MaskedTextBox } from '@progress/kendo-vue-inputs';
    import { Fade } from "@progress/kendo-vue-animation";
    import { DatePicker } from '@progress/kendo-vue-dateinputs';
    import { Grid, GridToolbar } from '@progress/kendo-vue-grid';
    import { ProgressBar } from "@progress/kendo-vue-progressbars";
    import { PanelBar } from '@progress/kendo-vue-layout';
    import { TabStrip } from '@progress/kendo-vue-layout';
    import { RadioButton } from "@progress/kendo-vue-inputs";

    import { orderBy, filterBy } from '@progress/kendo-data-query';

    import loanNotesComponent from './loanNotesComponent.vue';
    import escrowHoldbackDialog from './escrowHoldbackDialog.vue';
    import wizardLiabilitiesDialog from './wizardLiabilitiesDialog.vue';

    export default {
        props: ['allDocuments', 'attachmentsSource', 'earnestMoneyDeposit', 'fields', 'finishClicked', 'isRefi', 'loanId', 'loanType', 'loanVOLs', 'sellerContributionFields', 'sellerContributionTotal', 'wizardStep'],
        emits: ['cleartofinish', 'documentsupdated', 'loanclearedtoclose', 'requestfailed', 'setcurrentstepcleared'],
        data() {
            return {
                addedNotes: [],
                allAttachmentColumns: [
                    { field: 'title', title: 'Title' },
                    { field: 'assignedToName', title: 'Document' },
                    { field: 'attDocDescription', title: 'Document Description' },
                    { field: 'addedBy', title: 'Added By' },
                    { field: 'createdDate', title: 'Date Added', filter: "date", type: "date", format: "{0:M/d/y}" },
                    { cell: 'versionCell', field: 'isActive', title: 'Current', filter: 'boolean' },
                ],
                allAttachmentFilter: null,
                allAttachments: [],
                allAttachmentSearchWord: '',
                allAttachmentSort: [],
                applicationGiftGrants: [],
                applicationGiftGrantsTotal: 0,
                applicationId: sessionStorage.getItem('applicationid'),
                applicationOtherAssets: [],
                applicationOtherAssetsTotal: 0,
                applicationVODs: [],
                applicationVOLs: [],
                applicationVOLsToBePaid: [],
                applicationVOLsToBePaidTotal: 0,
                applicationVODItems: [],
                applicationVODTotal: 0,
                appraisalTypeSelects: ['URAR', 'FHA URAR', '2055 Drive-by', '2075 Limited Desk Review', '704 Limited Scope Appraisal Report', 'Condo Appraisal',
                    '2-4 Small Income Property Appraisal', '1092 Broker Price Opinion', 'No appraisal/inspection obtained', 'Form 2095 appraisal with exterior only',
                    'Form 1025 appraisal with interior/exterior', 'Form 1004 appraisal with interior/exterior', 'Prior appraisal used for the transaction', 'Other',
                    'Form 26-1805, Certificate of Reasonable Value for VA', 'Form 26-8712, Manufactured Home Appraisal Report for VA', 'Form 1004C, Manufactured Home Appraisal Report with interior/exterior inspection', 
                    'Form 1073 condominium appraisal with interior/exterior inspection', 'Form 1075 condominium appraisal with exterior inspection', 
                    'Form 2090 cooperative appraisal with interior/exterior inspection', 'Form 1004D appraisal updated/completion report','From 2000 Field review one-unit'],
                approvalMilestoneId: null,
                assetsMinimumCondition: null,
                assetsMinimumTotal: null,
                attachmentColumns: [
                    { field: 'title', title: 'Title' },
                    { field: 'createdBy.entityId', title: 'Added By' },
                    { field: 'createdDate', title: 'Date Added', filter: "date", type: "date", format: "{0:MM/dd/yyyy}" },
                ],
                attachments: [],
                attachmentSort: [],
                ausAttachmentId: null,
                ausFindingsWarning: false,
                borrowerEMDCondition: null,
                borrowerFunds: 0,
                borrowerFundsCondition: null,
                borrowerSourceOfFundsSelects: ['Bridge Loan', 'Cash On Hand', 'Checking/Savings', 'Deposit On Sales Contract', 'Equity On Pending Sale', 'Equity On Sold Property', 'Equity On Subject Property', 'Gift Funds', 'Life Insurance Cash Value',
                    'Lot Equity', 'Other Type Of Down Payment', 'Rent With Option To Purchase', 'Retirement Funds', 'Sale Of Chattel', 'Secured Borrowed Funds', 'Stocks And Bonds', 'Sweat Equity', 'Trade Equity', 'Trust Funds',
                    'Unsecured Borrowed Funds', 'FHA - Gift - Source N/A', 'FHA - Gift - Source Relative', 'FHA - Gift - Source Government Assistance', 'FHA - Gift - Source Nonprofit/Religious/Community - Seller Funded', 
                    'FHA - Gift - Source Nonprofit/Religious/Community - Non-Seller Funded', 'FHA - Gift - Source Employer'],
                conditionTemplates: [],
                cuScoreSelects: ['Select Option', '1', '1.5', '2', '2.5', '3', '3.5', '4', '4.5', '5', '999'],
                docDateFields: [
                    { title: 'Credit Report', hasDoc: true, hasExp: true, hasNA: false, fields: [{ type: 'doc', fieldId: 'CX.UW.CREDITDATE', value: null }, { type: 'exp', fieldId: 'CX.UW.ID.CREDITEXP', value: null }] },
                    { title: 'Credit Refresh', hasDoc: true, hasExp: true, hasNA: false, fields: [{ type: 'doc', fieldId: 'CX.UW.ID.CREDITREFRESH', value: null }, { type: 'exp', fieldId: 'CX.UW.ID.CREDITREFRESHEXP', value: null }]},
                    { title: 'Borr. Income', hasDoc: true, hasExp: true, hasNA: true, fields: [{ type: 'doc', fieldId: 'CX.UW.ID.BINCOME', value: null }, { type: 'exp', fieldId: 'CX.UW.ID.BINCOMEEXP', value: null }, { type: 'na', fieldId: 'CX.UW.ID.OVERRIDE1', value: false }]},
                    { title: 'Co. Borr. Income', hasDoc: true, hasExp: true, hasNA: true, fields: [{ type: 'doc', fieldId: 'CX.UW.ID.CINCOME', value: null }, { type: 'exp', fieldId: 'CX.UW.ID.CINCOMEEXP', value: null }, { type: 'na', fieldId: 'CX.UW.ID.OVERRIDE2', value: false }]},
                    { title: 'Assets', hasDoc: true, hasExp: true, hasNA: true, fields: [{ type: 'doc', fieldId: 'CX.UW.ID.ASSETS', value: null }, { type: 'exp', fieldId: 'CX.UW.ID.ASSESTSEXP', value: null }, { type: 'na', fieldId: 'CX.UW.ID.OVERRIDE3', value: false }]},
                    { title: 'Verbal VOE (1st Job)', hasDoc: true, hasExp: true, hasNA: true, fields: [{ type: 'doc', fieldId: 'CX.UW.ID.BVOE1', value: null }, { type: 'exp', fieldId: 'CX.UW.ID.VOE1EXP', value: null }, { type: 'na', fieldId: 'CX.UW.ID.OVERRIDE4', value: false }]},
                    { title: 'Verbal VOE (2nd Job)', hasDoc: true, hasExp: true, hasNA: true, fields: [{ type: 'doc', fieldId: 'CX.UW.ID.BVOE2', value: null }, { type: 'exp', fieldId: 'CX.UW.ID.BVOE2EXP', value: null }, { type: 'na', fieldId: 'CX.UW.ID.OVERRIDE5', value: false }]},
                    { title: 'Co Borr. VOE (1st Job)', hasDoc: true, hasExp: true, hasNA: true, fields: [{ type: 'doc', fieldId: 'CX.UW.ID.CVOE1', value: null }, { type: 'exp', fieldId: 'CX.UW.ID.CVOE1EXP', value: null }, { type: 'na', fieldId: 'CX.UW.ID.OVERRIDE6', value: false }]},
                    { title: 'Co Borr. VOE (2nd Job)', hasDoc: true, hasExp: true, hasNA: true, fields: [{ type: 'doc', fieldId: 'CX.UW.ID.CVOE2', value: null }, { type: 'exp', fieldId: 'CX.UW.ID.CVOE2EXP', value: null }, { type: 'na', fieldId: 'CX.UW.ID.OVERRIDE7', value: false }]},
                    { title: 'Appraisal Date', hasDoc: true, hasExp: true, hasNA: true, fields: [{ type: 'doc', fieldId: 'CX.UW.ID.APPRAISAL', value: null }, { type: 'exp', fieldId: 'CX.UW.ID.APPRAISALEXP', value: null }, { type: 'na', fieldId: 'CX.UW.ID.OVERRIDE8', value: false }]},
                    { title: 'CPL Date', hasDoc: true, hasExp: true, hasNA: false, fields: [{ type: 'doc', fieldId: 'CX.UW.ID.CPL', value: null }, { type: 'exp', fieldId: 'CX.UW.ID.CPLEXP', value: null }]},
                    { title: 'HOI', hasDoc: true, hasExp: true, hasNA: false, fields: [{ type: 'doc', fieldId: 'CX.UW.ID.HOI', value: null }, { type: 'exp', fieldId: 'CX.UW.ID.HOIEXP', value: null }]},
                    { title: 'FHA Case #', hasDoc: false, hasExp: true, hasNA: false, fields: [{ type: 'exp', fieldId: 'CX.UW.ID.FHACASENUM', value: null }]},
                    { title: 'Master Policy', hasDoc: true, hasExp: true, hasNA: true, fields: [{ type: 'doc', fieldId: 'CX.UW.ID.MASTER', value: null }, { type: 'exp', fieldId: 'CX.UW.ID.MASTEREXP', value: null }, { type: 'na', fieldId: 'CX.UW.ID.OVERRIDE12', value: false }]},
                    { title: 'Flood Insurance', hasDoc: true, hasExp: true, hasNA: true, fields: [{ type: 'doc', fieldId: 'CX.UW.ID.FLOOD', value: null }, { type: 'exp', fieldId: 'CX.UW.ID.FLOODEXP', value: null }, { type: 'na', fieldId: 'CX.UW.ID.OVERRIDE10', value: false }]},
                    { title: 'Master Flood Policy', hasDoc: true, hasExp: true, hasNA: true, fields: [{ type: 'doc', fieldId: 'CX.UW.ID.MASTERFLOOD', value: null }, { type: 'exp', fieldId: 'CX.UW.ID.MASTERFLOODEXP', value: null }, { type: 'na', fieldId: 'CX.UW.ID.OVERRIDE11', value: false }]},

                ],
                docExpFields: [
                    { title: 'Payoff Date', fields: [{ type: 'doc', fieldId: 'CX.UW.ID.PAYOFFEXP', value: null }] },
                    { title: 'MI Date', fields: [{ type: 'doc', fieldId: 'CX.UW.ID.MIEXP', value: null }] },
                    { title: 'USDA Conditional Commitment Expiration', fields: [{ type: 'doc', fieldId: 'CX.UW.ID.USDAEXPIRE', value: null }] },
                    { title: 'Document Date', fields: [{ type: 'doc', fieldId: 'L770', value: null }] },
                ],
                docPurchaseFields: [
                    { title: 'PA Date (Purchase) or Original Purchase Date (Refi)', fields: [{ fieldId: '1518', value: null }, { fieldId: 'CX.UW.PAEXPIRES', value: null }]}
                ],
                docFieldsList: ['CX.UW.CREDITDATE', 'CX.UW.ID.CREDITEXP', 'CX.UW.ID.CREDITREFRESH', 'CX.UW.ID.CREDITREFRESHEXP', 'CX.UW.ID.BINCOME', 'CX.UW.ID.BINCOMEEXP', 'CX.UW.ID.OVERRIDE1',
                    'CX.UW.ID.CINCOME', 'CX.UW.ID.CINCOMEEXP', 'CX.UW.ID.OVERRIDE2', 'CX.UW.ID.ASSETS', 'CX.UW.ID.ASSESTSEXP', 'CX.UW.ID.OVERRIDE3', 'CX.UW.ID.BVOE1', 'CX.UW.ID.VOE1EXP', 'CX.UW.ID.OVERRIDE4',
                    'CX.UW.ID.BVOE2', 'CX.UW.ID.BVOE2EXP', 'CX.UW.ID.OVERRIDE5', 'CX.UW.ID.CVOE1', 'CX.UW.ID.CVOE1EXP', 'CX.UW.ID.OVERRIDE6', 'CX.UW.ID.CVOE2', 'CX.UW.ID.CVOE2EXP', 'CX.UW.ID.OVERRIDE7', 
                    'CX.UW.ID.APPRAISAL', 'CX.UW.ID.APPRAISALEXP', 'CX.UW.ID.OVERRIDE8', 'CX.UW.ID.CPL', 'CX.UW.ID.CPLEXP', 'CX.UW.ID.HOI', 'CX.UW.ID.HOIEXP', 'CX.UW.ID.FHACASENUM', 'CX.UW.ID.MASTER', 'CX.UW.ID.MASTEREXP',
                    'CX.UW.ID.OVERRIDE12', 'CX.UW.ID.FLOOD', 'CX.UW.ID.FLOODEXP', 'CX.UW.ID.OVERRIDE10', 'CX.UW.ID.MASTERFLOOD', 'CX.UW.ID.MASTERFLOODEXP', 'CX.UW.ID.OVERRIDE11', 'CX.UW.ID.PAYOFFEXP',
                    'CX.UW.ID.MIEXP', 'CX.UW.ID.USDAEXPIRE', 'L770', '1518', 'CX.UW.PAEXPIRES'],
                doesSelects: ['Does', 'Does not'],
                emd: null,
                errorMsg: '',
                errorTitle: '',
                fhaAgencyTypeSelects: ['HUD / FHA', 'VA'],
                fhaAttachmentId: null,
                fhaAttachments: [],
                fhaBorrowerCertOneSelects: ['The statement of appraised value as determined by HUD / FHA', 'The reasonable value of the property as determined by V.A.'],
                fhaBorrowerCertTwoSelects: ['I was not aware of this valuation when I signed my contract', 'I was aware of this valuation when I signed my contract'],
                fhaOccupancySelects: ['I now actually occupy the above property as my home', 'I, the Borrower or Co-Borrower will occupy the property within 60 days of signing the security instrument, and intend to continue occupancy for at least one year',
                    'I do not intend to occupy the property as my primary residence', 'My spouse is on active military duty and I occupy', 'I am active duty and my dependent child occupies home', 'I previously occupied the property as my home',
                    'While my spouse was on active military duty...I previously', 'I was on active military duty...my dependent child occupied home'],
                fhaRefiFields: [
                    { label: 'Date', value: null, id: '3042', type: 'date', iterate: true, section: 'FHA Case Number' },
                    { label: 'Case Number', value: null, id: '1040', type: 'input', iterate: true, section: 'FHA Case Number' },
                    { label: 'By', value: null, id: '3059', type: 'input', iterate: true, section: 'FHA Case Number' },
                    { label: 'Date', value: null, id: '3064', type: 'date', iterate: true, section: 'Refi Authorization' },
                    { label: 'Old FHA Case #', value: null, id: '3066', type: 'input', iterate: true, section: 'Refi Authorization' },
                    { label: 'By', value: null, id: '3065', type: 'input', iterate: true, section: 'Refi Authorization' },
                    { label: 'MI Premium Refund', value: null, id: '1134', type: 'numeric', dec: true, iterate: true, section: 'Refi Authorization' },
                    { label: 'Prior Endorsement Date', value: null, id: '3432', type: 'date', iterate: true, section: 'Refi Authorization' },
                    { label: 'Date', value: null, id: '3071', type: 'date', iterate: true, section: 'Total Scorecard' },
                    { label: 'Risk Class', value: null, id: '3029', iterate: false, radioGroup: 4 },
                    { masterLabel: 'Risk Class', id: null, type: 'radio', iterate: true, radioGroup: 4, section: 'Total Scorecard', items: [
                        { label: 'A/A', value: 'A/A' }, { label: 'Refer', value: 'Refer' }] },
                    { label: 'By', value: null, id: '3072', type: 'input', iterate: true, section: 'Total Scorecard' },
                    { label: 'Eligibility Assessment', value: null, id: '3631', iterate: false, radioGroup: 5 },
                    { masterLabel: 'Eligibility Assessment', id: null, type: 'radio', iterate: true, radioGroup: 5, section: 'Total Scorecard', items: [
                        { label: 'Eligible', value: 'Eligible' }, { label: 'Ineligible', value: 'Ineligible' }] },
                    { label: 'Date', value: null, id: '3073', type: 'date', iterate: true, section: 'Condo PUD Lookup' },
                    { label: 'Condo / PUD ID', value: null, id: '3075', type: 'input', iterate: true, section: 'Condo PUD Lookup' },
                    { label: 'By', value: null, id: '3074', type: 'input', iterate: true, section: 'Condo PUD Lookup' }
                ],
                fhaRefiFieldsList: ['3042', '3059', '1040', '3064', '3065', '3066', '1134', '3432', '3071', '3072', '3029', '3631', '3073', '3074', '3075'],
                vaLoanSummaryFields: [
                  //Header
                  { label: 'VA Case #', value: null, id: '1040', type: 'input', iterate: true, section: 'header', isDisabled: false },
                  //Borrower
                  { label: 'First Name', value: null, id: 'VASUMM.X32', type: 'input', iterate: true, section: 'borrower', isDisabled: true },
                  { label: 'Last Name', value: null, id: 'VASUMM.X33', type: 'input', iterate: true, section: 'borrower', isDisabled: true },
                  { label: 'Sex', value: null, id: 'VASUMM.X35', type: 'input', iterate: true, section: 'borrower', isDisabled: true },
                  { label: 'Date of Birth', value: null, id: 'VASUMM.X1', type: 'input', iterate: true, section: 'borrower', isDisabled: true },
                  //CoBorrower
                  { label: 'First Name', value: null, id: '4004', type: 'input', iterate: true, section: 'coborrower', isDisabled: true },
                  { label: 'Last Name', value: null, id: '4006', type: 'input', iterate: true, section: 'coborrower', isDisabled: true },
                  { label: 'Sex', value: null, id: 'VASUMM.X35', type: 'input', iterate: true, section: 'coborrower', isDisabled: true },
                  { label: 'Date of Birth', value: null, id: '1403', type: 'date', iterate: true, section: 'coborrower', isDisabled: true },
                  //Entitlement
                  { label: 'Entitlement Code', value: null, id: 'VASUMM.X2', type: 'input', iterate: true, section: 'entitlement', isDisabled: false },
                  { label: 'Entitlement Amount', value: null, id: 'VASUMM.X3', type: 'numeric', iterate: true, section: 'entitlement', isDisabled: false },
                  { label: 'Branch of Service', value: null, id: '954', type: 'dropdown', iterate: true, section: 'entitlement', isDisabled: false, options: ['AirForce', 'Army', 'CoastGuard', 'Marines', 'Navy', 'SpaceForce'] },
                  { label: 'Status', value: null, id: '955', type: 'dropdown', iterate: true, section: 'entitlement', isDisabled: false, options: ['SeparatedFromService', 'InService'] },
                  //Loan/Property Info
                  { label: 'First Time Homebuyer', value: null, id: '934', type: 'dropdown', iterate: true, section: 'loanprop', isDisabled: true, options: ['Yes', 'No'] },
                  { label: 'Loan Procedure', value: null, id: '953', type: 'dropdown', iterate: true, section: 'loanprop', isDisabled: false, options: ['Automatic', 'Auto-IRRRL', 'VAPriorApproval'] }, //check this
                  { label: 'Purpose of Loan', value: null, id: '956', type: 'dropdown', iterate: true, section: 'loanprop', isDisabled: false, options: ['Home', 'ManufacturedHome', 'Condominium', "Alterations/Improvements", "Refinance"] }, //check this
                  { label: 'Loan Code', value: null, id: '958', type: 'dropdown', iterate: true, section: 'loanprop', isDisabled: false, options: ['Purchase', 'IRRRLStreamlineRefi', 'CashoutRefi'] }, //check this
                  { label: 'Prior Loan Type', value: null, id: 'VASUMM.X50', type: 'dropdown', iterate: true, section: 'loanprop', isDisabled: false, options: ['FHAFixed', 'FHAARMHARM', 'ConventionalFixed', 'Conventional-ARM/HARM', 'ConventionalInterestOnly', 'VAFixed', 'VAARMHARM', 'Other'] }, //check this
                  { label: 'Type of Mortgage', value: null, id: '959', type: 'dropdown', iterate: true, section: 'loanprop', isDisabled: false, options: ['RegularFixedPayment', 'GPM', 'OtherGPMs', 'GEM', 'TemporaryBuydown', 'HybridARM', 'ARM'] }, //check this
                  { label: 'Type of Hybrid-ARM', value: null, id: 'VASUMM.X24', type: 'dropdown', iterate: true, section: 'loanprop', isDisabled: false, options: ['3/1', '5/1', '7/1', '10/1'] }, //check this
                  { label: 'Type of Ownership', value: null, id: '957', type: 'dropdown', iterate: true, section: 'loanprop', isDisabled: false, options: ['Sole Ownership', 'Joint - 2 Or More Veterans', 'JointVetNonVet'] }, //check this
                  { label: 'Closing Date', value: null, id: '748', type: 'date', iterate: true, section: 'loanprop', isDisabled: false },
                  { label: 'Purchase Price', value: null, id: '136', type: 'numeric', iterate: true, section: 'loanprop', isDisabled: false },
                  { label: 'Reasonable Value', value: null, id: '356', type: 'numeric', iterate: true, section: 'loanprop', isDisabled: false },
                  { label: 'None', value: null, id: '376', type: 'checkbox', iterate: true, section: 'loanpropcheck', isDisabled: false },
                  { label: 'Addition of Feature', value: null, id: '379', type: 'checkbox', iterate: true, section: 'loanpropcheck', isDisabled: false },
                  { label: 'Solar Heating / Cooling', value: null, id: '377', type: 'checkbox', iterate: true, section: 'loanpropcheck', isDisabled: false },
                  { label: 'Insulation, Caulking', value: null, id: '380', type: 'checkbox', iterate: true, section: 'loanpropcheck', isDisabled: false },
                  { label: 'Replacement of System', value: null, id: '378', type: 'checkbox', iterate: true, section: 'loanpropcheck', isDisabled: false },
                  { label: 'Other Improvements', value: null, id: '381', type: 'checkbox', iterate: true, section: 'loanpropcheck', isDisabled: false },
                  { label: 'Amount Spent on Energy Improvements', value: null, id: '961', type: 'numeric', iterate: true, section: 'loanpropcheck', isDisabled: false },
                  { label: 'Loan Amount', value: null, id: '2', type: 'numeric', iterate: true, section: 'loanpropcont', isDisabled: true },
                  { label: 'Property Type', value: null, id: '1041', type: 'dropdown', iterate: true, section: 'loanpropcont', isDisabled: false, options: ['PUD', 'Condominium'] }, //check this
                  { label: 'Appraisal Type', value: null, id: '962', type: 'dropdown', iterate: true, section: 'loanpropcont', isDisabled: false, options: ['IND-Single Prop-Ind Appraisal', 'MCRV', 'LAPP-Lender', 'MBL-Manufactured Home', 'HUD-HUD Conversion', 'PMC-Property Management Case' ] }, //check this
                  { label: 'Type of Structure', value: null, id: '986', type: 'dropdown', iterate: true, section: 'loanpropcont', isDisabled: false, options: ['Conventional', 'Singlewide M/H', 'Doublewide M/H', 'M/H Lot Only', 'Prefabricated Home', 'Condominium Conversion' ] }, //check this
                  { label: 'Prop Designation', value: null, id: '988', type: 'dropdown', iterate: true, section: 'loanpropcont', isDisabled: false, options: ['Existing', 'Proposed Construction', 'New Existing-Never Occupied', 'Energy Improvements'] }, //check this
                  { label: 'Number of Units', value: null, id: '16', type: 'numeric', iterate: true, section: 'loanpropcont', isDisabled: false },
                  { label: 'MCRV #', value: null, id: '989', type: 'input', iterate: true, section: 'loanpropcont', isDisabled: false }, 
                  { label: 'Mfg Home', value: null, id: '963', type: 'dropdown', iterate: true, section: 'loanpropcont', isDisabled: false, options: ['MH on Permanent Foundation', 'MHOnlyVeteranOwnedLot', 'MHOnlyRentedSpace', 'OtherNotMH' ] }, 
                  { label: 'Property Address', value: null, id: '11', type: 'input', iterate: true, section: 'loanpropcont', isDisabled: true }, 
                  { label: 'City', value: null, id: '12', type: 'input', iterate: true, section: 'loanpropcont', isDisabled: false },
                  { label: 'State', value: null, id: '14', type: 'input', iterate: true, section: 'loanpropcont', isDisabled: false }, 
                  { label: 'Zip', value: null, id: '15', type: 'input', iterate: true, section: 'loanpropcont', isDisabled: false }, 
                  { label: 'County', value: null, id: '13', type: 'input', iterate: true, section: 'loanpropcont', isDisabled: false }, 
                  { label: 'Lender VA ID ', value: null, id: '1059', type: 'input', iterate: true, section: 'loanpropcont', isDisabled: false }, 
                  { label: 'Agent VA ID', value: null, id: '1060', type: 'input', iterate: true, section: 'loanpropcont', isDisabled: false }, 
                  { label: 'Lender Loan #', value: null, id: '305', type: 'input', iterate: true, section: 'loanpropcont', isDisabled: false }, 
                  //LAPP Cases Only
                  { label: 'Lender SAR ID', value: null, id: 'VASUMM.X6', type: 'input', iterate: true, section: 'lapp', isDisabled: false },
                  { label: 'Property Gross Living Area', value: null, id: 'VASUMM.X7', type: 'input', iterate: true, section: 'lapp', isDisabled: false },
                  { label: 'Age of Property', value: null, id: 'VASUMM.X8', type: 'input', iterate: true, section: 'lapp', isDisabled: false },
                  { label: 'Date SAR Issued Value', value: null, id: 'VASUMM.X9', type: 'date', iterate: true, section: 'lapp', isDisabled: false },
                  { label: 'Total Rooms', value: null, id: 'VASUMM.X10', type: 'input', iterate: true, section: 'lapp', isDisabled: false },
                  { label: 'Baths', value: null, id: 'VASUMM.X11', type: 'input', iterate: true, section: 'lapp', isDisabled: false },
                  { label: 'Bedrooms', value: null, id: 'VASUMM.X12', type: 'input', iterate: true, section: 'lapp', isDisabled: false },
                  { label: 'Was the fee Appraisers Original Value Estimate Changed?', value: null, id: 'VASUMM.X13', type: 'dropdown', iterate: true, section: 'lapp', isDisabled: false, options: ['No', 'Yes' ] },
                  //Income
                  { label: 'Loan processed under VA recognized automated underwriting system?', value: null, id: 'VASUMM.X4', type: 'dropdown', iterate: true, section: 'income', isDisabled: false, options: ['No', 'Yes'] },
                  { label: 'Which system was used?', value: null, id: 'VASUMM.X17', type: 'dropdown', iterate: true, section: 'income', isDisabled: false, options: ['LP', 'DU', 'PMI AURA', 'CLUES', 'ZIPPY' ] }, //check this
                  { label: 'Risk Classification', value: null, id: 'VASUMM.X21', type: 'dropdown', iterate: true, section: 'income', isDisabled: false, options: ['APPROVE', 'REFER' ] },
                  { label: 'Credit Score', value: null, id: 'VASUMM.X23', type: 'numeric', iterate: true, section: 'income', isDisabled: false },
                  { label: 'Liquid Assets', value: null, id: '915', type: 'numeric', iterate: true, section: 'income', isDisabled: true },
                  { label: 'Total Mthly Gross Inc', value: null, id: '993', type: 'numeric', iterate: true, section: 'income', isDisabled: true },
                  { label: 'Residual Income', value: null, id: '1325', type: 'numeric', iterate: true, section: 'income', isDisabled: true },
                  { label: 'Residual Income Guideline', value: null, id: '1340', type: 'numeric', iterate: true, section: 'income', isDisabled: false },
                  { label: 'Debt-Income Ratio', value: null, id: '1341', type: 'numeric', iterate: true, section: 'income', isDisabled: true },
                  { label: 'Spouse Income Considered?', value: null, id: '1006', type: 'dropdown', iterate: true, section: 'income', isDisabled: false, options: ['Yes', 'No'] },
                  { label: 'Spouses Income', value: null, id: '1008', type: 'numeric', iterate: true, section: 'income', isDisabled: true },
                  //Discount Information
                  { label: 'Total Discount Points Charged', value: null, id: 'VASUMM.X47', type: 'numeric', iterate: true, section: 'discount', isDisabled: false }, // TODO Add or $ field
                  { label: 'Discount Points Paid by Veteran', value: null, id: 'VASUMM.X48', type: 'numeric', iterate: true, section: 'discount', isDisabled: false }, // TODO Add or $ field
                  { label: 'Term', value: null, id: '4', type: 'numeric', iterate: true, section: 'discount', isDisabled: false },
                  { label: 'Interest Rate', value: null, id: '3', type: 'numeric', iterate: true, section: 'discount', isDisabled: false },
                  { label: 'Funding Fee', value: null, id: '990', type: 'dropdown', iterate: true, section: 'discount', isDisabled: false, options: ['Y', 'N'] },
                  //IRRRLs Only
                  { label: 'Paid in Full VA Loan Number', value: null, id: 'VASUMM.X14', type: 'input', iterate: true, section: 'IRRRL', isDisabled: false }, //TODO FIX numeric here
                  { label: 'Original Loan Amount', value: null, id: 'VASUMM.X15', type: 'numeric', iterate: true, section: 'IRRRL', isDisabled: false },
                  { label: 'Original Int Rate', value: null, id: 'VASUMM.X16', type: 'numeric', iterate: true, section: 'IRRRL', isDisabled: false },
                  { label: 'Original Term', value: null, id: 'VASUMM.X18', type: 'numeric', iterate: true, section: 'IRRRL', isDisabled: false },
                  //Remarks
                  { label: 'Remark 1', value: null, id: 'VASUMM.X37', type: 'input', iterate: true, section: 'remarks', isDisabled: false },
                  { label: 'Remark 2', value: null, id: 'VASUMM.X38', type: 'input', iterate: true, section: 'remarks', isDisabled: false },
                  { label: 'Remark 3', value: null, id: 'VASUMM.X39', type: 'input', iterate: true, section: 'remarks', isDisabled: false },
                  { label: 'Remark 4', value: null, id: 'VASUMM.X40', type: 'input', iterate: true, section: 'remarks', isDisabled: false },
                  { label: 'Remark 5', value: null, id: 'VASUMM.X41', type: 'input', iterate: true, section: 'remarks', isDisabled: false },
                  { label: 'Remark 6', value: null, id: 'VASUMM.X42', type: 'input', iterate: true, section: 'remarks', isDisabled: false },
                  { label: 'Remark 7', value: null, id: 'VASUMM.X43', type: 'input', iterate: true, section: 'remarks', isDisabled: false },
                ],

                vaRasonableValueFields: [
                  //Section 1
                  { label: 'VA Loan Identification Number (LIN)', value: null, id: '1040', type: 'input', iterate: true, section: 'reasonablevaluesection1', isDisabled: false },
                  { label: 'APN/Lot Number', value: null, id: '2973', type: 'input', iterate: true, section: 'reasonablevaluesection1', isDisabled: false },
                  { label: 'Lattitude/Longitude Grid', value: null, id: '4860', type: 'input', iterate: true, section: 'reasonablevaluesection1', isDisabled: false },
                  { label: 'Property Address Line One', value: null, id: '11', type: 'input', iterate: true, section: 'reasonablevaluesection1', isDisabled: true },
                  { label: 'Property Address City', value: null, id: '12', type: 'input', iterate: true, section: 'reasonablevaluesection1', isDisabled: false },
                  { label: 'Property Address State', value: null, id: '14', type: 'input', iterate: true, section: 'reasonablevaluesection1', isDisabled: false },
                  { label: 'Property Address Line Two', value: null, id: '3258', type: 'input', iterate: true, section: 'reasonablevaluesection1', isDisabled: false },
                  { label: 'Property Address County', value: null, id: '13', type: 'input', iterate: true, section: 'reasonablevaluesection1', isDisabled: false },
                  { label: 'Property Address Zip Code', value: null, id: '15', type: 'input', iterate: true, section: 'reasonablevaluesection1', isDisabled: false },
                  { label: 'Single Family Residence', value: null, id: '602', type: 'dropdown', iterate: true, section: 'reasonablevaluesection1', isDisabled: false, options: ['Single Family Residence', 'Manufactured Home', 'Condo', 'Multi-Family Residence'] },
                  { label: 'Property Leasehold?', value: null, id: '4861', type: 'dropdown', iterate: true, section: 'reasonablevaluesection1', isDisabled: false, options: ['Y', 'N'] },
                  { label: 'Verified By USPS?', value: null, id: '4862', type: 'dropdown', iterate: true, section: 'reasonablevaluesection1', isDisabled: false, options: ['Y', 'N'] },
                  //Section 2
                  { label: 'Appraisal Type', value: null, id: '4863', type: 'dropdown', iterate: true, section: 'reasonablevaluesection2', isDisabled: false, options: ['Purchase', 'Refinance', 'Liquidation', 'Other' ] },
                  { label: 'Loan Use (If Applicable)', value: null, id: '4864', type: 'dropdown', iterate: true, section: 'reasonablevaluesection2', isDisabled: false, options: ['Renovation', 'Construction', 'Energy Efficient Mortgage (EEM)', 'Other'] },
                  { label: 'Building Status', value: null, id: '601', type: 'dropdown', iterate: true, section: 'reasonablevaluesection2', isDisabled: false, options: ['Proposed', 'New/Under Construction', 'Existing', 'Other' ] },
                  { label: 'Sales Price', value: null, id: '136', type: 'numeric', iterate: true, section: 'reasonablevaluesection2', isDisabled: false },
                  //Section 2 - New or Proposed Construction
                  { label: 'Builder Name', value: null, id: '713', type: 'input', iterate: true, section: 'reasonablevaluesection2newprop', isDisabled: false },
                  { label: 'Builder ID Numer', value: null, id: '3348', type: 'input', iterate: true, section: 'reasonablevaluesection2newprop', isDisabled: false },
                  { label: 'Builder Telephone Number', value: null, id: '718', type: 'phone', iterate: true, section: 'reasonablevaluesection2newprop', isDisabled: false },
                  //Section 3 - Special Instructions
                  { label: 'Veteran/Seller Works Nights', value: null, id: '4865', type: 'checkbox', iterate: true, section: 'reasonablevaluesection3specialinstructions', isDisabled: false },
                  { label: 'Pets On Premises', value: null, id: '4866', type: 'checkbox', iterate: true, section: 'reasonablevaluesection3specialinstructions', isDisabled: false },
                  { label: 'House Alarm', value: null, id: '4867', type: 'checkbox', iterate: true, section: 'reasonablevaluesection3specialinstructions', isDisabled: false },
                  { label: 'Gated Community', value: null, id: '4868', type: 'checkbox', iterate: true, section: 'reasonablevaluesection3specialinstructions', isDisabled: false },
                  { label: 'Special Energy Efficiency', value: null, id: '4869', type: 'checkbox', iterate: true, section: 'reasonablevaluesection3specialinstructions', isDisabled: false },
                  //Section 3 - Other Instructions
                  { label: 'Other Special Instructions Or Invoice Information (Please Describe)', value: null, id: '4870', type: 'textarea', iterate: true, section: 'reasonablevaluesection3', isDisabled: false },
                  { label: 'Number of Pages in Uploaded Sales Contract', value: null, id: '4871', type: 'input', iterate: true, section: 'reasonablevaluesection3', isDisabled: false },
                  //Section 4
                  { label: 'Lender POC Name', value: null, id: '1256', type: 'input', iterate: true, section: 'reasonablevaluesection4', isDisabled: false },
                  { label: 'Lender POC Phone Number', value: null, id: '1262', type: 'phone', iterate: true, section: 'reasonablevaluesection4', isDisabled: false },
                  { label: 'Lender POC Email', value: null, id: '95', type: 'email', iterate: true, section: 'reasonablevaluesection4', isDisabled: false },
                  { label: 'Veteran/Borrower First Name', value: null, id: 'VASUMM.X32', type: 'input', iterate: true, section: 'reasonablevaluesection4', isDisabled: true },
                  { label: 'Veteran/Borrower Last Name', value: null, id: 'VASUMM.X33', type: 'input', iterate: true, section: 'reasonablevaluesection4', isDisabled: true },
                  { label: 'Veteran/Borrower Phone Number', value: null, id: '66', type: 'phone', iterate: true, section: 'reasonablevaluesection4', isDisabled: false },
                  { label: 'Veteran/Borrower Email', value: null, id: '1240', type: 'email', iterate: true, section: 'reasonablevaluesection4', isDisabled: false },
                  { label: 'Buyer Agent POC Name', value: null, id: 'VEND.X139', type: 'input', iterate: true, section: 'reasonablevaluesection4', isDisabled: false },
                  { label: 'Buyer Agent POC Phone Number', value: null, id: 'VEND.X140', type: 'phone', iterate: true, section: 'reasonablevaluesection4', isDisabled: false },
                  { label: 'Buyer Agent POC Email', value: null, id: 'VEND.X141', type: 'email', iterate: true, section: 'reasonablevaluesection4', isDisabled: false },
                  { label: 'Seller Agent POC Name', value: null, id: 'VEND.X150', type: 'input', iterate: true, section: 'reasonablevaluesection4', isDisabled: false },
                  { label: 'Seller Agent POC Phone Number', value: null, id: 'VEND.X151', type: 'phone', iterate: true, section: 'reasonablevaluesection4', isDisabled: false },
                  { label: 'Seller Agent POC Email', value: null, id: 'VEND.X152', type: 'email', iterate: true, section: 'reasonablevaluesection4', isDisabled: false },
                  { label: 'Seller/Home Owner POC Name', value: null, id: '727', type: 'input', iterate: true, section: 'reasonablevaluesection4', isDisabled: false },
                  { label: 'Seller/Home Owner POC Phone Number', value: null, id: '4878', type: 'phone', iterate: true, section: 'reasonablevaluesection4', isDisabled: false },
                  { label: 'Seller/Home Owner POC Email', value: null, id: '4879', type: 'email', iterate: true, section: 'reasonablevaluesection4', isDisabled: false },
                  { label: 'Builder Sales Office POC Name', value: null, id: '714', type: 'input', iterate: true, section: 'reasonablevaluesection4', isDisabled: false },
                  { label: 'Builder Sales Office POC Phone Number', value: null, id: '718', type: 'phone', iterate: true, section: 'reasonablevaluesection4', isDisabled: false },
                  { label: 'Builder Sales Office POC Email', value: null, id: '94', type: 'email', iterate: true, section: 'reasonablevaluesection4', isDisabled: false },
                  { label: 'Tidewater POC Name', value: null, id: '4872', type: 'input', iterate: true, section: 'reasonablevaluesection4', isDisabled: false },
                  { label: 'Tidewater POC Phone Number', value: null, id: '4873', type: 'phone', iterate: true, section: 'reasonablevaluesection4', isDisabled: false },
                  { label: 'Tidewater POC Email', value: null, id: '4874', type: 'email', iterate: true, section: 'reasonablevaluesection4', isDisabled: false },
                  //Section 5 - Requester Information
                  { label: 'Business/Lender Name', value: null, id: '1264', type: 'input', iterate: true, section: 'reasonablevaluesection5', isDisabled: false },
                  { label: 'Requester Name', value: null, id: '1256', type: 'input', iterate: true, section: 'reasonablevaluesection5', isDisabled: false },
                  { label: 'Requester Title', value: null, id: 'GAPPR.X5', type: 'input', iterate: true, section: 'reasonablevaluesection5', isDisabled: false },
                  { label: 'Requester Phone Number', value: null, id: '324', type: 'phone', iterate: true, section: 'reasonablevaluesection5', isDisabled: false },
                  { label: 'Requester Email', value: null, id: '95', type: 'email', iterate: true, section: 'reasonablevaluesection5', isDisabled: false },
                  { label: 'Business/Lender Street Address Line One', value: null, id: '1257', type: 'input', iterate: true, section: 'reasonablevaluesection5', isDisabled: false },
                  { label: 'Business/Lender Address City', value: null, id: '1258', type: 'input', iterate: true, section: 'reasonablevaluesection5', isDisabled: false },
                  { label: 'Business/Lender Street Address Line Two', value: null, id: '4875', type: 'input', iterate: true, section: 'reasonablevaluesection5', isDisabled: false },
                  { label: 'Business/Lender Address State', value: null, id: '1259', type: 'input', iterate: true, section: 'reasonablevaluesection5', isDisabled: false },
                  { label: 'Business/Lender Zip Code', value: null, id: '1260', type: 'numeric', iterate: true, section: 'reasonablevaluesection5', isDisabled: false },
                  { label: 'Institution Case Number', value: null, id: '352', type: 'input', iterate: true, section: 'reasonablevaluesection5', isDisabled: false },
                  { label: 'Sponsor Type', value: null, id: '4876', type: 'dropdown', iterate: true, section: 'reasonablevaluesection5', isDisabled: false, options: ['Servicer', 'Lender'] },
                  { label: 'Sponsor ID', value: null, id: '1060', type: 'input', iterate: true, section: 'reasonablevaluesection5', isDisabled: false },
                  { label: 'Can Assisted Appraisal Processing Program (AAPP) Be Utilized on this Appraisal Assignment? ', value: null, id: '4877', type: 'dropdown', iterate: true, section: 'reasonablevaluesection5', isDisabled: false, options: ['Y', 'N'] },
                  //Section 6 - Veteran/Borrower Information
                  { label: 'Veteran First Name', value: null, id: 'VASUMM.X32', type: 'input', iterate: true, section: 'reasonablevaluesection6', isDisabled: true },
                  { label: 'Veteran Middle/Last Name', value: null, id: 'VASUMM.X33', type: 'input', iterate: true, section: 'reasonablevaluesection6', isDisabled: true },
                  { label: 'Other Borrower Name(s)', value: null, id: '1873', type: 'input', iterate: true, section: 'reasonablevaluesection6', isDisabled: false },
                  { label: 'Veteran Address Line One', value: null, id: 'VAELIG.X75', type: 'input', iterate: true, section: 'reasonablevaluesection6', isDisabled: true },
                  { label: 'Veteran Address Line Two', value: null, id: '4859', type: 'input', iterate: true, section: 'reasonablevaluesection6', isDisabled: false },
                  { label: 'Veteran Address City', value: null, id: 'VAELIG.X76', type: 'input', iterate: true, section: 'reasonablevaluesection6', isDisabled: true },
                  { label: 'Veteran Address State', value: null, id: 'VAELIG.X77', type: 'input', iterate: true, section: 'reasonablevaluesection6', isDisabled: true },
                  { label: 'Veteran Address Zip Code', value: null, id: 'VAELIG.X78', type: 'input', iterate: true, section: 'reasonablevaluesection6', isDisabled: true },
                  { label: 'Veteran Phone Number', value: null, id: 'VAELIG.X74', type: 'input', iterate: true, section: 'reasonablevaluesection6', isDisabled: true },
                  { label: 'Veteran Email Address', value: null, id: 'VAELIG.X97', type: 'input', iterate: true, section: 'reasonablevaluesection6', isDisabled: true },
                  //Section 7 - Certification for Submission to VA
                  { label: 'Person Authorizing Request Title', value: null, id: 'GAPPR.X5', type: 'input', iterate: true, section: 'reasonablevaluesection7', isDisabled: false },
                  { label: 'Appraisal Request Date', value: null, id: '363', type: 'date', iterate: true, section: 'reasonablevaluesection7', isDisabled: false },
                  
                ],

                vaDisbursementFields: [
                  //Top Section
                  { label: 'Automatic Procedure', value: null, id: 'VASUMM.X51', type: 'checkbox', iterate: true, section: 'disbursement', isDisabled: false },
                  { label: 'Prior Approval Procedure', value: null, id: 'VASUMM.X52', type: 'checkbox', iterate: true, section: 'disbursement', isDisabled: false },
                  { label: 'VA Loan #', value: null, id: '1040', type: 'input', iterate: true, section: 'disbursement', isDisabled: false },
                  { label: 'Lenders Loan #', value: null, id: '364', type: 'input', iterate: true, section: 'disbursement', isDisabled: false },
                  { label: 'Lenders VA ID #', value: null, id: '1059', type: 'input', iterate: true, section: 'disbursement', isDisabled: false },
                  { label: 'Date of Report', value: null, id: 'L770', type: 'date', iterate: true, section: 'disbursement', isDisabled: false },
                  { label: 'Insurance Type', value: null, id: '3642', type: 'dropdown', iterate: true, section: 'disbursement', isDisabled: false, options: ['Guaranty', 'Insurance'] },
                  //Section 1 - Purpose, Amount, Terms and Security for Loan
                  { label: 'VA Loan Purpose', value: null, id: 'VASUMM.X155', type: 'dropdown', iterate: true, section: 'disbursementsection1', isDisabled: false, options: ['Interest Rate Reduction Refinance', 'Cash Out Refinance', 'Construction - Two-Time Closing', 'Construction - One-Time Closing', 'Alteration & Repair', 'Purchase Manufactured Home (Not Permanently Affixed)', 'Purchase a Condominium', 'Purchase a 2-4 Unit Home', 'Purchase an Existing Home (Includes Manufactured Homes Permanently Affixed)' ] },
                  { label: 'Address of Property Securing Loan', value: null, id: '11', type: 'input', iterate: true, section: 'disbursementsection1', isDisabled: true },
                  { label: 'City', value: null, id: '12', type: 'input', iterate: true, section: 'disbursementsection1', isDisabled: false },
                  { label: 'State', value: null, id: '14', type: 'input', iterate: true, section: 'disbursementsection1', isDisabled: false },
                  { label: 'Zip', value: null, id: '15', type: 'input', iterate: true, section: 'disbursementsection1', isDisabled: false },
                  { label: 'Lot', value: null, id: '2973', type: 'input', iterate: true, section: 'disbursementsection1', isDisabled: false },
                  { label: 'Block', value: null, id: '2974', type: 'input', iterate: true, section: 'disbursementsection1', isDisabled: false },
                  { label: 'Subdivision', value: null, id: '1079', type: 'input', iterate: true, section: 'disbursementsection1', isDisabled: false },
                  //Section 1 - Terms
                  { label: 'Loan Amount', value: null, id: '2', type: 'numeric', iterate: true, section: 'disbursementsection1terms', isDisabled: false },
                  { label: 'Interest Rate', value: null, id: '3', type: 'numeric', iterate: true, section: 'disbursementsection1terms', isDisabled: false },
                  { label: 'Term of Loan (Months)', value: null, id: '4', type: 'numeric', iterate: true, section: 'disbursementsection1terms', isDisabled: false },
                  { label: 'Amortization Type', value: null, id: '959', type: 'dropdown', iterate: true, section: 'disbursementsection1terms', isDisabled: false, options: ['RegularFixedPayment', 'GPM', 'OtherGPMs', 'GEM', 'TemporaryBuydown', 'HybridARM', 'ARM'] },
                  { label: 'ARM Type', value: null, id: 'VASUMM.X24', type: 'dropdown', iterate: true, section: 'disbursementsection1terms', isDisabled: false, options: ['3/1', '5/1', '7/1', '10/1'] }, //check this
                  { label: 'Principal & Interest Per Period', value: null, id: '5', type: 'input', iterate: true, section: 'disbursementsection1terms', isDisabled: true },
                  { label: 'Closing Date', value: null, id: '748', type: 'date', iterate: true, section: 'disbursementsection1terms', isDisabled: false },
                  { label: 'Date Loan Proceeds Fully Paid Out', value: null, id: '2553', type: 'date', iterate: true, section: 'disbursementsection1terms', isDisabled: false },
                  { label: 'Date of First Payment', value: null, id: '682', type: 'date', iterate: true, section: 'disbursementsection1terms', isDisabled: false },
                  { label: 'Date of Maturity', value: null, id: '78', type: 'date', iterate: true, section: 'disbursementsection1terms', isDisabled: false },
                  { label: 'Date of Note', value: null, id: 'L770', type: 'date', iterate: true, section: 'disbursementsection1terms', isDisabled: false },
                  //Section 1 - Type of Lien
                  { label: 'Type of Lien', value: null, id: '420', type: 'dropdown', iterate: true, section: 'disbursementsection1lien', isDisabled: false, options: ['First Realty', 'Second Realty'] }, //check this
                  { label: 'First Chattel', value: null, id: 'VASUMM.X53', type: 'checkbox', iterate: true, section: 'disbursementsection1lien', isDisabled: false },
                  { label: 'Unsecured', value: null, id: 'VASUMM.X54', type: 'checkbox', iterate: true, section: 'disbursementsection1lien', isDisabled: false },
                  { label: 'Other', value: null, id: 'VASUMM.X55', type: 'checkbox', iterate: true, section: 'disbursementsection1lien', isDisabled: false },
                  { label: 'Other (Fill In)', value: null, id: 'VASUMM.X56', type: 'input', iterate: true, section: 'disbursementsection1lien', isDisabled: false },
                  //Section 1 - Estate in Property Is
                  { label: 'Estate Property Is', value: null, id: '1066', type: 'dropdown', iterate: true, section: 'disbursementsection1estate', isDisabled: false, options: ['Fee Simple', 'Leasehold'] }, //check this
                  { label: 'Other', value: null, id: 'VASUMM.X57', type: 'checkbox', iterate: true, section: 'disbursementsection1estate', isDisabled: false },
                  { label: 'Other (Fill In)', value: null, id: 'VASUMM.X58', type: 'input', iterate: true, section: 'disbursementsection1estate', isDisabled: false },
                  { label: 'If Leasehold, enter expiration date', value: null, id: '1034', type: 'date', iterate: true, section: 'disbursementsection1estate', isDisabled: false },
                  { label: 'Title of Property is Vested In:', value: null, id: '1497', type: 'dropdown', iterate: true, section: 'disbursementsection1estate', isDisabled: false, options: ['Veteran', 'Veteran and Veteran', 'Veteran and Spouse', 'Veteran and Non-Veteran', 'Other'] }, //check this
                  { label: 'Other (Fill In)', value: null, id: '1064', type: 'input', iterate: true, section: 'disbursementsection1estate', isDisabled: false },
                  { label: 'Discount Points Charged', value: null, id: 'NEWHUD2.X927', type: 'input', iterate: true, section: 'disbursementsection1estate', isDisabled: true },
                  { label: 'Discount Points Financed (IRRRL Only)', value: null, id: 'VARRRWS.X3', type: 'input', iterate: true, section: 'disbursementsection1estate', isDisabled: true },
                  //Section 1 - For Refinances Only
                  { label: 'Loan Being Refinanced Modified:', value: null, id: 'VASUMM.X150', type: 'dropdown', iterate: true, section: 'disbursementsection1refi', isDisabled: false, options: ['N', 'Y'] }, //check this
                  { label: 'Modified Interest Rate', value: null, id: 'VASUMM.X151', type: 'numeric', iterate: true, section: 'disbursementsection1refi', isDisabled: false },
                  { label: 'Modified Term', value: null, id: 'VASUMM.X152', type: 'numeric-whole', iterate: true, section: 'disbursementsection1refi', isDisabled: false },
                  { label: 'Original Amortization Type', value: null, id: 'VASUMM.X20', type: 'dropdown', iterate: true, section: 'disbursementsection1refi', isDisabled: false, options: ['Fixed', 'GraduatedPaymentMortgage', 'AdjustableRate', 'OtherAmortizationType' ] }, //check this
                  { label: 'Current Rate If Loan Being Refinanced was an ARM', value: null, id: 'VASUMM.X16', type: 'numeric', iterate: true, section: 'disbursementsection1refi', isDisabled: false },
                  //Section 1 - Continued
                  { label: 'Amounted of Energy Efficiency Mortgage', value: null, id: '961', type: 'numeric-currency', iterate: true, section: 'disbursementsection1cont', isDisabled: false },
                  { label: 'None', value: null, id: '376', type: 'checkbox', iterate: true, section: 'disbursementsection1cont', isDisabled: false },
                  { label: 'Addition of Feature', value: null, id: '379', type: 'checkbox', iterate: true, section: 'disbursementsection1cont', isDisabled: false },
                  { label: 'Solar Heating / Cooling', value: null, id: '377', type: 'checkbox', iterate: true, section: 'disbursementsection1cont', isDisabled: false },
                  { label: 'Insulation, Caulking', value: null, id: '380', type: 'checkbox', iterate: true, section: 'disbursementsection1cont', isDisabled: false },
                  { label: 'Replacement of System', value: null, id: '378', type: 'checkbox', iterate: true, section: 'disbursementsection1cont', isDisabled: false },
                  { label: 'Other Improvements', value: null, id: '381', type: 'checkbox', iterate: true, section: 'disbursementsection1cont', isDisabled: false },
                  { label: 'Annual Real Estate Taxes', value: null, id: '1031', type: 'numeric-currency', iterate: true, section: 'disbursementsection1cont', isDisabled: false }, //check this
                  { label: 'Hazard Face Amount', value: null, id: 'VEND.X445', type: 'numeric-currency', iterate: true, section: 'disbursementsection1cont', isDisabled: false },//check this
                  { label: 'Hazard Annual Premium', value: null, id: 'HUD42', type: 'numeric-currency', iterate: true, section: 'disbursementsection1cont', isDisabled: true },//check this
                  { label: 'Flood Face Amount', value: null, id: 'VEND.X446', type: 'numeric-currency', iterate: true, section: 'disbursementsection1cont', isDisabled: false },//check this
                  { label: 'Flood Annual Premium', value: null, id: 'HUD44', type: 'numeric-currency', iterate: true, section: 'disbursementsection1cont', isDisabled: true },//check this
                  { label: 'Annual Special Assessment', value: null, id: 'VASUMM.X59', type: 'numeric-currency', iterate: true, section: 'disbursementsection1cont', isDisabled: false },//check this
                  { label: 'Total Unpaid Special Assessments', value: null, id: 'VASUMM.X60', type: 'numeric-currency', iterate: true, section: 'disbursementsection1cont', isDisabled: false },//check this
                  { label: 'Homeowners Assn. Mo. Dues', value: null, id: '233', type: 'numeric-currency', iterate: true, section: 'disbursementsection1cont', isDisabled: false },
                  { label: 'Describe nonrealty, if any, acquired with proceeds of loan', value: null, id: 'VASUMM.X61', type: 'textarea', iterate: true, section: 'disbursementsection1cont', isDisabled: false },
                  { label: 'Amount withheld from loan proceeds and deposited in', value: null, id: 'VASUMM.X65', type: 'dropdown', iterate: true, section: 'disbursementsection1cont', isDisabled: false, options: ['Escrow', 'Earmarked Account'] }, //check this
                  { label: 'Amount', value: null, id: 'VASUMM.X66', type: 'numeric-currency', iterate: true, section: 'disbursementsection1cont', isDisabled: false },
                  { label: 'Items to be completed as part of the escrow', value: null, id: 'VASUMM.X153', type: 'textarea', iterate: true, section: 'disbursementsection1cont', isDisabled: false },
                  { label: 'Date Acquired (If land acquired by separate transaction)', value: null, id: 'VASUMM.X63', type: 'date', iterate: true, section: 'disbursementsection1estate', isDisabled: false },
                  { label: 'Purchase Price (If land acquired by separate transaction)', value: null, id: 'VASUMM.X64', type: 'numeric-currency', iterate: true, section: 'disbursementsection1cont', isDisabled: false },
                  //Section 2 - Lenders Certification
                  { label: 'Name', value: null, id: '322', type: 'input', iterate: true, section: 'disbursementsection2', isDisabled: false },
                  { label: 'Address', value: null, id: '1795', type: 'input', iterate: true, section: 'disbursementsection2', isDisabled: false },
                  { label: 'City', value: null, id: '684', type: 'input', iterate: true, section: 'disbursementsection2', isDisabled: false },
                  { label: 'State', value: null, id: '1797', type: 'input', iterate: true, section: 'disbursementsection2', isDisabled: false },
                  { label: 'Function', value: null, id: '1796', type: 'input', iterate: true, section: 'disbursementsection2', isDisabled: false },
                  { label: 'Function', value: null, id: '1798', type: 'input', iterate: true, section: 'disbursementsection2', isDisabled: false },
                  //Section 2 - Lender's Certification
                  { label: 'Any construction, repairs, alterations, or improvements upon which the reasonable value of the property is predicated and which were not inspected and approved subsequent to completion by a compliance inspector designated by the Secretary have been completed properly.', value: null, id: 'VASUMM.X67', type: 'checkbox', iterate: true, section: 'disbursementsection2cert', isDisabled: false },
                  //Section 2 - VA Approved UW Required
                  { label: 'Name of Underwriter', value: null, id: '2984', type: 'input', iterate: true, section: 'disbursementsection2uwapproved', isDisabled: false },
                  { label: 'Underwriter VA ID Number', value: null, id: 'VASUMM.X154', type: 'input', iterate: true, section: 'disbursementsection2uwapproved', isDisabled: false },
                  //Section 2 - Lender Information
                  { label: 'Comapny Name', value: null, id: '3632', type: 'input', iterate: true, section: 'disbursementsection2lender', isDisabled: false },
                  { label: 'Address', value: null, id: '3633', type: 'input', iterate: true, section: 'disbursementsection2lender', isDisabled: false },
                  { label: 'City', value: null, id: '3634', type: 'input', iterate: true, section: 'disbursementsection2lender', isDisabled: false },
                  { label: 'State', value: null, id: '3635', type: 'input', iterate: true, section: 'disbursementsection2lender', isDisabled: false },
                  { label: 'Zip', value: null, id: '3636', type: 'input', iterate: true, section: 'disbursementsection2lender', isDisabled: false },
                  { label: 'Lender Phone', value: null, id: '1262', type: 'input', iterate: true, section: 'disbursementsection2lender', isDisabled: false },
                  //Section 3 - Veteran's Certification
                  {
                    label: 'Occupancy', value: null, id: '1065', type: 'dropdown', iterate: true, section: 'disbursementsection3', isDisabled: false, //check this//check this//check this
                    options: ['ActuallyOccupyPropertyAsMyHome', 'SpouseOnActiveMilitaryDuty', 'VeteranOnActiveMilitaryDuty', 'PreviouslyOccupiedTheProperty', 'PreviouslyOccupiedWhileSpouseOnActiveMilitaryDuty', 'PreviouslyDependentOccupiedWhileVeteranOnActiveMilitaryDuty' ]
                  },
                  { label: 'I have been informed that the following is the reasonable value of the property as determined by VA:', value: null, id: '356', type: 'numeric- whole', iterate: true, section: 'disbursementsection3', isDisabled: false },
                  //Section 3 - Contract Price or Cost Exceeds VA Reasonable Value
                  {
                    label: 'Choose One', value: null, id: '1399', type: 'dropdown', iterate: true, section: 'disbursementsection3exceeds', isDisabled: false, //check this//check this//check this
                    options: ['AwareOfThisValuation', 'NotAwareOfThisValuation']
                  },
                  { label: 'I certify that I have not been discharged or released from active duty since the date of my Certificate of Eligibility was issued.', value: null, id: 'VASUMM.X156', type: 'checkbox', iterate: true, section: 'disbursementsection3certrequired', isDisabled: false },
                  { label: 'If the COE indicates it is subject to continued Reserve/National Guard Service, I the undersigned Veteran certify I have not been discharged or released from Reserve/National Guard Service since the COE was issued.', value: null, id: 'VASUMM.X157', type: 'checkbox', iterate: true, section: 'disbursementsection3certrequired', isDisabled: false },
                  { label: 'If the COE indicates it is subject to my eligibility as an unmarried surviving spouse, I the undersigned spouse, certify that my status has not changed since the COE was issued. ', value: null, id: 'VASUMM.X158', type: 'checkbox', iterate: true, section: 'disbursementsection3certrequired', isDisabled: false },


                ],
                vaFieldsList: ['1040', 'VASUMM.X32', 'VASUMM.X33', 'VASUMM.X35', 'VASUMM.X1', 'VASUMM.X2', 'VASUMM.X3', '954', '955', '934', '953', '956', '958',
                  'VASUMM.X50', '959', 'VASUMM.X24', '957', '748', '136', '356', '376', '379', '377', '380', '378', '381', '961', '2', '1041', '962', '986', '988',
                  '16', '989', '963', '11', '12', '14', '15', '13', '1059', '1060', '305', 'VASUMM.X6', 'VASUMM.X7', 'VASUMM.X8', 'VASUMM.X9', 'VASUMM.X10',
                  'VASUMM.X11', 'VASUMM.X12', 'VASUMM.X13', 'VASUMM.X4', 'VASUMM.X17', 'VASUMM.X21', 'VASUMM.X23', '915', '993', '1325', '1340', '1341', '1006',
                  '1008', 'VASUMM.X47', 'VASUMM.X48', '4', '3', '990', 'VASUMM.X14', 'VASUMM.X15', 'VASUMM.X16', 'VASUMM.X18', 'VASUMM.X37', 'VASUMM.X38',
                  'VASUMM.X39', 'VASUMM.X40', 'VASUMM.X41', 'VASUMM.X42', 'VASUMM.X43', '1040', '2973', '4860', '11', '12', '14', '3258', '13', '15', '602',
                  '4861', '4862', '4863', '4864', '601', '136', '713', '3348', '718', '4865', '4866', '4867', '4868', '4869', '4870', '4871', '1256', '1262', '95',
                  '66', '1240', 'VEND.X139', 'VEND.X140', 'VEND.X141', 'VEND.X150', 'VEND.X151', 'VEND.X152', '727', '4878', '4879', '714', '718', '94', '4872',
                  '4873', '4874', '1264', 'GAPPR.X5', '324', '95', '1257', '1258', '4875', '1259', '1260', '352', '4876', '1060', '4877', 'VASUMM.X32',
                  'VASUMM.X33', '1873', 'VAELIG.X75', '4859', 'VAELIG.X76', 'VAELIG.X77', 'VAELIG.X78', 'VAELIG.X74', 'VAELIG.X97', 'GAPPR.X5', '363', 'VASUMM.X51',
                  'VASUMM.X52', '1040', '364', '1059', 'L770', '3642', 'VASUMM.X155', '11', '12', '14', '15', '2973', '2974', '1079', '2', '3', '4', '959',
                  'VASUMM.X24', '5', '748', '2553', '682', '78', 'L770', '420', 'VASUMM.X53', 'VASUMM.X54', 'VASUMM.X55', 'VASUMM.X56', '1066', 'VASUMM.X57',
                  'VASUMM.X58', '1034', '1497', '1064', 'NEWHUD2.X927', 'VARRRWS.X3', 'VASUMM.X150', 'VASUMM.X151', 'VASUMM.X152', 'VASUMM.X20', 'VASUMM.X16',
                  '961', '376', '379', '377', '380', '378', '381', '1031', 'VEND.X445', 'HUD42', 'VEND.X446', 'HUD44', 'VASUMM.X59', 'VASUMM.X60', '233',
                  'VASUMM.X61', 'VASUMM.X65', 'VASUMM.X66', 'VASUMM.X153', 'VASUMM.X63', 'VASUMM.X64', '322', '1795', '684', '1797', '1796', '1798', 'VASUMM.X67',
                  '2984', 'VASUMM.X154', '3632', '3633', '3634', '3635', '3636', '1262', '1065', '356', '1399', 'VASUMM.X156', 'VASUMM.X157', 'VASUMM.X158',



                ],

                fhaRefundCondition: null,
                fhaSigningDocs: [],
                fhaSigningDocsBase64: [
                    { loanId: null, documentName: '*UW* HUD/VA 1003 Addendum - 92900A', file: null, fileName: 'HUD 1003 Addendum', documentId: null, contentType: 'application/pdf', applicationNumber: 1, applicationId: null },
                    { loanId: null, documentName: '*UW* Conditional Commitment  - 92800.5b', file: null, fileName: 'HUD-928005b Conditional Commitment', documentId: null, contentType: 'application/pdf', applicationNumber: 1, applicationId: null },
                    { loanId: null, documentName: '*UW* Loan Transmittal - 92900LT', file: null, fileName: 'HUD-92900LT FHA Loan Transmittal', documentId: null, contentType: 'application/pdf', applicationNumber: 1, applicationId: null },
                    { loanId: null, documentName: '*UW* HUD/VA 1003 Addendum - 92900A', file: null, fileName: 'HUD 1003 Addendum', documentId: null, contentType: 'application/pdf', applicationNumber: 2, applicationId: null },
                    { loanId: null, documentName: '*UW* Conditional Commitment  - 92800.5b', file: null, fileName: 'HUD-928005b Conditional Commitment', documentId: null, contentType: 'application/pdf', applicationNumber: 2, applicationId: null },
                    { loanId: null, documentName: '*UW* Loan Transmittal - 92900LT', file: null, fileName: 'HUD-92900LT FHA Loan Transmittal', documentId: null, contentType: 'application/pdf', applicationNumber: 2, applicationId: null },
                    { loanId: null, documentName: '*UW* HUD/VA 1003 Addendum - 92900A', file: null, fileName: 'HUD 1003 Addendum', documentId: null, contentType: 'application/pdf', applicationNumber: 3, applicationId: null },
                    { loanId: null, documentName: '*UW* Conditional Commitment  - 92800.5b', file: null, fileName: 'HUD-928005b Conditional Commitment', documentId: null, contentType: 'application/pdf', applicationNumber: 3, applicationId: null },
                    { loanId: null, documentName: '*UW* Loan Transmittal - 92900LT', file: null, fileName: 'HUD-92900LT FHA Loan Transmittal', documentId: null, contentType: 'application/pdf', applicationNumber: 3, applicationId: null }
                ],
                fhaSigningDocsSelects: [
                    { display: 'HUD 1003 Addendum (App 1)', docName: 'HUD/V.A. Addendum to Uniform Residential Loan Application', applicationNumber: 1 },
                    { display: 'HUD-928005b Conditional Commitment (App 1)', docName: 'HUD-92800.5B Appraised Value', applicationNumber: 1 },
                    { display: 'HUD-92900LT FHA Loan Transmittal (App 1)', docName: 'FHA Loan Transmittal', applicationNumber: 1 }
                ],
                fhaSigningDocsSelectsApp2: [
                    { display: 'HUD 1003 Addendum (App 2)', docName: 'HUD/V.A. Addendum to Uniform Residential Loan Application', applicationNumber: 2 },
                    { display: 'HUD-928005b Conditional Commitment (App 2)', docName: 'HUD-92800.5B Appraised Value', applicationNumber: 2 },
                    { display: 'HUD-92900LT FHA Loan Transmittal (App 2)', docName: 'FHA Loan Transmittal', applicationNumber: 2 }
                ],
                fhaSigningDocsSelectsApp3: [
                    { display: 'HUD 1003 Addendum (App 3)', docName: 'HUD/V.A. Addendum to Uniform Residential Loan Application', applicationNumber: 3 },
                    { display: 'HUD-928005b Conditional Commitment (App 3)', docName: 'HUD-92800.5B Appraised Value', applicationNumber: 3 },
                    { display: 'HUD-92900LT FHA Loan Transmittal (App 3)', docName: 'FHA Loan Transmittal', applicationNumber: 3 }
                ],
                fhaSummaryFields: [
                    { label: 'FHA Case #', value: null, id: '1040', type: 'input', iterate: true, section: 'lt' },
                    { label: 'SOA', value: null, id: '1039', type: 'dropdown', selects: [], iterate: true, section: 'lt' },
                    { label: 'Property Type', value: null, id: '2996', iterate: false, radioGroup: 1 },
                    { masterLabel: 'Property Type', label: '1 Unit', value: '1 Unit', id: null, type: 'radio', iterate: true, radioGroup: 1, checked: false, section: 'Property Information' },
                    { masterLabel: 'Property Type', label: '2 Units', value: '2 Units', id: null, type: 'radio', iterate: true, radioGroup: 1, checked: false, section: 'Property Information' },
                    { masterLabel: 'Property Type', label: '3-4 Units', value: '3-4 Units', id: null, type: 'radio', iterate: true, radioGroup: 1, checked: false, section: 'Property Information' },
                    { masterLabel: 'Property Type', label: 'Condominium', value: 'Condominium', id: null, type: 'radio', iterate: true, radioGroup: 1, checked: false, section: 'Property Information' },
                    { masterLabel: 'Property Type', label: 'Co-Operative', value: 'Co-Operative', id: null, type: 'radio', iterate: true, radioGroup: 1, checked: false, section: 'Property Information' },
                    { masterLabel: 'Property Type', label: 'Manufactured Housing', value: 'Manufactured Housing', id: null, type: 'radio', iterate: true, radioGroup: 1, checked: false, section: 'Property Information' },
                    { label: 'Source / EIN', value: null, id: '3001', type: 'input', iterate: true, section: 'Secondary Financing' },
                    { label: "Gov't", value: null, id: '3002', type: 'checkbox', iterate: true, section: 'Secondary Financing' },
                    { label: 'NP', value: null, id: '3003', type: 'checkbox', iterate: true, section: 'Secondary Financing' },
                    { label: 'Family', value: null, id: '3004', type: 'checkbox', iterate: true, section: 'Secondary Financing' },
                    { label: 'Other', value: null, id: '3005', type: 'checkbox', iterate: true, section: 'Secondary Financing' },
                    { label: '', value: null, id: '3006', type: 'input', iterate: true, section: 'Secondary Financing' },
                    { label: 'Amount of Secondary Financing', value: null, id: '3007', type: 'numeric', iterate: true, section: 'Secondary Financing' },
                    { label: 'Seller Funded DAP', value: null, id: '3008', type: 'checkbox', iterate: false, section: 'Gifts' },
                    { label: 'Source / EIN', value: null, id: '3009', type: 'input', iterate: true, section: 'Gifts', group: 1 },
                    { label: "Gov't", value: null, id: '3010', type: 'checkbox', iterate: true, section: 'Gifts', group: 1 },
                    { label: 'NP', value: null, id: '3011', type: 'checkbox', iterate: true, section: 'Gifts', group: 1 },
                    { label: 'Family', value: null, id: '3012', type: 'checkbox', iterate: true, section: 'Gifts', group: 1 },
                    { label: 'Other', value: null, id: '3013', type: 'checkbox', iterate: true, section: 'Gifts', group: 1 },
                    { label: '', value: null, id: '3014', type: 'input', iterate: true, section: 'Gifts', group: 1 },
                    { label: 'Amount of Gift', value: null, id: '3015', type: 'numeric', iterate: true, section: 'Gifts', group: 1 },
                    { label: 'Source / EIN', value: null, id: '3016', type: 'input', iterate: true, section: 'Gifts', group: 2 },
                    { label: "Gov't", value: null, id: '3017', type: 'checkbox', iterate: true, section: 'Gifts', group: 2 },
                    { label: 'NP', value: null, id: '3018', type: 'checkbox', iterate: true, section: 'Gifts', group: 2 },
                    { label: 'Family', value: null, id: '3019', type: 'checkbox', iterate: true, section: 'Gifts', group: 2 },
                    { label: 'Other', value: null, id: '3020', type: 'checkbox', iterate: true, section: 'Gifts', group: 2 },
                    { label: '', value: null, id: '3021', type: 'input', iterate: true, section: 'Gifts', group: 2 },
                    { label: 'Amount of Gift', value: null, id: '3022', type: 'numeric', iterate: true, section: 'Gifts', group: 2 },
                    { label: 'Borrower', value: null, id: '1018', type: 'input', iterate: false, section: 'Qualifying Ratios' },
                    { label: 'Co-Borrower', value: null, id: '1144', type: 'input', iterate: false, section: 'Qualifying Ratios' },
                    { label: 'CHUMS ID #', value: null, id: '980', type: 'input', iterate: false, section: 'QualifyingRatios' },
                    { label: '', value: null, id: '1216', type: 'input', iterate: true, section: 'Underwriter Comments' },
                    { label: '', value: null, id: '1217', type: 'input', iterate: true, section: 'Underwriter Comments' },
                    { label: '', value: null, id: '1218', type: 'input', iterate: true, section: 'Underwriter Comments' },
                    { label: '', value: null, id: '1219', type: 'input', iterate: true, section: 'Underwriter Comments' },
                    { label: '', value: null, id: '1220', type: 'input', iterate: true, section: 'Underwriter Comments' },
                    { label: '', value: null, id: '1221', type: 'input', iterate: true, section: 'Underwriter Comments' },
                    { label: '', value: null, id: '1222', type: 'input', iterate: true, section: 'Underwriter Comments' },
                    { label: '', value: null, id: '1829', type: 'input', iterate: true, section: 'Underwriter Comments' },
                    { label: 'CHUMS ID# For Reviewer of Appraisal', value: null, id: '3030', type: 'input', iterate: false, section: 'Risk Assessment' },
                    { label: '', value: null, id: '34', type: 'dropdown', iterate: false },
                    { label: 'Action Date', value: null, id: '1038', type: 'date', iterate: false, section: 'Commitment Terms' },
                    { label: 'Commitment Issued', value: null, id: '1068', type: 'date', iterate: false, section: 'Commitment Terms' },
                    { label: 'Commitment Expires', value: null, id: '1072', type: 'date', iterate: false, section: 'Commitment Terms' },
                    { label: 'Agency Type', value: null, id: '1711', type: 'dropdown', iterate: false, section: 'addendum' },
                    { label: 'Purpose of Loan', value: null, id: '28', iterate: false, radioGroup: 2, section: 'Purpose of Loan' },
                    { masterLabel: 'Purpose of Loan', label: '1. Purchase Home (Previously Occupied)', value: 'Purchase Home (Prev Occupied)', id: null, type: 'radio', iterate: true, radioGroup: 2, checked: false, section: 'Purpose of Loan' },
                    { masterLabel: 'Purpose of Loan', label: '2. Finance Improvement', value: 'Finance Improvement', id: null, type: 'radio', iterate: true, radioGroup: 2, checked: false, section: 'Purpose of Loan' },
                    { masterLabel: 'Purpose of Loan', label: '3. Refinance', value: 'Refinance', id: null, type: 'radio', iterate: true, radioGroup: 2, checked: false, section: 'Purpose of Loan' },
                    { masterLabel: 'Purpose of Loan', label: '4. Purchase New Condo Unit', value: 'Purchase New Condo Unit', id: null, type: 'radio', iterate: true, radioGroup: 2, checked: false, section: 'Purpose of Loan' },
                    { masterLabel: 'Purpose of Loan', label: '5. Purchase Existing Condo Unit', value: 'Purchase Existing Condo Unit', id: null, type: 'radio', iterate: true, radioGroup: 2, checked: false, section: 'Purpose of Loan' },
                    { masterLabel: 'Purpose of Loan', label: '6. Purchase Home (Not Previously Occupied)', value: 'Purchase Home (Not Prev Occupied)', id: null, type: 'radio', iterate: true, radioGroup: 2, checked: false, section: 'Purpose of Loan' },
                    { masterLabel: 'Purpose of Loan', label: '7. Construct Home', value: 'Construct Home', id: null, type: 'radio', iterate: true, radioGroup: 2, checked: false, section: 'Purpose of Loan' },
                    { masterLabel: 'Purpose of Loan', label: '8. Finance Co-op Purchase', value: 'Finance Co-op Purchase', id: null, type: 'radio', iterate: true, radioGroup: 2, checked: false, section: 'Purpose of Loan' },
                    // { masterLabel: 'Purpose of Loan', label: '9. Purchase Manufactured Home', value: 'Purchase Manufactured Home', id: null, type: 'radio', iterate: true, radioGroup: 2, checked: false, section: 'Purpose of Loan' },
                    // { masterLabel: 'Purpose of Loan', label: '10. Purchase Manufactured Home & Lot', value: 'Purchase Manufactured Home & Lot', id: null, type: 'radio', iterate: true, radioGroup: 2, checked: false, section: 'Purpose of Loan' },
                    // { masterLabel: 'Purpose of Loan', label: '11. Refi. Manufactured Home to Buy Lot', value: 'Refi. Manufactured Home to Buy Lot', id: null, type: 'radio', iterate: true, radioGroup: 2, checked: false, section: 'Purpose of Loan' },
                    // { masterLabel: 'Purpose of Loan', label: '12. Refi. Manufactured Home / Lot Loan', value: 'Refi. Manufactured Home / Lot Loan', id: null, type: 'radio', iterate: true, radioGroup: 2, checked: false, section: 'Purpose of Loan' },
                    { label: 'Modified/Approved', value: null, id: '3175', iterate: false, radioGroup: 3, section: 'Modified/Approved' },
                    { masterLabel: 'Modified/Approved', label: 'Approved (subject to additional conditions below)', value: 'Approved', id: null, type: 'radio', iterate: true, radioGroup: 3, checked: false, section: 'Modified/Approved' },
                    { masterLabel: 'Modified/Approved', label: 'Modified & Approved as Follows', value: 'Modified And Approved', id: null, type: 'radio', iterate: true, radioGroup: 3, checked: false, section: 'Modified/Approved' },
                    { label: 'Loan Amount (incl. UFMIP)', value: null, id: '3178', type: 'numeric', dec: true, iterate: true, section: 'Approved & Additional Conditions'},
                    { label: 'Interest Rate', value: null, id: '3179', type: 'numeric', dec: true, iterate: true, section: 'Approved & Additional Conditions'},
                    { label: 'Proposed Maturity', value: null, id: '3180', type: 'numeric', dec: false, iterate: false, section: 'Approved & Additional Conditions'},
                    { label: 'Proposed Maturity', value: null, id: '3181', type: 'numeric', dec: false, iterate: false, section: 'Approved & Additional Conditions'},
                    { label: 'Monthly Payment', value: null, id: '3182', type: 'numeric', dec: true, iterate: false, section: 'Approved & Additional Conditions'},
                    { label: 'Date Mortgage Approved', value: null, id: '3176', type: 'date', iterate: false, section: 'Approved & Additional Conditions'},
                    { label: 'Amt of Up Front Premium', value: null, id: '3183', type: 'numeric', dec: true, iterate: true, section: 'Approved & Additional Conditions'},
                    { label: 'Amt of Monthly Premium', value: null, id: '3184', type: 'numeric', dec: true, iterate: true, section: 'Approved & Additional Conditions'},
                    { label: 'Term of Annual Premium', value: null, id: '3196', type: 'numeric', dec: false, iterate: false, section: 'Approved & Additional Conditions'},
                    { label: 'Date Approval Expires', value: null, id: '3177', type: 'date', iterate: false, section: 'Approved & Additional Conditions'},
                    { label: 'If this is a proposed construction, the builder has certified compliance with HUD requirements on form HUD-92541', value: null, id: '3185', type: 'checkbox', iterate: true, section: 'Additional Conditions' },
                    { label: "If this is new construction, the lender certified that the property is 100% complete (both on site and off site improvements) and the property meets HUD's minimum property standards and local building codes", value: null, id: '3186', type: 'checkbox', iterate: true, section: 'Additional Conditions' },
                    { label: "Form HUD-92544, Builder's Warranty is required", value: null, id: '3187', type: 'checkbox', iterate: true, section: 'Additional Conditions' },
                    { label: 'The property has a 10-year warranty', value: null, id: '3188', type: 'checkbox', iterate: true, section: 'Additional Conditions' },
                    { label: "Owner-Occupancy Not required (item (b) of the Borrower's Certificate does not apply)", value: null, id: '3189', type: 'checkbox', iterate: true, section: 'Additional Conditions' },
                    { label: 'All conditions of Approval have been satisfied', value: null, id: '4092', type: 'checkbox', iterate: true, section: 'Additional Conditions' },
                    { label: 'The mortgage is a high loan-to-value ratio for non-occupant mortgagor', value: null, id: '3190', type: 'checkbox', iterate: true, section: 'Additional Conditions' },
                    { label: 'Other (specify)', value: null, id: '3191', type: 'checkbox', iterate: true, section: 'Additional Conditions' },
                    { label: '', value: null, id: '3192', type: 'textarea', iterate: true, section: 'Additional Conditions'},
                    { label: "This mortgage was rated as an 'accept' or 'approve' by FHA's Total Mortgage Scorecard", value: null, id: '3193', type: 'checkbox', iterate: true, section: 'Additional Conditions' },
                    { label: 'Mortgagee Representative', value: null, id: '3194', type: 'input', iterate: true, section: 'Additional Conditions' },
                    { label: "This mortgage was rated as a 'refer' by a FHA's Total Morgage Scorecard, and/or was manually underwritten by a Direct Endorsement underwriter", value: null, id: '3195', type: 'checkbox', iterate: true, section: 'Additional Conditions' },
                    { label: 'Do you own / sold other real estate?', value: null, id: '900', type: 'yesnodropdown', section: 'Borrower Certification' },
                    { label: 'Is it to be sold?', value: null, id: '933', type: 'yesnodropdown', section: 'Borrower Certification' },
                    { label: 'Sale Price', value: null, id: '687', type: 'numeric', dec: true, section: 'Borrower Certification' },
                    { label: 'Original Mfg Amount', value: null, id: '744', type: 'numeric', dec: true, section: 'Borrower Certification' },
                    { label: 'Street', value: null, id: '461', type: 'input', section: 'Borrower Certification' },
                    { label: 'City', value: null, id: '1738', type: 'input', section: 'Borrower Certification' },
                    { label: 'State', value: null, id: '1739', type: 'input', section: 'Borrower Certification' },
                    { label: 'Zip', value: null, id: '1740', type: 'input', section: 'Borrower Certification' },
                    { label: 'If the dwelling to be covered by?', value: null, id: '1016', type: 'yesnodropdown', section: 'Borrower Certification' },
                    { label: 'Do you own more than four dwellings?', value: null, id: '1017', type: 'yesnodropdown', section: 'Borrower Certification' },
                    { label: 'Have you ever had a VA home loan?', value: null, id: '1398', type: 'yesnodropdown', section: 'Borrower Certification' },
                    { label: '(2) Occupancy', value: null, id: '1065', type: 'dropdown', selects: [], section: 'Borrower Certification'},
                    { label: '(3) I have been informed that', value: null, id: '356', type: 'numeric', dec: false, section: 'Borrower Certification' },
                    { label: '', value: null, id: '1639', type: 'dropdown', selects: [], section: 'Borrower Certification'},
                    { label: '', value: null, id: '1399', type: 'dropdown', selects: [], section: 'Borrower Certification'},
                    { label: '(6) For HUD Only - I have received information on lead paint poisoning', value: null, id: '1400', type: 'yesnodropdown', section: 'Borrower Certification' },
                    { label: 'Name', value: null, id: '1754', type: 'input', section: 'Borrower Certification' },
                    { label: 'Title', value: null, id: '1755', type: 'input', section: 'Borrower Certification' },
                    { label: 'Phone', value: null, id: '1756', type: 'input', section: 'Borrower Certification' },
                    { label: '', value: null, id: '153', type: 'dropdown', selects: [], section: 'Borrower Certification' },
                    { label: 'Logged Date', value: null, id: '3076', type: 'date', section: 'Appraisal' },
                    { label: 'By', value: null, id: '3077', type: 'input', section: 'Appraisal' }
                ],
                fhaSummaryFieldsList: ['1040', '1039', '2996', '3001', '3002', '3003', '3004', '3005', '3006', '3007', '3008', '3009', '3010', '3011', '3012', '3013', '3014', '3015', 
                    '3016', '3017', '3018', '3019', '3020', '3021', '3022', '34', '1018', '1144', '980', '1216', '1217', '1218', '1219', '1220', '1221', '1222', '1829', '3030',
                    '1038', '1068', '1072', '1711', '28', '3175', '3178', '3179', '3180', '3181', '3182', '3176', '3183', '3184', '3196', '3177', '3185', '3186', '3187', '3188', '3189', '4092',
                    '3190', '3191', '3192', '3193', '3194', '3195', '900', '933', '687', '744', '461', '1738', '1739', '1740', '1016', '1017', '1398', '1065', '356', '1639', '1399', '1400',
                    '1754', '1755', '1756', '153', '3076', '3077'],
                fhaRefiTab: {
                    title: 'FHA Tracking',
                    content: 'tracking'
                },
                fhaSigningRequest: {
                    entity: {
                        entityType: 'urn:elli:encompass:loan',
                        entityId: ''
                    },
                    scope: {
                        entityType: 'urn:elli:encompass:loan:borrower',
                        entityId: ''
                    },
                    printMode: 'LoanData',
                    forms: [
                        { type: 'Standard', source: 'HUD/V.A. Addendum to Uniform Residential Loan Application' },
                        { type: 'Standard', source: 'HUD-92800.5B Appraised Value' },
                        { type: 'Standard', source: 'FHA Loan Transmittal' }
                    ]
                },
                fhaTabs: [
                    {
                        title: 'Loan Transmittal',
                        content: 'loanTransmittal'
                    },
                    {
                        title: "Cond'l Commitment",
                        content: 'conditionalCommitment'
                    },
                    {
                        title: 'Addendum',
                        content: 'addendum'
                    }
                ],
                filteredProcessors: [],
                giftGrantsColumns: [
                    { field: 'assetType', title: 'Type' },
                    { field: 'owner', title: 'Belong To' },
                    { field: 'source', title: 'Source' },
                    { field: 'deposited', title: 'Deposited' },
                    { field: 'amount', title: 'Total', format: '{0:c2}' }
                ],
                homeReadyDropdownSelects: ['Home Ready', 'Home Possible' ],
                isAttachmentLoading: false,
                isFhaAttachmentLoading: false,
                isVaAttachmentLoading: false,
                isFhaDocLoading: false,
                isLoading: false,
                isLoadingAUS: false,
                isLoadingBorrowerFunds: false,
                liabilitiesToBePaidCondition: null,
                loanData: null,
                loanProgram: '',
                miAttachmentId: null,
                monthlyPaymentCondition: null,
                monthlyPaymentTotal: null,
                newCondition: {
                    ConditionType: 'Underwriting',
                    Title: '',
                    internalDescription: '',
                    externalDescription: '',
                    priorTo: '',
                    id: ''
                },
                notificationMsg: '',
                otherAssetsColumns: [
                    { field: 'holderName', title: 'Title' },
                    { field: 'borrowerType', title: 'Belong To' },
                    { field: 'assetType', title: 'Type' },
                    { field: 'otherDescription', title: 'Description' },
                    { field: 'cashOrMarketValue', title: 'Total', format: '{0:c2}' }
                ],
                panelItems: [
                    {
                        title: 'Supporting Documents',
                        content: 'attachmentsgrid',
                        expanded: false
                    }
                ],
                processors: [],
                progressAnimation: { duration: 500},
                progressCount: 0,
                progressInterval: null,
                progressNotification: 'AUS Is Running...',
                progressNotificationTab: false,
                progressNotificationTabMsg: '',
                progressValue: 0,
                projectTypeSelects: ['III Condo', 'II Condo', 'I Condo', 'One Cooperative', 'Two Cooperative', 'T Cooperative', 'E/PUD', 'F/PUD', 'T/PUD', 'III PUD',
                    'P/Limited Review New Detach', 'Q/Limited Review Est.', 'R/Expedited New', 'S/Expedited Est.', 'T/Fannie Mae Review', 'U/FHA-approved', 'V/Refi Plus',
                    'Detached Project', '2-To-4-Unit Project', 'Reciprocal Review', 'Approved FHA/VA Condominium Project Or Spot Loan', 'G/Not in a Project or Development'],
                propertyAndAppraisalFields: [
                        { label: 'Approved Escrow Holdback', value: null, id: 'CX.HOLD.AMOUNT', type: 'numeric', iterate: false, holdback: true },
                        { label: 'Required Completion Date', value: null, id: 'CX.HOLD.REQUIREDDATE', type: 'date', iterate: false, holdback: true },
                        { label: 'Inspection Ordered', value: null, id: 'CX.HOLD.FINALINSPECT', type: 'date', iterate: false, holdback: true },
                        { label: 'Inspection Received', value: null, id: 'CX.HOLD.FINALRECEIVED', type: 'date', iterate: false, holdback: true },
                        { label: 'Funds Disbursed', value: null, id: 'CX.HOLD.DISPERSED', type: 'date', iterate: false, holdback: true },
                        { label: 'Completion Date Extended', value: null, id: 'CX.HOLD.EXTENDED', type: 'date', iterate: false, holdback: true },
                        { label: 'Comments', value: null, id: 'CX.HOLD.Comments', type: 'textarea', iterate: false, holdback: true },
                        { label: 'MGR Review', value: null, id: 'CX.UW.MGRAPPREVIEW', type: 'checkbox', iterate: false },
                        { label: '', value: null, id: 'CX.AUDIT.APPRAISALREVIEW', type: 'datetime', iterate: false },
                        { label: 'Property Type', value: null, id: '1041', type: 'dropdown', selects: [], iterate: true },
                        { label: 'Property Review', value: null, id: '1541', type: 'dropdown', selects: [], iterate: true },
                        { label: 'Project Type', value: null, id: '2367', type: 'dropdown', selects: [], iterate: true },
                        { label: 'Appraisal Type', value: null, id: '2356', type: 'dropdown', selects: [], iterate: true },
                        { label: "Appraiser's Name", value: null, id: '618', type: 'input', iterate: true },
                        { label: "Appraiser's License #", value: null, id: '974', type: 'input', iterate: true },
                        { label: "Appraiser's Company Name", value: null, id: '617', type: 'input', iterate: true },
                        { label: 'Acreage', value: null, id: 'CX.UW.PROPACREAGE', type: 'numeric', iterate: true },
                        { label: 'Form Number', value: null, id: '1542', type: 'input', iterate: true },
                        { label: 'Appraisal Received', value: null, id: 'CX.IA.DATERECEIVED', type: 'date', iterate: true },
                        { label: 'CU Score', value: null, id: 'CX.UW.CUSCORE', type: 'dropdown', selects: [], iterate: true },
                        { label: 'New Construction', value: null, id: 'CX.UW.CONSTRUCTION', type: 'yesnodropdown', iterate: true },
                        { label: 'Appraiser City', value: null, id: 'CX.UW.APPRAISERCITY', type: 'input', iterate: true },
                        { label: 'Appraiser State', value: null, id: 'CX.UW.APPRAISERSTATE', type: 'input', iterate: true },
                        { label: 'Condominium', value: null, id: 'URLA.X205', type: 'nestedcheckbox', iterate: false },
                        { label: 'Cooperative', value: null, id: 'URLA.X206', type: 'nestedcheckbox', iterate: false },
                        { label: 'Planned Unit Development (PUD)', value: null, id: 'URLA.X207', type: 'nestedcheckbox', iterate: false },
                        { label: 'Property is not located in a project', value: null, id: 'URLA.X208', type: 'nestedcheckbox', iterate: false }
                ],
                propertyAndAppraisalFieldsList: ['CX.HOLD.AMOUNT', 'CX.HOLD.REQUIREDDATE', 'CX.HOLD.FINALINSPECT', 'CX.HOLD.FINALRECEIVED', 'CX.HOLD.DISPERSED', 
                    'CX.HOLD.EXTENDED', 'CX.HOLD.COMMENTS', 'CX.UW.MGRAPPREVIEW', 'CX.AUDIT.APPRAISALREVIEW', '1041', '1541', '2367', '2356', '618', '974', '617',
                    'CX.UW.PROPACREAGE', '1542', 'CX.IA.DATERECEIVED', 'CX.UW.CUSCORE', 'CX.UW.CONSTRUCTION', 'CX.UW.APPRAISERCITY', 'CX.UW.APPRAISERSTATE',
                    'URLA.X205', 'URLA.X206', 'URLA.X207', 'URLA.X208'],
                propertyReviewSelects: ['Select Option', 'Exterior / Interior', 'Exterior Only', 'No Appraisal'],
                propertyTypeSelects: ['Attached', 'Condominium', 'Co-Operative', 'Detached', 'High Rise Condominium', 'Manufactured Housing', 'PUD', 'Detached Condo',
                    'Mfd Home/Condo/PUD/Co-Op', 'MH Select'],
                qcReviewMilestoneId: null,
                quoteAttachments: [],
                refreshedFields: [],
                resubmittalMilestoneId: null,
                secondaryExecutionFields: [
                    { label: 'Was non-traditional credit used to qualify the borrower?', value: null, id: 'CX.SEQ.1', type: 'yesnodropdown' },
                    { label: 'Is Power of Attorney being used?', value: null, id: 'CX.SEQ.2', type: 'yesnodropdown' },
                    { label: 'Was the appraisal transferred from another lender?', value: null, id: 'CX.SEQ.5', type: 'yesnodropdown' },
                    { label: 'Was down payment assistance used and not provided by a government entity?', value: null, id: 'CX.SEQ.6', type: 'yesnodropdown' },
                    { label: 'Rentback Period (if applicable)', value: null, id: 'CX.SEQ.12', type: 'numeric' },
                    { label: 'Number of properties owned by borrower', value: null, id: 'CX.SEQ.16', type: 'numeric' },
                    { label: 'Does credit report have: (a) 2 tradelines w/ 12 month history OR (b) 1 tradeline w/ 12 month history and a housing reference with cancelled checks?',
                        value: null, id: 'CX.SEQ.17', type: 'yesnodropdown' },
                    { label: 'Is there pending litigation on the subject property condo association?', value: null, id: 'CX.SEQ.18', type: 'yesnodropdown' },
                    // { label: 'Flood insurance is not available for the property because the community the property is located in does not participate in NFIP. (Only allowed at Amerihome)', 
                    //     value: null, id: null, type: 'checkbox' },
                    { label: 'Was HomeOne program used?', value: null, id: 'CX.SEQ.21', type: 'yesnodropdown' },
                    { label: 'Is this a DACA Borrower?', value: null, id: 'CX.SEQ.22', type: 'yesnodropdown' },
                    { label: 'Is loan Home Ready or Home Possible?', value: null, id: 'CX.SEQ.23', type: 'homereadydropdown' },
                    { label: 'Is this a Rate and Term Refinance of an Energy Improvement Mortgage?', value: null, id: 'CX.SEQ.25', type: 'yesnodropdown' },
                    { label: 'Borrower(s) completed homeowneship education', value: null, id: 'URLA.X153', type: 'checkbox' },
                    { label: 'If HUD Approved, Provide Agency #', value: null, id: 'URLA.X155', type: 'input' },
                    { label: 'If not HUD Approved Provide Agency Name', value: null, id: 'URLA.X232', type: 'input' },
                    { label: 'Was cryptocurrency used as funds for closing?', value: null, id: 'CX.SEQ.26', type: 'yesnodropdown' },
                    { label: '(If Condo) does master contain walls in?', value: null, id: 'CX.SEQ.27', type: 'yesnodropdown' }
                ],
                secondaryExecutionFieldsList: ['CX.SEQ.1', 'CX.SEQ.2', 'CX.SEQ.5','CX.SEQ.6', 'CX.SEQ.12', 'CX.SEQ.16', 'CX.SEQ.17', 'CX.SEQ.18',
                    'CX.SEQ.21', 'CX.SEQ.22', 'CX.SEQ.23', 'CX.SEQ.25', 'URLA.X153', 'URLA.X155', 'URLA.X232', 'CX.SEQ.26', 'CX.SEQ.27'],
                selectedAttachment: { url: '', id: '' },
                selectedFHASigningDoc: { url: '', docName: 'HUD/V.A. Addendum to Uniform Residential Loan Application', display: 'HUD 1003 Addendum (App 1)', applicationNumber: 1 },
                selectedFhaTab: 0,
                selectedField: 'selected',
                selectedId: null,
                selectedProcessor: null,
                selectedVaTab: 0,
                sellerContributionCondition: null,
                sellerContTotal: 0,
                showAllAttachments: true,
                showAttachment: false,
                showErrorDialog: false,
                showEscrowHoldback: false,
                showFHADocsWarning: false,
                showLiabilitiesDialog: false,
                showPMIQuoteWarning: false,
                showVADocsWarning: false,
                soaSelects: ['184', '203B', '203B251', '203B2', '203K', '203K251', '221D2', '221D2251', '234C', '234C251', '257', '203H'],
                sortable: { allowUnsort: false, mode: 'single' },
                successNotification: false,
                vaAttachmentId: null,
                vaAttachments: [],
                vaAttachmentSort: [],
                vaTabs: [
                  {
                    title: 'Loan Summary',
                    content: 'vaLoanSummary'
                  },
                  {
                    title: 'Reasonable Value',
                    content: 'vaReasonableValue'
                  },
                  {
                    title: 'Disbursement',
                    content: 'vaDisbursement'
                  },
                  {
                    title: 'Loan Analysis',
                    content: 'vaLoanAnalysis'
                  }
                ],
                VODColumns: [
                    { field: 'bank', title: 'Bank' },
                    { field: 'owner', title: 'Belong To' },
                    { field: 'type', title: 'Account Type' },
                    { field: 'accountIdentifier', title: 'Account Number' },
                    { field: 'cashOrMarketValueAmount', title: 'Total', format: '{0:c2}' }
                ],
                yesNoDropdownSelects: ['Select Option', 'Yes', 'No']
            }
        },
        computed: {
            applications() {
                let applications = sessionStorage.getItem('applications');
                if (applications) {
                    return JSON.parse(applications)
                }

                return [];
            },
            appraisalType() {
                return this.propertyAndAppraisalFields.find(field => field.id === '2356')?.value;
            },
            escrowHoldbackFields() {
                return this.propertyAndAppraisalFields.filter(field => field.holdback);
            },
            hasMI() {
                let hasMI = sessionStorage.getItem('hasmi');

                if (this.loanType !== 'FHA' && hasMI && +hasMI > 0) {
                    return true;
                }

                return false;
            },
            isFHA() {
                return this.loanType === 'FHA';
            },
            isVA() {
                return this.loanType === 'VA';
            }
        },
        watch: {
            appraisalType(val) {
                ['618', '974', '617', 'CX.UW.APPRAISERCITY', 'CX.UW.APPRAISERSTATE'].forEach(fieldId => {
                    let match = this.propertyAndAppraisalFields.find(f => f.id === fieldId);

                    if (match) {
                        if (val === 'No appraisal/inspection obtained' || val === 'No') {
                            match.value = 'No appraisal/inspection obtained';
                        } else {
                            if (match.value === 'No appraisal/inspection obtained') {
                                match.value = null;
                            }
                        }

                    }
                })
            },
            attachmentsSource(val) {
                if (val) {
                    this.assignAttDocDescription();
                }
            },
            finishClicked(val) {
                this.dispositionLoan();
            },
            secondaryExecutionFields: {
                handler(val) {
                    let step = this.hasMI ? 5 : 3;

                    if (val.some(field => field.type === 'yesnodropdown' && (!field.value || field.value === 'Select Option'))) {
                        return this.$emit('setcurrentstepcleared', false, step);
                    }

                    this.$emit('setcurrentstepcleared', true, step);
                },
                deep: true
            },
            showAllAttachments(val) {
                this.processAttachmentsFilterSort();
            },
            wizardStep(val) {
                this.showAttachment = false;

                this.attachments.forEach(att => {
                    att.selected = false;
                });

                this.selectedId = null;

                if (this.hasMI && val === 0) {
                    this.showPMIQuoteWarning = false;
                    this.getPMIQuote();
                }

                if ((this.hasMI && val === 2) || (!this.hasMI && val === 0)) {
                    this.selectedAttachment.id = '';
                    this.selectedAttachment.url = '';

                    this.stopProgressBar();

                    if (!this.ausAttachmentId) {
                        this.ausFindingsWarning = false;
                        return this.getAUSFindings();
                    }

                    return this.getAttachment({ dataItem: { id: this.ausAttachmentId }});
                }

                if ((!this.hasMI && this.isFHA && val === 4)) {
                    this.getFHADocs()
                }
                /** WIP - VA CTC Wizard */
                //if ((!this.hasMI && this.isVA && val === 4)) {
                //  //this.getVADocs()
                //  console.log('getVADocs()');
                //}

                if (this.processors.length === 0 && ((this.hasMI && val === 6) || (!this.hasMI && !this.isFHA && val === 4) || (!this.hasMI && this.isFHA && val === 6))) {
                    this.getEncompassUsers();
                }
            }
        },
        async mounted() {
            this.allAttachmentSort.push({ field: 'createdDate', dir: 'desc' });
            this.assignAttDocDescription();

            this.getCTCFields();
            this.getBorowerFundsToClose();
            this.getEncompassUsers();

            let loanProgram = sessionStorage.getItem('loanprogram');
            this.loanProgram = loanProgram === 'EarlyCheck' ? 'DU' : loanProgram;

            if (this.hasMI) {
                this.getPMIQuote();
            } else {
                this.getAUSFindings();
            }

            if (this.isFHA) {
                this.getAllFHASigningDocs();

                if (this.applications?.length >= 2) {
                    this.fhaSigningDocsSelects = [...this.fhaSigningDocsSelects, ...this.fhaSigningDocsSelectsApp2];

                    if (this.applications.length === 3) {
                        this.fhaSigningDocsSelects = [...this.fhaSigningDocsSelects, ...this.fhaSigningDocsSelectsApp3];
                    }
                }

                this.fhaTabs.push(this.fhaRefiTab);
            }

            await this.assignClosingConditions();

            let milestones = sessionStorage.getItem('loanmilestones');
            if (milestones) {
                let allMilestones = JSON.parse(milestones);

                let resubmittalMilestone = allMilestones.find(m => m.name === 'Resubmittal');

                if (resubmittalMilestone) {
                    this.resubmittalMilestoneId = resubmittalMilestone.doneIndicator ? null : resubmittalMilestone.id;
                }

                this.approvalMilestoneId = allMilestones.find(m => m.name === 'Approval')?.id;
                this.qcReviewMilestoneId = allMilestones.find(m => m.name === 'QC Review')?.id;
            }
        },
        methods: {
            addWizardNote(noteHtml) {
                this.addedNotes.push(noteHtml);
            },
            allAttachmentFilterChange(evt) {
                this.allAttachmentFilter = evt.filter;

                this.processAttachmentsFilterSort();
            },
            allAttachmentSortChangeHandler(evt) {
                this.allAttachmentSort = evt.sort;

                this.attachments = orderBy(this.attachments, this.allAttachmentSort);
            },
            assignAttDocDescription() {
                this.allAttachments = this.attachmentsSource.filter(att => att.assignedTo?.entityName !== '* AIQ Upload' && att.assignedTo?.entityName !== 'zUploaded_to_AIQ');

                this.allAttachments.forEach(att => {
                if (att.assignedTo) {
                    let assignedDocument = this.allDocuments.find(doc => doc.id === att.assignedTo.entityId);

                    att.attDocDescription = assignedDocument?.description ?? '';
                } else {
                    attDocDescription = '';
                }
                });

                this.attachments = this.allAttachments.map(att => ({...att}));

                this.processAttachmentsFilterSort();
            },
            async assignClosingConditions() {
                if (!this.isRefi) {
                    this.emd = +this.earnestMoneyDeposit;
                        
                    await this.assignOrCreateClosingCondition('*CL1010 - Closing - EMD', 'borrowerEMDCondition');

                    this.sellerContTotal = this.sellerContributionTotal;

                    await this.assignOrCreateClosingCondition('*CL1014 - Closing - Seller Contribution', 'sellerContributionCondition');
                } else {
                    await this.assignOrCreateClosingCondition('*CL1054 - Closing - UFMIP Refund', 'fhaRefundCondition');
                }

                await this.assignOrCreateClosingCondition('*CL1007 - Closing - Borrower(s) cash to close cannot exceed $', 'borrowerFundsCondition');

                if (this.isFHA) {
                    await this.assignOrCreateClosingCondition('*CL1001 - Closing - Assets Minimum Contribution', 'assetsMinimumCondition');
                    let purchasePrice = sessionStorage.getItem('purchaseprice');

                    if (purchasePrice && purchasePrice > 0) {
                        this.assetsMinimumTotal = +((purchasePrice * 0.035).toFixed(2));
                    } else {
                        this.assetsMinimumTotal = 0;
                    }
                }

                await this.assignOrCreateClosingCondition('*CL1029 -Closing - Monthly payment including taxes,HOA,  insurance, MI not to exceed $', 'monthlyPaymentCondition');

                let monthlyPayment = this.fields.find(field => field.fieldId === '912');

                if (monthlyPayment?.value && this.monthlyPaymentCondition) {
                    this.monthlyPaymentTotal = +monthlyPayment.value + 50;
                }

                let loanData = sessionStorage.getItem('loandata');

                if (loanData) {
                    this.loanData = JSON.parse(loanData);
                }

                this.applicationVOLs = this.loanVOLs;

                this.applicationVOLs.forEach(vol => {
                    vol.liabilityType = this.formatPascalValue(vol.liabilityType);
                    vol.toBePaidOff = vol.payoffIncludedIndicator ? 'Y' : 'N';
                });

                this.applicationVOLsToBePaid = this.loanVOLs.filter(vol => vol.payoffIncludedIndicator);

                await this.assignOrCreateClosingCondition('*CL1032 - Closing Debts to be paid on CD', 'liabilitiesToBePaidCondition');

                this.applicationVOLsToBePaidTotal = this.applicationVOLsToBePaid.reduce((prev, cur) => {
                    return prev + cur.toBePaidOffAmount;
                }, 0);
            },
            assignFHASummarySelects(fieldId) {
                switch (fieldId) {
                    case '1039':
                        this.soaSelects.sort();
                        this.soaSelects.unshift('Select Option');
                        return this.soaSelects;
                    case '34':
                        this.borrowerSourceOfFundsSelects.sort();
                        this.borrowerSourceOfFundsSelects.unshift('Select Option');
                        return this.borrowerSourceOfFundsSelects;
                    case '1711':
                        this.fhaAgencyTypeSelects.sort();
                        this.fhaAgencyTypeSelects.unshift('Select Option');
                        return this.fhaAgencyTypeSelects;
                    case '1065':
                        this.fhaOccupancySelects.sort();
                        this.fhaOccupancySelects.unshift('Select Option');
                        return this.fhaOccupancySelects;
                    case '1639':
                        this.fhaBorrowerCertOneSelects.unshift('Select Option');
                        return this.fhaBorrowerCertOneSelects;
                    case '1399':
                        this.fhaBorrowerCertTwoSelects.unshift('Select Option');
                        return this.fhaBorrowerCertTwoSelects;
                    case '153':
                        this.doesSelects.unshift('Select Option');
                        return this.doesSelects;
                    default:
                        return this.yesNoDropdownSelects;
                }
            },
            async assignOrCreateClosingCondition(conditionName, prop) {
                this[prop] = this.$store.state.conditions.find(cond => cond.title.trim() === conditionName);

                if (!this[prop]) {
                    if (this.conditionTemplates.length === 0) {
                        if (this.$store.state.conditionTemplates.length === 0) {
                            await this.$store.dispatch('getConditionTemplates');
                        }
                    }

                    this.conditionTemplates = cloneDeep(this.$store.state.conditionTemplates);

                    let template = this.conditionTemplates.find(cond => cond.title === conditionName);

                    if (template) {
                        let newCondition = cloneDeep(template);

                        newCondition.externalDescription = newCondition.externalDescription ?? "";
                        newCondition.internalDescription = newCondition.internalDescription ?? "";
                        newCondition.priorTo = newCondition.priorTo ?? "";
                        newCondition.bySwift = true;

                        await this.$store.dispatch('addCondition', newCondition);
                        await this.$store.dispatch('getConditions');

                        this[prop] = this.$store.state.conditions.find(cond => cond.title === conditionName);
                    }
                }

                this[prop].externalDescription = this[prop].externalDescription ?? "";
                this[prop].internalDescription = this[prop].internalDescription ?? "";
                this[prop].priorTo = this[prop].priorTo ?? "";
            },
            assignProcessors(allProcessors) {
                if(allProcessors.length > 0) {
                    let currentProcessor = sessionStorage.getItem('currentprocessor');

                    this.processors = allProcessors.filter(proc => proc.userIndicators.some(indicator => indicator === 'Enabled') || proc.id === currentProcessor).sort((a, b) => a.fullName.localeCompare(b.fullName));
                    this.processors.forEach(proc => proc.displayName = `${proc.fullName}  (${proc.id})`);

                    this.filteredProcessors = cloneDeep(this.processors);

                    this.selectedProcessor = this.filteredProcessors.find(proc => proc.id === currentProcessor);
                    this.$emit('cleartofinish', true);
                }
            },
            assignPropertyAppraisalSelects(fieldId) {
                switch (fieldId) {
                    case '1041':
                        this.propertyTypeSelects.sort();
                        this.propertyTypeSelects.unshift('Select Option');
                        return this.propertyTypeSelects;
                    case '1541':
                        return this.propertyReviewSelects;
                    case '2367':
                        this.projectTypeSelects.sort();
                        this.projectTypeSelects.unshift('Select Option');
                        return this.projectTypeSelects;
                    case '2356':
                        this.appraisalTypeSelects.sort();
                        this.appraisalTypeSelects.unshift('Select Option');
                        return this.appraisalTypeSelects;
                    case 'CX.UW.CUSCORE':
                        return this.cuScoreSelects;
                    default:
                        return this.yesNoDropdownSelects;
                }
            },
            attachmentSortChangeHandler(evt) {
                this.attachmentSort = evt.sort;

                this.quoteAttachments = orderBy(this.quoteAttachments, this.attachmentSort);
            },
            base64ToBlob(base64, type='application/octet-stream') {
                const binStr = atob(base64);
                const len = binStr.length;
                const arr = new Uint8Array(len);

                for (let i = 0; i < len; i++) {
                    arr[i] = binStr.charCodeAt(i);
                }
                
                return new Blob([arr], {type: type});
            },
            async dispositionLoan() {
                if (this.borrowerEMDCondition) {
                    this.borrowerEMDCondition.externalDescription = this.$options.filters.formatCurrency(Math.ceil(this.emd).toString());
                }

                if (this.sellerContributionCondition) {
                    this.sellerContributionCondition.externalDescription = this.$options.filters.formatCurrency(Math.ceil(this.sellerContTotal).toString());
                }

                if (this.liabilitiesToBePaidCondition) {
                    this.liabilitiesToBePaidCondition.externalDescription = this.$options.filters.formatCurrency(Math.ceil(this.applicationVOLsToBePaidTotal).toString());
                }

                if (this.assetsMinimumCondition) {
                    this.assetsMinimumCondition.externalDescription = this.$options.filters.formatCurrency(Math.ceil(this.assetsMinimumTotal).toString());
                }

                this.borrowerFundsCondition.externalDescription = this.$options.filters.formatCurrency(Math.ceil(this.borrowerFunds).toString());

                this.monthlyPaymentCondition.externalDescription = this.$options.filters.formatCurrency(Math.ceil(this.monthlyPaymentTotal).toString());

                let fields = this.docDateFields.reduce((prev, cur) => {
                    prev.push(cur.fields);
                    return prev;
                }, []);
                
                fields = fields.flat().filter(field => field.value && field.type != 'exp').map(field => {
                    let value;

                    if (field.type != 'na') {
                        value = field.value.toISOString();
                    } else {
                        value = field.value.toString();
                    }

                    return {
                        id: field.fieldId,
                        value: value
                    }
                });

                this.secondaryExecutionFields.forEach(field => {
                    let value;
                    let push = true;

                    if (field.type !== 'checkbox') {
                        value = field.value;

                        if (field.type === 'numeric') {
                            value = field.value.toString();
                        }

                        if (field.type === 'homereadydropdown' && field.value === 'Select Option') {
                            push = false;
                        }
                    } else {
                        value = field.value === 'Y' ? 'true' : 'false';
                    }

                    if (push) {
                        fields.push({ id: field.id, value: value });
                    }
                });

                let addlFields = this.propertyAndAppraisalFields;

                if (this.isFHA) {
                    addlFields = [...this.fhaSummaryFields.filter(f => f.id), ...addlFields];

                    if (this.isRefi) {
                        addlFields = [...this.fhaRefiFields.filter(f => f.id), ...addlFields];
                    }
                }

                addlFields.forEach(field => {
                    let value;
                    let push = true;

                    if (field.type !== 'checkbox' && field.type !== 'nestedcheckbox') {
                        value = field.value ? field.value : '';

                        if (field.type === 'numeric') {
                            value = field.value.toString();
                        }

                        if ((field.type === 'dropdown' || field.type === 'yesnodropdown') && field.value === 'Select Option') {
                            value = '';
                        }

                        if (field.type === 'yesnodropdown' && value && field.section === 'Borrower Certification') {
                            value = field.value === 'Yes' ? 'true' : 'false';
                        }

                        if (field.type === 'date') {
                            value = field.value ? field.value.toISOString() : '';

                            if (!value) {
                                push = false;
                            }
                        }
                    } else {
                        value = field.value === 'Y' ? 'true' : 'false';
                    }

                    if (field.id === 'CX.AUDIT.APPRAISALREVIEW') {
                        push = false;
                    }

                    if (field.id === 'CX.UW.CONSTRUCTION') {
                        value = field.value === 'Yes' ? 'Y' : 'N';
                    }

                    if (push) {
                        fields.push({ id: field.id, value: value });
                    }
                });

                fields.push({ id: 'CX.UWI.CTC', value: 'X' });

                let request = {
                    loanId: this.loanId,
                    borrowerFundsCondition: this.borrowerFundsCondition,
                    borrowerEMDCondition: this.borrowerEMDCondition,
                    sellerContributionCondition: this.sellerContributionCondition,
                    assetsMinimumCondition: this.assetsMinimumCondition,
                    monthlyPaymentCondition: this.monthlyPaymentCondition,
                    liabilitiesToBePaidCondition: this.liabilitiesToBePaidCondition,
                    fhaRefundCondition: this.fhaRefundCondition,
                    fields: fields,
                    approvalMilestoneId: this.approvalMilestoneId,
                    resubmittalMilestoneId: this.resubmittalMilestoneId,
                    qcReviewAssociate: {
                        loanAssociateType: 'User',
                        userId: this.selectedProcessor.id,
                        loanId: this.loanId,
                        milestoneId: this.qcReviewMilestoneId
                    },
                    signedDocs: this.isFHA ? this.fhaSigningDocsBase64.filter(doc => doc.file && doc.loanId) : []
                }

                this.isLoading = true;

                let tokenResponse = await auth.acquireTokenResponse();


                apiService.ClearToCloseLoan(request, tokenResponse.accessToken)
                    .then(res => {
                        this.isLoading = false;
                        this.$emit('loanclearedtoclose', 'File cleared to close successfully');
                    }).catch(error => {
                        this.errorTitle = 'Failed to Disposition Loan';
                        
                        if(error.response?.data?.data) {
                            this.errorMsg = "Error: \n\n" + error.response.data.data;
                        } else {
                            this.errorMsg = '';
                        }

                        this.onRequestError(this.errorTitle, this.errorMsg);
                        this.$emit('requestfailed');
                    });
            },
            formatDocDateFields(data) {
                this.docDateFields.forEach(field => {
                    field.fields.forEach(f => {
                        let match = data.find(item => item.fieldId === f.fieldId);

                        if (match) {
                            if (match.value && match.value !== '//') {
                                if (f.type === 'na') {
                                    f.value = match.value === 'X' ? true : false;
                                } else {
                                    f.value = new Date(match.value);
                                }
                            } else {
                                if (f.type === 'na') {
                                    f.value = false;
                                } else {
                                    f.value = null;
                                }
                            }
                        }
                    });
                });
            },
            formatDocExpFields(data) {
                this.docExpFields.forEach(field => {
                    field.fields.forEach(f => {
                        let match = data.find(item => item.fieldId === f.fieldId);

                        if (match) {
                            if (match.value && match.value !== '//') {
                                f.value = new Date(match.value);
                            } else {
                                f.value = null;
                            }
                        }
                    });
                });
            },
            formatDocPurchaseFields(data) {
                this.docPurchaseFields[0].fields.forEach(field => {
                    let match = data.find(item => item.fieldId === field.fieldId);

                    if (match) {
                        if (match.value && match.value !== '//') {
                            field.value = new Date(match.value);
                        } else {
                            field.value = null;
                        }
                    }
                });
            },
            formatFHAFields(data) {
                this.fhaSummaryFields.forEach(field => {
                    let match = data.find(item => item.fieldId === field.id);

                    if (match) {
                        if (field.type === 'dropdown' || field.type === 'yesnodropdown') {
                            field.selects = this.assignFHASummarySelects(field.id);

                            if (!match.value) {
                                match.value = 'Select Option';
                            } else {
                                if (field.type === 'yesnodropdown') {
                                    match.value = match.value === 'Y' ? 'Yes' : 'No';
                                } else {
                                    let customMatch = false;

                                    if (field.id === '1065' || field.id === '1399' || (field.id === '34' && match.value.includes('Nonprofit'))) {
                                        customMatch = true;
                                    }

                                    if (field.id === '1065') {
                                        match.value = this.getOccupancyDropdownValue(match.value);
                                    } 

                                    if (field.id === '1399') {
                                        match.value = match.value === 'AwareOfThisValuation'
                                            ? 'I was aware of this valuation when I signed my contract'
                                            : 'I was not aware of this valuation when I signed my contract';
                                    }

                                    if (field.id === '34' && customMatch) {
                                        match.value = this.getFHAFundsSourceValue(match.value);
                                    }

                                    if (!customMatch) {
                                        let s = match.value.replace(/[^a-zA-Z0-9]/g, '');
                                        let matchingSelect = field.selects.find(select => select.replace(/[^a-zA-Z0-9]/g, '').toLowerCase() === s.toLowerCase());
                                        
                                        match.value = matchingSelect ?? match.value;
                                    }
                                            
                                }
                            }
                        }

                        if (field.type === 'checkbox' && (match.value === 'Y' || match.value === 'X')) {
                            match.value = 'Y';
                        } 

                        if (field.type === 'numeric') {
                            match.value = +match.value;
                        }

                        if (field.type === 'date') {
                            if (match.value && match.value !== '//') {
                                match.value = new Date(match.value);
                            } else {
                                match.value = null;
                            }

                            if (!match.value && (field.section === 'Commitment Terms' || field.section === 'Approved & Additional Conditions')) {
                                if (field.id === '1072' || field.id === '3177') {
                                    let today = new Date();
                                    today.setDate(today.getDate() + 180);

                                    match.value = today;
                                } else {
                                    match.value = new Date();
                                }
                            }
                        }

                        field.value = match.value;
                    }
                });
            },
            formatFhaRefiFields(data) {
                this.fhaRefiFields.forEach(field => {
                    let match = data.find(item => item.fieldId === field.id);

                    if (match) {
                        if (field.type === 'numeric') {
                            match.value = +match.value;
                        }

                        if (field.type === 'date') {
                            if (match.value && match.value !== '//') {
                                match.value = new Date(match.value);
                            } else {
                                match.value = null;
                            }
                        }

                        field.value = match.value;
                    }
                });
            },
            formatVAFields(data) {
              console.log(data);
              this.formatVALoanSummaryFields(data);
              this.formatVAReasonableValueFields(data);
              this.formatVADisbursementFields(data);
              //this.formatVALoanAnalysisFields(data);

              const borrowerFirstName = data.find(f => f.fieldId === 'BORR_FIRST_NAME_ID')?.value;
              const borFirstNameField = this.vaLoanSummaryFields.find(f => f.id === 'BORR_FIRST_NAME_ID');
              if (borFirstNameField) borFirstNameField.value = borrowerFirstName;
            },
          handleVaEnergyCheckboxChange(event, changedField) {
            const NONE_ID = '376';
            const OTHER_IDS = ['379', '377', '380', '378', '381'];

            const GROUPS = [this.vaLoanSummaryFields, this.vaDisbursementFields];

            const isChecked = event.value;

            GROUPS.forEach(group => {
              const target = group.find(f => f.id === changedField.id);
              if (target) target.value = isChecked;
            });

            if (changedField.id === NONE_ID && isChecked) {
              GROUPS.forEach(group => {
                group.forEach(f => {
                  if (OTHER_IDS.includes(f.id)) f.value = false;
                });
              });
            } else if (OTHER_IDS.includes(changedField.id) && isChecked) {
              GROUPS.forEach(group => {
                const noneBox = group.find(f => f.id === NONE_ID);
                if (noneBox) noneBox.value = false;
              });
            }
          },



            formatVALoanSummaryFields(data) {
              this.vaLoanSummaryFields.forEach(field => {
                if (field.disabled) return;

                let match = data.find(item => item.fieldId === field.id);
                if (match) {

                  if (field.type === 'numeric') {
                    field.value = match.value ? +match.value : null;
                  } else if (field.type === 'date') {
                    field.value = (match.value && match.value !== '//') ? new Date(match.value) : null;
                  } else if (field.type === 'dropdown') {
                    field.value = match.value || field.selects?.[0]; 
                  } else if (field.type === 'checkbox') {
                    field.value = match.value === 'Y' || match.value === 'X' || match.value === true; 
                  } else if (field.type === 'radio') {
                    field.value = match.value;
                  } else { 
                    field.value = match.value;
                  }
                } else {
                }
              });
            },
           formatVAReasonableValueFields(data) {
               this.vaRasonableValueFields.forEach(field => {
                if (field.disabled) return; 

                let match = data.find(item => item.fieldId === field.id);
                if (match) {
                  if (field.type === 'numeric') {
                    field.value = match.value ? +match.value : null;
                  } else if (field.type === 'date') {
                    field.value = (match.value && match.value !== '//') ? new Date(match.value) : null;
                  } else if (field.type === 'dropdown') {
                    field.value = match.value || field.selects?.[0]; 
                  } else if (field.type === 'checkbox') {
                    field.value = match.value === 'Y' || match.value === 'X' || match.value === true; 
                  } else if (field.type === 'radio') {
                    field.value = match.value; 
                  } else {
                    field.value = match.value;
                  }
                } else {
                }
              });
            },
           formatVADisbursementFields(data) {
              this.vaDisbursementFields.forEach(field => {
                if (field.disabled) return;

                let match = data.find(item => item.fieldId === field.id);
                if (match) {
                  if (field.type === 'numeric') {
                    field.value = match.value ? +match.value : null;
                  } else if (field.type === 'date') {
                    field.value = (match.value && match.value !== '//') ? new Date(match.value) : null;
                  } else if (field.type === 'dropdown') {
                    field.value = match.value || field.selects?.[0]; 
                  } else if (field.type === 'checkbox') {
                    field.value = match.value === 'Y' || match.value === 'X' || match.value === true; 
                  } else if (field.type === 'radio') {
                    field.value = match.value; 
                  } else {
                    field.value = match.value;
                  }
                } else {
                }
              });
            },
            formatPascalValue(val) {
                if (!val) return;

                return val.match(/[A-Z][a-z]+|[0-9]+/g).join(' ');
            },
            formatPropertyAndAppraisalFields(data) {
                this.propertyAndAppraisalFields.forEach(field => {
                    let match = data.find(item => item.fieldId === field.id);

                    if (match) {
                        if (field.type === 'datetime' || field.type === 'date') {
                            if (match.value && match.value !== '//') {
                                match.value = new Date(match.value);
                            } else {
                                match.value = null;
                            }
                        } 

                        if (field.type === 'dropdown' || field.type === 'yesnodropdown') {
                            field.selects = this.assignPropertyAppraisalSelects(field.id);

                            if (!match.value) {
                                if (field.id === '1711') {
                                    if (this.isFHA) {
                                        match.value = 'HUD/FHA';
                                    }
                                }
                                match.value = 'Select Option';
                            } else {
                                if (field.type === 'yesnodropdown') {
                                    match.value = match.value === 'Y' ? 'Yes' : 'No';
                                } else {
                                    if (field.id === '2367' && match.value.includes('ICondominium')) {
                                        match.value = match.value.split('_')[1].replace('minium', '');
                                    }

                                    let s = match.value.replace(/[^a-zA-Z0-9]/g, '');
                                    let matchingSelect = field.selects.find(select => select.replace(/[^a-zA-Z0-9]/g, '').toLowerCase() === s.toLowerCase())
                                    
                                    match.value = matchingSelect ?? match.value;
                                }
                            }
                        }

                        if (field.type === 'checkbox' && (match.value === 'Y' || match.value === 'X')) {
                            match.value = 'Y';
                        }

                        if (field.type === 'numeric') {
                            match.value = +match.value;
                        }

                        field.value = match.value;
                    }
                });
            },
            formatSecondaryExecutionFields(data) {
                this.secondaryExecutionFields.forEach(field => {
                    field.value = data.find(f => f.fieldId === field.id)?.value;

                    if (!field.value && (field.type === 'yesnodropdown' || field.type === 'homereadydropdown')) {
                        field.value = 'Select Option';
                    }

                    if (field.value && field.type === 'yesnodropdown') {
                        if (field.value === 'Y' || field.value === 'Yes') {
                            field.value = 'Yes'
                        } else {
                            field.value = 'No'
                        }
                    }

                    if (field.type === 'numeric') {
                        field.value = +field.value;
                    }
                });
            },
            async getAllFHASigningDocs() {
                if (this.applications.length === 0) return;

                this.isFhaDocLoading = true;

                await this.getFHASigningDocs(this.applications[0]);

                if (this.applications.length > 1) {
                    await this.getFHASigningDocs(this.applications[1]);

                    if (this.applications.length === 3) {
                        await this.getFHASigningDocs(this.applications[2]);
                    }
                }

                this.selectedFHASigningDoc.url = this.fhaSigningDocs.find(doc => doc.docName === this.selectedFHASigningDoc.docName && doc.applicationNumber === 1)?.url;
                this.isFhaDocLoading = false;

                this.$emit('setcurrentstepcleared', true, 5);
            },
            async getAttachment(evt) {
                this.showAttachment = true;
                this.selectedAttachment.id = evt.dataItem.id;

                this.isAttachmentLoading = true;

                let attachmentsFile = {
                    loanId: this.loanId,
                    attachments: [evt.dataItem.id]
                };

                let tokenResponse = await auth.acquireTokenResponse();

                apiService.GetAttachmentsFileBytes(attachmentsFile, tokenResponse.accessToken)
                    .then(res => {
                        const blob = this.base64ToBlob(res.data.data, 'application/pdf');
                        const url = URL.createObjectURL(blob);

                        this.isAttachmentLoading = false;
                        this.isFhaAttachmentLoading = false;
                        this.selectedAttachment.url = url;
                    }).catch(error => {
                        this.selectedAttachment.id = '';

                        this.isAttachmentLoading = false;
                        this.isFhaAttachmentLoading = false;

                        this.errorTitle = 'Failed to Open Attachment';

                        if(error?.response?.data?.data) {
                        this.errorMsg = "Error: \n\n" + error.response.data.data;
                        } else {
                            this.errorMsg = '';
                        }

                        this.onRequestError(this.errorTitle, this.errorMsg);
                    });
            },
            async getAUSFindings() {
                this.isLoadingAUS = true;

                this.startProgressBar();

                let tokenResponse = await auth.acquireTokenResponse();

                apiService.OrderAUS(this.loanId, this.loanProgram, tokenResponse.accessToken)
                    .then(res => {
                        if (this.progressValue < 50) {
                            this.progressValue = 49;
                        }

                        this.$emit('documentsupdated');

                        setTimeout(() => {
                            this.isLoadingAUS = false;
                            this.ausAttachmentId = res.data.data;
                            this.stopProgressBar();
                            this.getAttachment({ dataItem: { id: this.ausAttachmentId }});
                        }, 2000);

                    }).catch(error => {
                        this.isLoadingAUS = false;
                        this.stopProgressBar();

                        this.ausFindingsWarning = true;

                        this.errorTitle = 'Failed to Launch AUS Findings';

                        if(error?.response?.data?.data) {
                            this.errorMsg = "Error: \n\n" + error.response.data.data;
                        } else {
                            this.errorMsg = '';
                        }

                        if ((this.hasMI && this.wizardStep === 2) || (!this.hasMI && this.wizardStep === 0)) {
                            this.onRequestError(this.errorTitle, this.errorMsg);
                        }
                    });
            },
            async getBorowerFundsToClose() {
                let tokenResponse = await auth.acquireTokenResponse();

                this.isLoadingBorrowerFunds = true;

                apiService.GetBorrowerFundsToClose(this.loanId, this.applicationId, tokenResponse.accessToken)
                    .then(res => {
                        this.applicationVODs = res.data.data.applicationVODs;
                        this.applicationGiftGrants = res.data.data.applicationGiftGrants;
                        this.applicationOtherAssets = res.data.data.applicationOtherAssets;

                        this.processApplicationVODs();
                        this.processApplicationGiftGrants();
                        this.processApplicationOtherAssets(); 

                        this.borrowerFunds = this.applicationGiftGrantsTotal + this.applicationOtherAssetsTotal + this.applicationVODTotal;

                        let closingFundsStep = this.hasMI ? 3 : 1;

                        this.isLoadingBorrowerFunds = false;

                        this.$emit('setcurrentstepcleared', true, closingFundsStep);
                    }).catch(error => {
                        this.errorTitle = 'Failed to Get Borrower Funds To Close';

                        if(error?.response?.data?.data) {
                        this.errorMsg = "Error: \n\n" + error.response.data.data;
                        } else {
                            this.errorMsg = '';
                        }

                        this.onRequestError(this.errorTitle, this.errorMsg);
                    });
            },
            async getCTCFields() {
                let ctcFields = [...this.docFieldsList, ...this.secondaryExecutionFieldsList, ...this.propertyAndAppraisalFieldsList];

                if (this.isFHA) {
                    ctcFields = [...ctcFields, ...this.fhaSummaryFieldsList];

                    if (this.isRefi) {
                        ctcFields = [...ctcFields, ...this.fhaRefiFieldsList];
                    }
                }
                if (this.isVA) {
                  ctcFields = [...ctcFields, ...this.vaFieldsList];
                }

                ctcFields = [...new Set(ctcFields)];

                let tokenResponse = await auth.acquireTokenResponse();

                return apiService.GetLoanFieldList(this.loanId, ctcFields, tokenResponse.accessToken)
                    .then(res => {
                        this.formatDocDateFields(res.data.data);
                        this.formatDocExpFields(res.data.data);
                        this.formatDocPurchaseFields(res.data.data);
                        this.formatSecondaryExecutionFields(res.data.data);
                        this.formatPropertyAndAppraisalFields(res.data.data);

                        if (this.isFHA) {
                            this.formatFHAFields(res.data.data);

                            if (this.isRefi) {
                                this.formatFhaRefiFields(res.data.data);
                            }
                      }
                      if (this.isVA) {
                        this.formatVAFields(res.data.data);
                      }
                    }).catch(error => {
                        this.errorTitle = 'Failed to Fetch Loan Fields';
                        
                        if(error.response?.data?.data) {
                            this.errorMsg = "Error: \n\n" + error.response.data.data;
                        } else {
                            this.errorMsg = 'Please close the disposition menu and try again.';
                        }

                        this.onRequestError(this.errorTitle, this.errorMsg);
                    });

            },
            getDocAttachment(evt) {
                this.selectedId = evt.dataItem.id;

                this.attachments.forEach(att => {
                    if (att.id === this.selectedId) {
                        att.selected = true;
                    } else {
                        att.selected = false;
                    }
                })
                this.selectedAttachment.url = '';

                this.getAttachment(evt);
            },
            async getDocFieldsList() {
                let tokenResponse = await auth.acquireTokenResponse();

                return apiService.GetLoanFieldList(this.loanId, this.docFieldsList, tokenResponse.accessToken)
                    .then(res => {
                        this.formatDocDateFields(res.data.data);
                        this.formatDocExpFields(res.data.data);
                        this.formatDocPurchaseFields(res.data.data);
                    }).catch(error => {
                        this.errorTitle = 'Failed to Fetch Loan Fields';
                        
                        if(error.response?.data?.data) {
                            this.errorMsg = "Error: \n\n" + error.response.data.data;
                        } else {
                            this.errorMsg = '';
                        }

                        this.onRequestError(this.errorTitle, this.errorMsg);
                    });
            },
            async getEncompassUsers() {
                if (this.processors.length > 0) return this.filteredProcessors = cloneDeep(this.processors);

                let tokenResponse = await auth.acquireTokenResponse();
                this.idTokenClaims = tokenResponse.idTokenClaims;

                apiService.GetProcessors(tokenResponse.accessToken)
                    .then(res => {
                        this.assignProcessors(res.data.data);
                    }).catch(error => {
                        this.errorTitle = 'Failed to Fetch Processors';
                        
                        if(error.response?.data?.data) {
                            this.errorMsg = "Error: \n\n" + error.response.data.data;
                        } else {
                            this.errorMsg = '';
                        }

                        this.onRequestError(this.errorTitle, this.errorMsg);
                    });
            },
            getFHADocs() {
                this.selectedAttachment.id = '';
                this.selectedAttachment.url = '';

                if (this.fhaAttachmentId) {
                    return this.getAttachment({ dataItem: { id: this.fhaAttachmentId }});
                }

                let fhaDocs = this.allDocuments.filter(doc => doc.title === 'Govt - FHA Case Number' || doc.title.trim() === '*APPR1000 - Appraisal' || doc.title.trim() === 'GOVT - Refi Auth / Netting Auth');
                if (fhaDocs.length > 0) {
                    this.fhaAttachments = this.allAttachments
                        .filter(att => att.assignedTo && fhaDocs.some(doc => doc.id === att.assignedTo.entityId))
                        .sort((a, b) => b.createdDate - a.createdDate);

                    if (this.fhaAttachments.length > 0) {
                        this.isFhaAttachmentLoading = true;
                        this.fhaAttachmentId = this.fhaAttachments[0].id;
                        this.getAttachment({ dataItem: { id: this.fhaAttachments[0].id }})
                    } else {
                        this.showFHADocsWarning = true;
                    }
                } else {
                    this.showFHADocsWarning = true;
                }

                this.$nextTick(() => {
                    let panel = document.querySelector('.edit-condition__attachments .fha');

                    if (panel) {
                        let panelTextEl = panel.querySelector('.k-panelbar-item-text');

                        if (panelTextEl) {
                            panelTextEl.innerHTML += `<span class="attachments-badge">${this.fhaAttachments.length}</span>`;
                        }
                    }
                });
            },
            async getFHAFieldsList() {
                let tokenResponse = await auth.acquireTokenResponse();

                return apiService.GetLoanFieldList(this.loanId, this.fhaSummaryFieldsList, tokenResponse.accessToken)
                    .then(res => {
                        this.formatFHAFields(res.data.data);
                    }).catch(error => {
                        this.errorTitle = 'Failed to Fetch Loan Fields';
                        
                        if(error.response?.data?.data) {
                            this.errorMsg = "Error: \n\n" + error.response.data.data;
                        } else {
                            this.errorMsg = '';
                        }

                        this.onRequestError(this.errorTitle, this.errorMsg);
                    });
            },
            getFHAFundsSourceValue(value) {
                switch(value) {
                    case 'FHAGiftSourceNonprofitSellerFunded':
                        return 'FHA - Gift - Source Nonprofit/Religious/Community - Seller Funded';
                    case 'FHAGiftSourceNonprofitNonSellerFunded':
                        return 'FHA - Gift - Source Nonprofit/Religious/Community - Non-Seller Funded';
                    default:
                        return value;
                };
            },
            async getFHASigningDocs(application) {
                let request = cloneDeep(this.fhaSigningRequest);
                request.entity.entityId = this.loanId;
                request.scope.entityId = application.applicationId;

                let tokenResponse = await auth.acquireTokenResponse();

                return apiService.OrderEncompassDocs(request, tokenResponse.accessToken)
                    .then(res => {
                        res.data.data.forEach(doc => {
                            const blob = this.base64ToBlob(doc.docBytes, 'application/pdf');
                            doc.url = URL.createObjectURL(blob);
                            doc.applicationNumber = application.application;
                            doc.applicationId = application.applicationId;
                        });

                        this.fhaSigningDocs = [...this.fhaSigningDocs, ...res.data.data];
                    }).catch(error => {
                        this.isFhaDocLoading = false;
                        this.errorTitle = 'Failed to Fetch FHA Docs for Signing';

                        if(error.response?.data?.data) {
                            this.errorMsg = "Error: \n\n" + error.response.data.data;
                        } else {
                            this.errorMsg = '';
                        }

                        this.onRequestError(this.errorTitle, this.errorMsg);
                    });
            },
            getOccupancyDropdownValue(value) {
                switch(value) {
                    case 'ActuallyOccupyPropertyAsMyHome':
                        return 'I now actually occupy the above property as my home';
                    case 'ActuallyOccupyPropertyWithin60DaysContinueAtLeast1Year':
                        return 'I, the Borrower or Co-Borrower will occupy the property within 60 days of signing the security instrument, and intend to continue occupancy for at least one year';
                    case 'DoNotIntendToOccupyPropertyAsMyHome':
                        return 'I do not intend to occupy the property as my primary residence';
                    case 'SpouseOnActiveMilitaryDuty':
                        return 'My spouse is on active military duty and I occupy';
                    case 'VeteranOnActiveMilitaryDuty':
                        return 'I am active duty and my dependent child occupies home';
                    case 'PreviouslyOccupiedTheProperty':
                        return 'I previously occupied the property as my home';
                    case 'PreviouslyOccupiedWhileSpouseOnActiveMilitaryDuty':
                        return 'While my spouse was on active military duty…I previously';
                    case 'PreviouslyDependentOccupiedWhileVeteranOnActiveMilitaryDuty':
                        return 'I was on active military duty…my dependent child occupied home';
                    default:
                        return value;
                };
            },
            getPMIQuote() {
                this.selectedAttachment.id = '';
                this.selectedAttachment.url = '';
                
                if (this.miAttachmentId) {
                    return this.getAttachment({ dataItem: { id: this.miAttachmentId }});
                }

                let pmiCondition = this.$store.state.conditions.find(cond => cond.title === '*PMI1001- PMI - Quote' || cond.title === '*PMI100- PMI - Certificate');
                            
                if (pmiCondition && pmiCondition.assignedTo && pmiCondition.assignedTo.length > 0) {
                    let pmiQuoteDocs = pmiCondition.assignedTo.filter(doc => doc.entityName === 'PMI Quote' || doc.entityName === 'Mortgage Insurance' || doc.entityName === 'PMI Certificate');
                    
                    this.quoteAttachments = this.allAttachments
                        .filter(att => att.assignedTo && pmiQuoteDocs.some(doc => doc.entityId === att.assignedTo.entityId))
                        .sort((a, b) => b.createdDate - a.createdDate);

                    if (this.quoteAttachments.length > 0) {
                        this.miAttachmentId = this.quoteAttachments[0].id;
                        this.getAttachment({ dataItem: { id: this.quoteAttachments[0].id }});
                    } else {
                        this.showPMIQuoteWarning = true;
                    }
                } else {
                    this.showPMIQuoteWarning = true;
                }

                this.$nextTick(() => {
                    let panel = document.querySelector('.edit-condition__attachments .mi');

                    if (panel) {
                        let panelTextEl = panel.querySelector('.k-panelbar-item-text');

                        if (panelTextEl) {
                            panelTextEl.innerHTML += `<span class="attachments-badge">${this.quoteAttachments.length}</span>`;
                        }
                    }
                });
            },
            async getPropertyAppraisalFieldsList() {
                let tokenResponse = await auth.acquireTokenResponse();

                return apiService.GetLoanFieldList(this.loanId, this.propertyAndAppraisalFieldsList, tokenResponse.accessToken)
                    .then(res => {
                        this.formatPropertyAndAppraisalFields(res.data.data);
                    }).catch(error => {
                        this.errorTitle = 'Failed to Fetch Property and Appraisal Loan Fields';
                        
                        if(error.response?.data?.data) {
                            this.errorMsg = "Error: \n\n" + error.response.data.data;
                        } else {
                            this.errorMsg = '';
                        }

                        this.onRequestError(this.errorTitle, this.errorMsg);
                    });
            },
            async getSecondaryExecutionFieldsList() {
                let tokenResponse = await auth.acquireTokenResponse();

                return apiService.GetLoanFieldList(this.loanId, this.secondaryExecutionFieldsList, tokenResponse.accessToken)
                    .then(res => {
                        this.formatSecondaryExecutionFields(res.data.data);
                    }).catch(error => {
                        this.errorTitle = 'Failed to Fetch Secondary Execution Loan Fields';
                        
                        if(error.response?.data?.data) {
                            this.errorMsg = "Error: \n\n" + error.response.data.data;
                        } else {
                            this.errorMsg = '';
                        }

                        this.onRequestError(this.errorTitle, this.errorMsg);
                    });
            },
            onCloseNotification(flag) {
                if (flag === 'progressNotificationTab') {
                    this.progressCount -= 1;
                    
                    if (this.progressCount === 0) {
                        this[flag] = false;
                    }
                } else {
                    this[flag] = false;
                }
            },
            onRefiEligibilityChanged(evt) {
                this.fhaRefiFields.find(field => field.id === '3631').value = evt.value;
            },
            onFhaLoanPurposeChanged(evt) {
                this.fhaSummaryFields.find(field => field.id === '28').value = evt.value;
            },
            onFhaPropertyTypeChanged(evt) {
                this.fhaSummaryFields.find(field => field.id === '2996').value = evt.value;
            },
            onFhaSigningDocSelected(evt) {
                this.isFhaDocLoading = true;
                this.selectedFHASigningDoc.url = this.fhaSigningDocs.find(doc => doc.docName === this.selectedFHASigningDoc.docName && doc.applicationNumber === this.selectedFHASigningDoc.applicationNumber)?.url;
                this.isFhaDocLoading = false;         
            },
            onFhaTabSelected(evt) {
                this.selectedFhaTab = evt.selected;
            },
            onFilterAttachments(evt) {
                this.allAttachmentSearchWord = evt.value;

                this.processAttachmentsFilterSort();
            },
            onModifiedApprovedChanged(evt) {
                this.fhaSummaryFields.find(field => field.id === '3175').value = evt.value;
            },
            onProcessorFilterChange(evt) {
                this.filteredProcessors = filterBy(this.processors, evt.filter);
            },
            onProcessorSelected(evt) {
                this.selectedProcessor = evt.value;
                this.$emit('cleartofinish', true);
            },
            onRequestError(errorTitle, errorMsg) {
                this.isLoading = false;

                this.errorTitle = errorTitle;

                if (errorMsg) {
                    this.errorMsg = errorMsg;
                } else {
                    this.errorMsg = 'Please try again';
                }

                this.toggleErrorDialog();
            },
            onRiskTypeChanged(evt) {
                this.fhaRefiFields.find(field => field.id === '3029').value = evt.value;
            },
            onVaTabSelected(evt) {
              this.selectedVaTab = evt.selected;
            },
            async onUpdateLoanField(evt, prop) {
                let fieldSet = this[prop].find(set => set.fields.some(field => field.fieldId === evt.target.name));
                let updatedField = fieldSet.fields.find(field => field.fieldId === evt.target.name);
                if (updatedField.type === 'doc') {
                    if (updatedField.value && updatedField.value.getFullYear() < 2000) return;
                }

                if (fieldSet) {
                    await this.updateLoanFields(fieldSet.fields, true);

                    if (this.refreshedFields.length > 0) {
                        switch (prop) {
                            case 'docDateFields':
                                this.formatDocDateFields(this.refreshedFields);
                                break;
                            case 'docExpFields':
                                this.formatDocExpFields(this.refreshedFields);
                                break;
                            case 'docPurchaseFields':
                                this.formatDocPurchaseFields(this.refreshedFields);
                        }
                    }
                }
            },
            processApplicationGiftGrants() {
                this.applicationGiftGrants.forEach(gg => {
                    gg.deposited = gg.depositedIndicator ? 'Yes' : 'No';
                    gg.assetType = this.formatPascalValue(gg.assetType);
                    gg.source = this.formatPascalValue(gg.source);
                });

                this.applicationGiftGrantsTotal = this.applicationGiftGrants.reduce((prev, cur) => {
                    if (!cur.depositedIndicator) {
                        return prev + cur.amount;
                    }

                    return prev;
                }, 0);
            },
            processApplicationOtherAssets() {
                this.applicationOtherAssets.forEach(asset => {
                    asset.assetType = this.formatPascalValue(asset.assetType);
                });

                this.applicationOtherAssetsTotal = this.applicationOtherAssets.reduce((prev, cur) => {
                    if (cur.assetType !== 'Earnest Money') {
                        return prev + cur.cashOrMarketValue;
                    } 

                    return prev;
                }, 0);
            },
            processApplicationVODs() {
                this.applicationVODItems = [];
                this.applicationVODTotal = 0;

                this.applicationVODs.forEach(vod => {
                    let VODItems = vod.items.map(item => {
                        return {
                            bank: vod.holderName,
                            owner: vod.owner,
                            type: this.formatPascalValue(item.type),
                            cashOrMarketValueAmount: item.cashOrMarketValueAmount + item.urla2020CashOrMarketValueAmount,
                            itemNumber: item.itemNumber,
                            accountIdentifier: item.accountIdentifier
                        }
                    })
                    this.applicationVODItems.push([...VODItems]);

                    this.applicationVODTotal += vod.total;
                });

                this.applicationVODItems = this.applicationVODItems.flat().filter(item => item.cashOrMarketValueAmount > 0 || item.urla2020CashOrMarketValueAmount > 0);
            },
            processAttachmentsFilterSort() {
                if (this.allAttachmentSearchWord) {
                    this.attachments = this.allAttachments.filter(item => {
                        return Object.values(item).some(val => val && val.toString().toLowerCase().includes(this.allAttachmentSearchWord.toLowerCase()));
                    });               
                } else {
                    this.attachments = this.allAttachments.map(att => ({...att}));
                }

                if (this.allAttachmentSort.length > 0) {
                    this.allAttachmentSortChangeHandler({ sort: this.allAttachmentSort });
                }

                if (this.allAttachmentFilter) {
                    this.attachments = filterBy(this.attachments, this.allAttachmentFilter);
                }

                if (!this.showAllAttachments) {
                    this.attachments = this.attachments.filter(att => att.assignedTo.entityName === 'Unassigned');
                }
            },
            async RemoveAttachments(id) {
                let tokenResponse = await auth.acquireTokenResponse();
                this.idTokenClaims = tokenResponse.idTokenClaims;

                let removedAttachment = {
                    entityId: id,
                    entityType: 'Attachment'
                }
            
                apiService.MoveAttachmentToJunkFolder(this.loanId, this.junkFolderId, removedAttachment, tokenResponse.accessToken)
                    .then(res => {
                        this.$emit('documentupdated', removedAttachment.entityId);
                    }).catch(error => {
                        this.errorTitle = 'Failed to Remove Attachment';

                        if (error?.response?.data?.data) {
                            this.errorMsg = "Error: \n\n" + error.response.data.data;
                        } else {
                            this.errorMsg = '';
                        }

                        this.onRequestError(this.errorTitle, this.errorMsg);
                    });
            },
            saveFHABase64(base64, docName, applicationNumber, applicationId) {
                let signingDoc = this.fhaSigningDocsBase64.find(doc => doc.documentName === docName && doc.applicationNumber === applicationNumber);

                if (signingDoc) {
                    signingDoc.file = base64;
                    signingDoc.documentId = this.allDocuments.find(doc => doc.title.trim() === signingDoc.documentName && doc.application?.entityId === applicationId)?.id;
                    signingDoc.loanId = this.loanId;
                    signingDoc.applicationId = this.applications.find(id => id.applicationId === applicationId)?.borrowerPairId ?? "All";
                }
            },
            setCheckboxValue(evt, fieldId, stepFields) {
                this[stepFields].find(field => field.id === fieldId).value = evt.value ? 'Y' : 'N';

                if (fieldId === 'CX.UW.MGRAPPREVIEW') {
                    if (this[stepFields].find(field => field.id === fieldId).value === 'Y') {
                        this[stepFields].find(field => field.id === 'CX.AUDIT.APPRAISALREVIEW').value = new Date();
                    } else {
                        this[stepFields].find(field => field.id === 'CX.AUDIT.APPRAISALREVIEW').value = null;
                    }
                }
            },
            showNotification(notificationMsg, progress = false) {
                if (progress) {
                    this.progressNotificationTabMsg = notificationMsg;

                    this.progressCount += 1;
                    this.progressNotificationTab = true;
                } else {
                    this.notificationMsg = notificationMsg;

                    this.successNotification = true;

                    setTimeout(() => {
                        this.successNotification = false;
                    }, 4000);
                }
            },
            startProgressBar() {
                this.progressInterval = setInterval(() => {
                    if (this.progressValue < 50) {
                        this.progressValue += 1;
                    }
                }, 500);
            },
            stopProgressBar() {
                clearInterval(this.progressInterval);
                this.progressInterval = null;
                this.progressValue = 0;
            },
            toggleErrorDialog() {
                this.showErrorDialog = !this.showErrorDialog;

                if (!this.showErrorDialog) {
                    this.errorMsg = '';
                    this.errorTitle = '';
                }
            },
            toggleEscrowHoldback() {
                this.showEscrowHoldback = !this.showEscrowHoldback;
            },
            toggleLiabilitiesDialog() {
                this.showLiabilitiesDialog = !this.showLiabilitiesDialog;
            },
            updateEscrowHoldbackFields(fields) {
                this.toggleEscrowHoldback();

                fields.forEach(field => {
                    let match = this.propertyAndAppraisalFields.find(f => f.id === field.id);

                    if (match) {
                        match.value = field.value;
                    }
                });
            },
            async updateLoanFields(fields, hideLoader = false) {
                if (!hideLoader) {
                    this.isLoading = true;
                } else {
                    this.showNotification('Updating Fields...', true);
                }

                this.refreshedFields = [];

                let updateFields = fields.filter(field => field.type != 'exp').map(field => {
                    let value;

                    if (field.type != 'na') {
                        value = field.value ? field.value.toISOString() : '';
                    } else {
                        value = field.value.toString();
                    }

                    return {
                        id: field.fieldId,
                        value: value
                    }
                });

                let request = {
                    updateFields: updateFields,
                    fields: fields.map(field => field.fieldId)
                };

                let tokenResponse = await auth.acquireTokenResponse();

                return apiService.RefreshLoanFieldValues(this.loanId, request, tokenResponse.accessToken)
                    .then(res => {
                        this.isLoading = false;
                        this.refreshedFields = res.data.data;

                        if(hideLoader) {
                            this.onCloseNotification('progressNotificationTab');
                        }
                        this.showNotification('Fields successfully updated');
                    }).catch(error => {
                        this.errorTitle = 'Failed to Update Fields';

                        if(error?.response?.data?.data) {
                        this.errorMsg = "Error: \n\n" + error.response.data.data;
                        } else {
                            this.errorMsg = '';
                        }

                        this.onRequestError(this.errorTitle, this.errorMsg);
                    });
            },
            vaAttachmentSortChangeHandler(evt) {
              this.vaAttachmentSort = evt.sort;
              this.vaAttachments = orderBy(this.vaAttachments, this.vaAttachmentSort);
            },
        },
        filters: {
            formatCurrency(val) {
                if (val === null || val === undefined || val === '') return '';

                if (val.toString().includes('$')) return val;

                if (isNaN(val)) {
                    val = 0;
                }

                let formatter = new Intl.NumberFormat('en-US', {
                    style: 'currency',
                    currency: 'USD',
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0
                });

                return formatter.format(val);
            },
            formatCurrencyDec(val) {
                if (val === null || val === undefined || val === '') return '';

                if (val.toString().includes('$')) return val;

                if (isNaN(val)) {
                    val = 0;
                }

                let formatter = new Intl.NumberFormat('en-US', {
                    style: 'currency',
                    currency: 'USD',
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                });

                return formatter.format(val);
            },
            phoneFilter(val) {
                if (!val) return '';

                let formattedPhone = val.split(' ').join('').split('-').join('').split('(').join('').split(')').join('');

                if (formattedPhone.length !== 10 && formattedPhone.length !== 11) return '';

                if (formattedPhone.length === 10) {
                    return `(${formattedPhone.substring(0, 3)}) ${formattedPhone.substring(3, 6)}-${formattedPhone.substring(6)}`;
                } else {
                    return `${formattedPhone.substring(0, 1)} (${formattedPhone.substring(1, 4)}) ${formattedPhone.substring(4, 7)}-${formattedPhone.substring(7)}`;
                }
            }
        },
        components: {
            'k-dialog': Dialog,
            'k-dialog-actions': DialogActionsBar,
            'loan-notes-component': loanNotesComponent,
            'loader': Loader,
            'k-button': Button,
            'k-dropdown': DropDownList,
            'k-input': Input,
            'k-fade': Fade,
            'k-datepicker': DatePicker,
            'k-textarea': TextArea,
            'k-checkbox': Checkbox,
            'k-grid': Grid,
            'k-progressbar': ProgressBar,
            'k-numeric-input': NumericTextBox,
            'k-notification': Notification,
            'k-notification-group': NotificationGroup,
            'toolbar': GridToolbar,
            'k-switch': Switch,
            'escrow-holdback-dialog': escrowHoldbackDialog,
            'k-panelbar': PanelBar,
            'k-tabstrip': TabStrip,
            'k-radio': RadioButton,
            'k-maskedtextbox': MaskedTextBox,
            WebViewer,
            'wizard-liabilities-dialog': wizardLiabilitiesDialog
        }
    }
</script>

<style>
    @import '/src/assets/css/editConditionDialog.css';
    @import '/src/assets/css/editDocumentDialog.css';
    @import '/src/assets/css/conditionallyApproveWizard.css';
    @import '/src/assets/css/clearToCloseWizard.css';
</style>
